import { r as e } from "./rolldown-runtime-B1bRi_D7.js";
import { t } from "./svg-CjnSTT0L.js";
import n from "classnames";
import { Fragment as r, jsx as i, jsxs as a } from "react/jsx-runtime";
import { PureComponent as o, createContext as s, createRef as c, forwardRef as l, memo as u, useCallback as d, useEffect as f, useImperativeHandle as p, useMemo as m, useRef as h, useState as g } from "react";
import _ from "lodash/find";
import v from "lodash/sortBy";
//#region src/components/icon/generated/iconmeta.json
var y = /* @__PURE__ */ e({
	default: () => x,
	names: () => b
}), b = {
	ai: [
		"ai",
		"brain",
		"grammar-spelling",
		"translate-auto",
		"translate-preferred",
		"translate"
	],
	"analytics & insights": [
		"activity",
		"bars-filter",
		"chart-area",
		"chart-bar-stacked",
		"chart-bar",
		"chart-donut",
		"chart-line",
		"chart-pie",
		"circle-dashed",
		"dashboard",
		"experiment",
		"filter-a-z",
		"filter-z-a",
		"hourglass-clock",
		"hourglass-end",
		"hourglass-full",
		"hourglass-half",
		"hourglass-start",
		"magnifying-glass-chart",
		"presentation",
		"trend-down",
		"trend-up"
	],
	arrows: /* @__PURE__ */ "angle-double-left.angle-double-right.angle-down.angle-left.angle-right.angle-square-down.angle-square-left.angle-square-right.angle-square-up.angle-up.arrow-down.arrow-expand.arrow-left.arrow-right.arrow-square-down.arrow-square-left.arrow-square-right.arrow-square-up.arrow-up.arrows-h.arrows-v.compress.exchange.expand.redo.reduce.sign-in.sign-out.sort-down.sort-up.square-arrow-down-left.square-arrow-up-right.sync.undo".split("."),
	audio: [
		"announcement-slash",
		"announcement",
		"headset",
		"pause",
		"play",
		"record",
		"stop",
		"volume-down",
		"volume-mute",
		"volume-off",
		"volume-up"
	],
	"calendar & time": [
		"calendar-plus",
		"calendar-times",
		"calendar",
		"clock-one",
		"clock-three",
		"clock",
		"history",
		"moon",
		"sun"
	],
	channel: [
		"callback",
		"chat-bot",
		"chat-widget",
		"chat",
		"dixa-messenger",
		"facebook-messenger",
		"generic-api",
		"instagram",
		"mail",
		"messaging-settings",
		"messenger",
		"mim-advisor",
		"mim-sidekick",
		"mim",
		"phone",
		"simultaneous",
		"sms",
		"trustpilot",
		"twitter",
		"voicemail",
		"whatsapp",
		"working"
	],
	conversation: [
		"at",
		"chat-plus",
		"chat-slash",
		"chat-x",
		"conversations",
		"forward-all",
		"forward",
		"phone-hang",
		"phone-incoming",
		"phone-outgoing",
		"phone-plus",
		"rec",
		"reply-all",
		"reply",
		"social",
		"subtitle",
		"tag",
		"tags",
		"transcript",
		"video",
		"widget-customize"
	],
	editor: /* @__PURE__ */ "align-center.align-justify.align-left.align-right.anchor.bold.callout.code-block.copy.cut.divider.download.enter.format.heading-1.heading-2.heading-3.heading.image-inline.image.italic.link-slash.link.list-ol-letters.list-ol-numbers.list-ol-roman.list-ol.list-ul-circle.list-ul-disc.list-ul-square.list-ul.paper-plane.paperclip.paste.print.quote.sticky-note.strikethrough.table-header-column.table-header-row.table.text.th.underline.upload".split("."),
	"file & folder": [
		"file-archive",
		"file-audio",
		"file-csv",
		"file-draft",
		"file-excel",
		"file-image",
		"file-lock",
		"file-pdf",
		"file-powerpoint",
		"file-text-search",
		"file-text",
		"file-video",
		"file-word",
		"file",
		"folder-open-slash",
		"folder-open",
		"folder-slash",
		"folder"
	],
	generic: /* @__PURE__ */ "american-football.bars.bell-slash.bell.bolt.bookmark.camera.check-circle-filled.check-circle.circle-filled.circle.close-circle-filled.close.dixa.docked.done.double-check-circle-filled.double-check-circle.exclamation-circle-filled.exclamation-triangle-filled.exclamation.external-link.flag.floating.gift.hamburger.hashtag.heart.home.info-filled.info.keyboard.knowledge.map-pin.minus.percent.plane.plus-circle-filled.plus.question-filled.question.screen-full.screen-split-2-horizontal.screen-split-2-pull-bottom.screen-split-2-pull-left.screen-split-2-pull-right.screen-split-2-pull-top.screen-split-2-vertical.screen-split-3-left.screen-split-3-right.screen-split-4.search-minus.search-plus.search.shield-alert.square-plus.thumbtack-full.thumbtack-slash.thumbtack.wrench".split("."),
	integrations: /* @__PURE__ */ "ada.agillic.assembled.braze.busylight.digitalgenius.elevio.github.ingrid.jira.kindly.klaviyo.linear.loyaltylion.magento.miuros.podio.recharge.rivoloyalty.salesforce.shopify.solvemate.trustpilot-outlined.trustpilot-star.voyado.web-form.webhooks.woocommerce.yotpo".split("."),
	presence: [
		"away-toggle",
		"circle-empty",
		"circle-simultaneous",
		"circle-z",
		"media-chat",
		"media-email",
		"media-messaging",
		"media-voice",
		"phone-filled"
	],
	satisfaction: [
		"smile",
		"star-full",
		"star-half-full",
		"star",
		"thumbs-down",
		"thumbs-up"
	],
	"settings & workflows": /* @__PURE__ */ "archive.arrow-u-turn-up-left.autocomplete.branch.building.cart-shopping.channels.cloud-check.cloud-download.cloud-slash.cloud-syncing.cloud-upload.cloud.code.cog.combine.credit-card.dots-h.dots-v.drag-h.drag.dropdown-list.eye-closed.eye-slash.eye.filter.flow.hide-strategy.input.key.lightbulb.lock.merge.pen-slash.pen.plug.preferences.route.trash.truck.url-trigger.wallet.world-slash.world".split("."),
	user: [
		"address-book",
		"ban",
		"id-card",
		"role-custom",
		"role-system",
		"team",
		"user-agent",
		"user-minus",
		"user-plus",
		"user-secret",
		"user-slash",
		"user-status",
		"user",
		"users"
	]
}, x = { names: b }, S = {
	purple: {
		100: "var(--dixa-color-purple-100)",
		200: "var(--dixa-color-purple-200)",
		300: "var(--dixa-color-purple-300)",
		400: "var(--dixa-color-purple-400)",
		500: "var(--dixa-color-purple-500)",
		600: "var(--dixa-color-purple-600)",
		700: "var(--dixa-color-purple-700)",
		800: "var(--dixa-color-purple-800)",
		900: "var(--dixa-color-purple-900)",
		values: {
			100: {
				light: "#f0f0ff",
				dark: "#242033"
			},
			200: {
				light: "#ddd8fd",
				dark: "#484166"
			},
			300: {
				light: "#c1b9f8",
				dark: "#6c6199"
			},
			400: {
				light: "#8f82ed",
				dark: "#9082cc"
			},
			500: {
				light: "#5644d8",
				dark: "#b4a2ff"
			},
			600: {
				light: "#392aa7",
				dark: "#c3b5ff"
			},
			700: {
				light: "#281c82",
				dark: "#d2c7ff"
			},
			800: {
				light: "#140561",
				dark: "#e1daff"
			},
			900: {
				light: "#0c0146",
				dark: "#f0ecff"
			}
		}
	},
	green: {
		100: "var(--dixa-color-green-100)",
		200: "var(--dixa-color-green-200)",
		300: "var(--dixa-color-green-300)",
		400: "var(--dixa-color-green-400)",
		500: "var(--dixa-color-green-500)",
		600: "var(--dixa-color-green-600)",
		700: "var(--dixa-color-green-700)",
		800: "var(--dixa-color-green-800)",
		900: "var(--dixa-color-green-900)",
		values: {
			100: {
				light: "#dffbe9",
				dark: "#03271f"
			},
			200: {
				light: "#c6f5d6",
				dark: "#064d3f"
			},
			300: {
				light: "#9febb9",
				dark: "#08745e"
			},
			400: {
				light: "#6ad495",
				dark: "#0b9a7e"
			},
			500: {
				light: "#33b967",
				dark: "#0ec19d"
			},
			600: {
				light: "#23924e",
				dark: "#3ecdb1"
			},
			700: {
				light: "#196c39",
				dark: "#6edac4"
			},
			800: {
				light: "#195239",
				dark: "#9fe6d8"
			},
			900: {
				light: "#164832",
				dark: "#cff3eb"
			}
		}
	},
	blue: {
		100: "var(--dixa-color-blue-100)",
		200: "var(--dixa-color-blue-200)",
		300: "var(--dixa-color-blue-300)",
		400: "var(--dixa-color-blue-400)",
		500: "var(--dixa-color-blue-500)",
		600: "var(--dixa-color-blue-600)",
		700: "var(--dixa-color-blue-700)",
		800: "var(--dixa-color-blue-800)",
		900: "var(--dixa-color-blue-900)",
		values: {
			100: {
				light: "#e7f5fe",
				dark: "#081a32"
			},
			200: {
				light: "#a8d9fc",
				dark: "#0f3565"
			},
			300: {
				light: "#69bbf6",
				dark: "#174f97"
			},
			400: {
				light: "#36a1ec",
				dark: "#1e6aca"
			},
			500: {
				light: "#0078cc",
				dark: "#2684fc"
			},
			600: {
				light: "#0067ad",
				dark: "#519dfd"
			},
			700: {
				light: "#005893",
				dark: "#7db5fd"
			},
			800: {
				light: "#00487a",
				dark: "#a8cefe"
			},
			900: {
				light: "#003d66",
				dark: "#d4e6fe"
			}
		}
	},
	orange: {
		100: "var(--dixa-color-orange-100)",
		200: "var(--dixa-color-orange-200)",
		300: "var(--dixa-color-orange-300)",
		400: "var(--dixa-color-orange-400)",
		500: "var(--dixa-color-orange-500)",
		600: "var(--dixa-color-orange-600)",
		700: "var(--dixa-color-orange-700)",
		800: "var(--dixa-color-orange-800)",
		900: "var(--dixa-color-orange-900)",
		values: {
			100: {
				light: "#ffeedd",
				dark: "#321f05"
			},
			200: {
				light: "#ffdcaf",
				dark: "#643d0b"
			},
			300: {
				light: "#ffbd6e",
				dark: "#955c10"
			},
			400: {
				light: "#ff9e37",
				dark: "#c77a16"
			},
			500: {
				light: "#fc800d",
				dark: "#f9991b"
			},
			600: {
				light: "#e56500",
				dark: "#faad49"
			},
			700: {
				light: "#ca4f00",
				dark: "#fbc276"
			},
			800: {
				light: "#a93900",
				dark: "#fdd6a4"
			},
			900: {
				light: "#872600",
				dark: "#feebd1"
			}
		}
	},
	red: {
		100: "var(--dixa-color-red-100)",
		200: "var(--dixa-color-red-200)",
		300: "var(--dixa-color-red-300)",
		400: "var(--dixa-color-red-400)",
		500: "var(--dixa-color-red-500)",
		600: "var(--dixa-color-red-600)",
		700: "var(--dixa-color-red-700)",
		800: "var(--dixa-color-red-800)",
		900: "var(--dixa-color-red-900)",
		values: {
			100: {
				light: "#fff2f2",
				dark: "#310c0c"
			},
			200: {
				light: "#f5cccb",
				dark: "#631918"
			},
			300: {
				light: "#eaa8a6",
				dark: "#942525"
			},
			400: {
				light: "#db6a68",
				dark: "#c63231"
			},
			500: {
				light: "#c83c3c",
				dark: "#f73e3d"
			},
			600: {
				light: "#c11d1d",
				dark: "#f96564"
			},
			700: {
				light: "#b30908",
				dark: "#fa8b8b"
			},
			800: {
				light: "#9e0302",
				dark: "#fcb2b1"
			},
			900: {
				light: "#870000",
				dark: "#fdd8d8"
			}
		}
	},
	neutral: {
		100: "var(--dixa-color-neutral-100)",
		200: "var(--dixa-color-neutral-200)",
		300: "var(--dixa-color-neutral-300)",
		400: "var(--dixa-color-neutral-400)",
		500: "var(--dixa-color-neutral-500)",
		600: "var(--dixa-color-neutral-600)",
		700: "var(--dixa-color-neutral-700)",
		800: "var(--dixa-color-neutral-800)",
		900: "var(--dixa-color-neutral-900)",
		values: {
			100: {
				light: "#f5f7fa",
				dark: "#23242c"
			},
			200: {
				light: "#e7ecf3",
				dark: "#2e3039"
			},
			300: {
				light: "#d7dfea",
				dark: "#464650"
			},
			400: {
				light: "#b5c1d4",
				dark: "#62626a"
			},
			500: {
				light: "#8193b0",
				dark: "#7e7e85"
			},
			600: {
				light: "#617598",
				dark: "#99999f"
			},
			700: {
				light: "#45587c",
				dark: "#b5b5b9"
			},
			800: {
				light: "#263758",
				dark: "#d1d1d3"
			},
			900: {
				light: "#132243",
				dark: "#ededee"
			},
			"000": {
				light: "#ffffff",
				dark: "#1a1b23"
			}
		},
		"000": "var(--dixa-color-neutral-000)"
	}
}, C = {
	"box-shadow": {
		100: "var(--dixa-effect-box-shadow-100)",
		200: "var(--dixa-effect-box-shadow-200)",
		300: "var(--dixa-effect-box-shadow-300)",
		400: "var(--dixa-effect-box-shadow-400)",
		values: {
			100: {
				light: "0px 2px 4px #6176981a, 0px 1px 2px #6176980a",
				dark: "0px 2px 4px #0a0a0e4d, 0px 1px 2px #0a0a0e36"
			},
			200: {
				light: "0px 4px 8px #6176981a, 0px 2px 4px #6176980a",
				dark: "0px 4px 8px #0a0a0e4d, 0px 2px 4px #0a0a0e36"
			},
			300: {
				light: "0px 8px 16px #6176981a, 0px 4px 8px #6176980a",
				dark: "0px 8px 16px #0a0a0e4d, 0px 4px 8px #0a0a0e36"
			},
			400: {
				light: "0px 12px 24px #6176981a, 0px 8px 16px #6176980a",
				dark: "0px 12px 24px #0a0a0e4d, 0px 8px 16px #0a0a0e36"
			}
		}
	},
	opacity: {
		200: "var(--dixa-effect-opacity-200)",
		500: "var(--dixa-effect-opacity-500)",
		values: {
			200: .2,
			500: .5
		}
	}
}, w = {
	spacer: {
		100: "var(--dixa-size-spacer-100)",
		200: "var(--dixa-size-spacer-200)",
		250: "var(--dixa-size-spacer-250)",
		300: "var(--dixa-size-spacer-300)",
		400: "var(--dixa-size-spacer-400)",
		500: "var(--dixa-size-spacer-500)",
		values: {
			100: "4px",
			200: "8px",
			250: "12px",
			300: "16px",
			400: "24px",
			500: "32px"
		}
	},
	"border-radius": {
		50: "var(--dixa-size-border-radius-50)",
		100: "var(--dixa-size-border-radius-100)",
		200: "var(--dixa-size-border-radius-200)",
		values: {
			50: "2px",
			100: "4px",
			200: "8px"
		}
	},
	border: {
		100: "var(--dixa-size-border-100)",
		200: "var(--dixa-size-border-200)",
		values: {
			100: "1px",
			200: "2px"
		}
	}
}, T = {
	color: {
		values: {
			primary: {
				light: "#132244",
				dark: "#e4e6ec"
			},
			secondary: {
				light: "#46597c",
				dark: "#aeafbb"
			},
			tertiary: {
				light: "#8294b0",
				dark: "#7f818e"
			},
			success: {
				light: "#23924e",
				dark: "#3ecdb1"
			},
			error: {
				light: "#c11d1d",
				dark: "#f96564"
			},
			warning: {
				light: "#e56500",
				dark: "#faad49"
			},
			link: {
				light: "#0078cc",
				dark: "#519dfd"
			}
		},
		primary: "var(--dixa-typography-color-primary)",
		secondary: "var(--dixa-typography-color-secondary)",
		tertiary: "var(--dixa-typography-color-tertiary)",
		success: "var(--dixa-typography-color-success)",
		error: "var(--dixa-typography-color-error)",
		warning: "var(--dixa-typography-color-warning)",
		link: "var(--dixa-typography-color-link)"
	},
	family: {
		values: {
			default: "IBM Plex Sans, Helvetica, Arial, sans-serif",
			code: "IBM Plex Mono, Menlo, Monaco, Consolas, Courier New, monospace"
		},
		default: "var(--dixa-typography-family-default)",
		code: "var(--dixa-typography-family-code)"
	},
	"letter-spacing": {
		100: "var(--dixa-typography-letter-spacing-100)",
		200: "var(--dixa-typography-letter-spacing-200)",
		300: "var(--dixa-typography-letter-spacing-300)",
		400: "var(--dixa-typography-letter-spacing-400)",
		500: "var(--dixa-typography-letter-spacing-500)",
		600: "var(--dixa-typography-letter-spacing-600)",
		700: "var(--dixa-typography-letter-spacing-700)",
		800: "var(--dixa-typography-letter-spacing-800)",
		900: "var(--dixa-typography-letter-spacing-900)",
		values: {
			100: "0px",
			200: "0px",
			300: "0px",
			400: "0px",
			500: "0px",
			600: "0px",
			700: "0px",
			800: "0px",
			900: "0px"
		}
	},
	"line-height": {
		100: "var(--dixa-typography-line-height-100)",
		200: "var(--dixa-typography-line-height-200)",
		300: "var(--dixa-typography-line-height-300)",
		400: "var(--dixa-typography-line-height-400)",
		values: {
			100: "12px",
			200: "16px",
			300: "20px",
			400: "24px"
		}
	},
	size: {
		100: "var(--dixa-typography-size-100)",
		200: "var(--dixa-typography-size-200)",
		300: "var(--dixa-typography-size-300)",
		400: "var(--dixa-typography-size-400)",
		500: "var(--dixa-typography-size-500)",
		600: "var(--dixa-typography-size-600)",
		values: {
			100: "10px",
			200: "12px",
			300: "14px",
			400: "16px",
			500: "18px",
			600: "24px"
		}
	},
	weight: {
		values: {
			semibold: 600,
			normal: 400
		},
		semibold: "var(--dixa-typography-weight-semibold)",
		normal: "var(--dixa-typography-weight-normal)"
	}
}, E = (e, t) => {
	let n = e.split(".").reverse(), r = t;
	for (; n.length;) {
		let e = n.pop();
		if (!e) return null;
		if (r[e] === void 0) return e === "0" ? e : (console.warn(`Token does not exist. (${e})`), null);
		r = r[e];
	}
	return r && typeof r != "object" ? r : null;
}, D = (e, t) => e.split(" ").map((e) => E(e, t)).filter((e) => e !== null).join(" "), ee = [
	"currentColor",
	"transparent",
	"inherit",
	"initial"
], O = {
	primary: "var(--dixa-typography-color-primary)",
	secondary: "var(--dixa-typography-color-secondary)",
	tertiary: "var(--dixa-typography-color-tertiary)",
	white: "var(--dixa-color-neutral-000)",
	success: "var(--dixa-typography-color-success)",
	error: "var(--dixa-typography-color-error)",
	warning: "var(--dixa-typography-color-warning)",
	link: "var(--dixa-typography-color-link)"
}, k = (e) => {
	if (e === void 0 || e.startsWith("#") || e.startsWith("rgb") || e.startsWith("var") || ee.includes(e)) return e;
	if (e in O) return O[e];
	let t = D(e, S);
	if (t) return t;
}, te = (e) => {
	let t = Object.keys(C["box-shadow"]);
	return t.includes(e) ? D(e, C["box-shadow"]) : t.map((e) => `box-shadow.${e}`).includes(e) ? D(e, C) : e;
}, A = (e) => e.indexOf("px") > -1 || e.indexOf("%") > -1 || e.indexOf("vh") > -1 || e.indexOf("vw") > -1 || e.startsWith("var"), j = (e = "200") => A(e) ? e : D(e, w.spacer) || "", ne = (e = "100") => A(e) ? e : D(e, w["border-radius"]) || "", M = (e = "100") => A(e) ? e : D(e, w.border) || "", re = (e = "100") => A(e) ? e : D(e, T.size) || "", ie = { root: "h-icon--icon__root" };
//#endregion
//#region src/components/icon/icon.tsx
t(document);
function N({ className: e, name: t, size: r = 16, color: a, style: o, ...s }) {
	let c = n(ie.root, e), l = { ...o }, u = {
		height: r,
		width: r
	};
	return a && (l.color = k(a)), /* @__PURE__ */ i("svg", {
		...s,
		className: c,
		style: l,
		...u,
		children: /* @__PURE__ */ i("use", { href: `#icon-${t}` })
	});
}
//#endregion
//#region src/components/box/box.types.ts
var ae = "div", oe = [
	"display",
	"align",
	"wrap",
	"clamp",
	"background",
	"color",
	"fontSize",
	"boxShadow",
	"padding",
	"margin",
	"width",
	"minWidth",
	"maxWidth",
	"height",
	"minHeight",
	"maxHeight",
	"borderRadius",
	"borderColor",
	"borderWidth",
	"flex",
	"justifySelf",
	"alignSelf",
	"style",
	"boxSizing"
];
function se(e) {
	let t = { ...e };
	return oe.forEach((e) => {
		delete t[e];
	}), t;
}
function ce(e) {
	let { display: t, align: n, wrap: r, clamp: i, background: a, color: o, fontSize: s, boxShadow: c, padding: l, margin: u, width: d, minWidth: f, maxWidth: p, height: m, minHeight: h, maxHeight: g, borderRadius: _, borderColor: v, borderWidth: y, flex: b, justifySelf: x, alignSelf: S, style: C, boxSizing: w } = e, T = {};
	return [
		{
			value: t,
			name: "display"
		},
		{
			value: s,
			name: "fontSize"
		},
		{
			value: d,
			name: "width"
		},
		{
			value: m,
			name: "height"
		},
		{
			value: f,
			name: "minWidth"
		},
		{
			value: p,
			name: "maxWidth"
		},
		{
			value: h,
			name: "minHeight"
		},
		{
			value: g,
			name: "maxHeight"
		},
		{
			value: b,
			name: "flex"
		},
		{
			value: x,
			name: "justifySelf"
		},
		{
			value: S,
			name: "alignSelf"
		},
		{
			value: n,
			name: "textAlign"
		},
		{
			value: r,
			name: "whiteSpace"
		},
		{
			value: w,
			name: "boxSizing"
		}
	].forEach((e) => {
		e.value && (T[e.name] = e.value);
	}), c && (T.boxShadow = te(c)), a && (T.backgroundColor = k(a)), o && (T.color = k(o)), l && (T.padding = j(l)), u && (T.margin = j(u)), l && (T.padding = j(l)), _ && (T.borderRadius = ne(typeof _ == "boolean" ? "100" : _)), v && (T.borderColor = k(v), T.borderWidth = M(), T.borderStyle = "solid"), y && (T.borderWidth = M(y)), s && (T.fontSize = re(s)), i && (T.display = "-webkit-box", T.overflow = "hidden", T.WebkitBoxOrient = "vertical", T.WebkitLineClamp = i), T = {
		...T,
		...C
	}, T;
}
//#endregion
//#region src/components/box/box.tsx
var P = l(function(e, t) {
	let { as: n, children: r, ...a } = se(e), o = n ?? "div", s = ce(e);
	return /* @__PURE__ */ i(o, {
		...a,
		ref: t,
		style: s,
		children: r
	});
}), F = { text: "h-text--sharedStyles__text" }, I = {
	"heading-1": "h-text-heading--heading__heading-1",
	"heading-2": "h-text-heading--heading__heading-2",
	"heading-3": "h-text-heading--heading__heading-3",
	"heading-4": "h-text-heading--heading__heading-4",
	withMarginBottom: "h-text-heading--heading__withMarginBottom"
}, le = {
	"heading-1": I["heading-1"],
	"heading-2": I["heading-2"],
	"heading-3": I["heading-3"],
	"heading-4": I["heading-4"]
}, ue = class e extends o {
	static defaultProps = {
		variant: "heading-2",
		withMarginBottom: !1,
		as: "h2"
	};
	render() {
		let { children: t, variant: r = e.defaultProps.variant, className: a, withMarginBottom: o = e.defaultProps.withMarginBottom, ...s } = this.props, c = n(F.text, le[r], { [I.withMarginBottom]: o }, a);
		return /* @__PURE__ */ i(P, {
			...s,
			className: c,
			children: t
		});
	}
}, L = {
	error: "h-text-input--input__error",
	warning: "h-text-input--input__warning",
	success: "h-text-input--input__success",
	title: "h-text-input--input__title"
}, de = {
	title: L.title,
	success: L.success,
	warning: L.warning,
	error: L.error
}, fe = class extends o {
	static defaultProps = {
		variant: "title",
		as: "div"
	};
	render() {
		let { children: e, variant: t, className: r, ...a } = this.props, o = n(F.text, de[t], r);
		return /* @__PURE__ */ i(P, {
			...a,
			role: "alert",
			className: o,
			children: e
		});
	}
}, pe = { linkText: "h-text-link--externalLink__linkText" }, me = class extends o {
	static defaultProps = { as: "a" };
	render() {
		let { children: e, className: t, ...r } = this.props, a = n(pe.linkText, F.text, t);
		return /* @__PURE__ */ i(P, {
			...r,
			className: a,
			children: e
		});
	}
}, R = {
	"variant-1": "h-text-paragraph--paragraph__variant-1",
	"variant-1-subdued": "h-text-paragraph--paragraph__variant-1-subdued",
	"variant-2": "h-text-paragraph--paragraph__variant-2",
	"variant-2-subdued": "h-text-paragraph--paragraph__variant-2-subdued",
	"variant-3": "h-text-paragraph--paragraph__variant-3",
	"variant-3-subdued": "h-text-paragraph--paragraph__variant-3-subdued",
	"variant-4": "h-text-paragraph--paragraph__variant-4",
	"variant-4-subdued": "h-text-paragraph--paragraph__variant-4-subdued",
	"variant-5": "h-text-paragraph--paragraph__variant-5",
	withMarginBottom: "h-text-paragraph--paragraph__withMarginBottom"
}, he = {
	1: R["variant-1"],
	2: R["variant-2"],
	3: R["variant-3"],
	4: R["variant-4"],
	5: R["variant-5"]
}, ge = {
	1: R["variant-1-subdued"],
	2: R["variant-2-subdued"],
	3: R["variant-3-subdued"],
	4: R["variant-4-subdued"],
	5: ""
};
function _e(e, t, r, i) {
	let a = he[e], o = ge[e];
	return n([
		F.text,
		a,
		i,
		{
			[o]: t,
			[R.withMarginBottom]: r
		}
	]);
}
function ve({ as: e = "p", variant: t = "2", subdued: n = !1, withMarginBottom: r = !1, className: a, children: o, ...s }) {
	return /* @__PURE__ */ i(P, {
		as: e,
		...s,
		className: _e(t, n, r, a),
		children: o
	});
}
//#endregion
//#region src/components/text/text.tsx
var z = class extends o {
	static Heading = ue;
	static Paragraph = ve;
	static ExternalLink = me;
	static Input = fe;
	render() {
		return console.error("Using <Text> component directly is not allowed, use one of the sub-components instead: <Text.Paragraph>"), null;
	}
}, B = {
	root: "h-button--button__root",
	normal: "h-button--button__normal",
	large: "h-button--button__large",
	primary: "h-button--button__primary",
	active: "h-button--button__active",
	label: "h-button--button__label",
	secondary: "h-button--button__secondary",
	tertiary: "h-button--button__tertiary",
	danger: "h-button--button__danger",
	disabled: "h-button--button__disabled",
	loading: "h-button--button__loading",
	withLabel: "h-button--button__withLabel",
	slot: "h-button--button__slot",
	content: "h-button--button__content"
}, V = u(l(function({ children: e, className: t, type: o = "button", variant: s = "primary", size: c = "normal", icon: l, slotStart: u, slotEnd: d, active: f = !1, isLoading: p = !1, loadingIndicator: m = /* @__PURE__ */ i(z.Paragraph, {
	as: "span",
	variant: "3",
	wrap: "nowrap",
	color: "inherit",
	children: "Loading..."
}), label: h, styleText: g = !0, disabled: _ = !1, onClick: v, ...y }, b) {
	let x = n({
		[B.root]: !0,
		[B[s]]: !0,
		[B[c]]: !0,
		[B.active]: f,
		[B.disabled]: _,
		[B.loading]: p,
		[B.withLabel]: !d && !!h
	}, t);
	return /* @__PURE__ */ i("button", {
		...y,
		type: o,
		className: x,
		onClick: _ ? void 0 : v,
		disabled: _,
		ref: b,
		children: p ? m : /* @__PURE__ */ a(r, { children: [
			(u || l) && /* @__PURE__ */ i("span", {
				className: B.slot,
				children: l ? /* @__PURE__ */ i(N, { name: l }) : u
			}),
			(g || e) && /* @__PURE__ */ i("span", {
				className: B.content,
				children: g ? /* @__PURE__ */ i(z.Paragraph, {
					as: "span",
					variant: "3",
					wrap: "nowrap",
					color: "inherit",
					children: e
				}) : e
			}),
			h && /* @__PURE__ */ i(z.Paragraph, {
				as: "span",
				variant: "4",
				wrap: "nowrap",
				color: "inherit",
				className: B.label,
				children: h
			}),
			d && /* @__PURE__ */ i("span", {
				className: B.slot,
				children: d
			})
		] })
	});
})), ye = { root: "h-button-navigationButton--navigationButton__root" }, be = ({ className: e, navigate: t, onClick: r, ...a }) => {
	let o = (e) => {
		r?.(e), t();
	};
	return /* @__PURE__ */ i(V, {
		...a,
		variant: a.variant ?? "tertiary",
		onClick: o,
		className: n(e, ye.root)
	});
}, xe = {
	root: "h-spinner--spinner__root",
	spin: "h-spinner--spinner__spin"
}, H = class extends o {
	render() {
		let { className: e, size: t, color: r, trackColor: a, bgColor: o, ...s } = this.props, c = n({ [xe.root]: !0 }, e), l = typeof t == "number" ? t : 32, u = typeof t == "number" ? `${l}px` : "32px", d = {
			height: u,
			width: u,
			borderWidth: `${Math.max(Math.floor(l / 8), 1)}px`
		};
		return a && a.length && (d.borderColor = a), r && r.length && (d.borderTopColor = r), o && o.length && (d.backgroundColor = o), /* @__PURE__ */ i("div", {
			...s,
			style: d,
			className: c
		});
	}
}, Se = { root: "h-iconButton--iconButton__root" }, U = u(l(function({ children: e, className: t, icon: r, iconProps: a, iconSize: o, variant: s = "primary", ...c }, l) {
	return /* @__PURE__ */ i(V, {
		ref: l,
		"aria-label": r,
		...c,
		variant: s,
		className: n(Se.root, t),
		loadingIndicator: /* @__PURE__ */ i(H, { size: 16 }),
		styleText: !1,
		slotStart: /* @__PURE__ */ i(N, {
			size: o || 16,
			name: r,
			...a
		})
	});
})), W = {
	root: "h-inputWrapper--inputWrapper__root",
	rootDisabled: "h-inputWrapper--inputWrapper__rootDisabled",
	rootActive: "h-inputWrapper--inputWrapper__rootActive",
	rootHasError: "h-inputWrapper--inputWrapper__rootHasError",
	rootHasWarning: "h-inputWrapper--inputWrapper__rootHasWarning",
	rootHasSuccess: "h-inputWrapper--inputWrapper__rootHasSuccess",
	inputWrapper: "h-inputWrapper--inputWrapper__inputWrapper",
	rootWithPrefix: "h-inputWrapper--inputWrapper__rootWithPrefix",
	rootWithSuffix: "h-inputWrapper--inputWrapper__rootWithSuffix",
	suffixesContainer: "h-inputWrapper--inputWrapper__suffixesContainer",
	prefix: "h-inputWrapper--inputWrapper__prefix",
	suffix: "h-inputWrapper--inputWrapper__suffix",
	prefixDropdownButton: "h-inputWrapper--inputWrapper__prefixDropdownButton",
	suffixDropdownButton: "h-inputWrapper--inputWrapper__suffixDropdownButton",
	prefixButton: "h-inputWrapper--inputWrapper__prefixButton",
	suffixButton: "h-inputWrapper--inputWrapper__suffixButton",
	icon: "h-inputWrapper--inputWrapper__icon"
}, G = s({
	position: null,
	disabled: !1,
	active: !1,
	status: "success"
}), Ce = "inputWrapper", we = class extends o {
	renderIcon() {
		let { icon: e } = this.props;
		return e ? /* @__PURE__ */ i(N, {
			className: W.icon,
			name: e
		}) : null;
	}
	isButtonAddon(e) {
		return !!e && "type" in e && e.type === "button";
	}
	isCustomAddon(e) {
		return !!e && "type" in e && (!e.type || e.type === "custom");
	}
	renderAddon(e) {
		let t = this.props[e], { disabled: r } = this.props;
		if (!t) return null;
		let a;
		if (typeof t != "object" || !("type" in t)) a = /* @__PURE__ */ i("div", {
			className: n(W[e]),
			children: t
		});
		else if (this.isCustomAddon(t)) a = t.noWrap ? t.value : /* @__PURE__ */ i("div", {
			className: W[e],
			children: t.value
		});
		else if (this.isButtonAddon(t)) {
			let { className: o, disabled: s, ...c } = t.button;
			a = /* @__PURE__ */ i(U, {
				className: n({
					[W[e]]: !t.noStyle,
					[W[`${e}Button`]]: !t.noStyle
				}, o),
				disabled: r || s,
				...c
			});
		}
		return a;
	}
	getContextValue(e) {
		let { disabled: t, active: n, status: r } = this.props;
		return {
			position: e,
			disabled: !!t,
			active: !!n,
			status: r || "success"
		};
	}
	render() {
		let { className: e, disabled: t, active: r, status: o, prefix: s, suffix: c, icon: l, children: u, innerRef: d, ...f } = this.props;
		return /* @__PURE__ */ a("div", {
			"data-testid": Ce,
			className: n(W.root, {
				[W.rootActive]: r,
				[W.rootDisabled]: t,
				[W.rootHasError]: o === "error",
				[W.rootHasWarning]: o === "warning",
				[W.rootHasSuccess]: o === "success",
				[W.rootWithPrefix]: !!s,
				[W.rootWithSuffix]: !!c
			}, e),
			ref: d,
			...f,
			children: [
				/* @__PURE__ */ i(G.Provider, {
					value: this.getContextValue("prefix"),
					children: this.renderAddon("prefix")
				}),
				/* @__PURE__ */ i("div", {
					className: W.inputWrapper,
					children: u
				}),
				/* @__PURE__ */ a("span", {
					className: W.suffixesContainer,
					children: [this.renderIcon(), /* @__PURE__ */ i(G.Provider, {
						value: this.getContextValue("suffix"),
						children: this.renderAddon("suffix")
					})]
				})
			]
		});
	}
}, Te = l(function(e, t) {
	return /* @__PURE__ */ i(we, {
		innerRef: t,
		...e,
		children: e.children
	});
}), K = (e, t = 0) => {
	if (!e) return t;
	if (typeof e == "number") return e;
	let n = parseFloat(e);
	return isNaN(n) ? t : n;
}, q = {
	root: "h-inputText-inputNumberArrows--inputNumberArrows__root",
	button: "h-inputText-inputNumberArrows--inputNumberArrows__button",
	buttonUp: "h-inputText-inputNumberArrows--inputNumberArrows__buttonUp",
	buttonDown: "h-inputText-inputNumberArrows--inputNumberArrows__buttonDown",
	spacer: "h-inputText-inputNumberArrows--inputNumberArrows__spacer"
}, Ee = 50, De = 300, Oe = "inputNumberArrowsTestId", ke = class extends o {
	intervalId;
	timeoutId;
	constructor(e) {
		super(e), this.intervalId = null, this.timeoutId = null, this.increaseValue = this.increaseValue.bind(this), this.decreaseValue = this.decreaseValue.bind(this), this.startIncreaseValue = this.startIncreaseValue.bind(this), this.startDecreaseValue = this.startDecreaseValue.bind(this), this.stopChangeValue = this.stopChangeValue.bind(this);
	}
	componentDidMount() {
		window.addEventListener("mouseup", this.stopChangeValue);
	}
	componentWillUnmount() {
		window.removeEventListener("mouseup", this.stopChangeValue);
	}
	getNewValue(e) {
		let { step: t, min: n, max: r, inputRef: { current: i } } = this.props;
		if (!i) return 0;
		let a = K(i.value), o = K(t, 1), s = K(n, -(2 ** 53 - 1)), c = K(r, 2 ** 53 - 1);
		return e == "decrease" ? Math.max(a - o, s) : Math.min(a + o, c);
	}
	startIncreaseValue() {
		this.timeoutId = setTimeout(() => this.startChangeValue("increase"), De);
	}
	startDecreaseValue() {
		this.timeoutId = setTimeout(() => this.startChangeValue("decrease"), De);
	}
	startChangeValue(e) {
		this.intervalId ||= setInterval(() => this.triggerInputChange(e), Ee);
	}
	stopChangeValue() {
		this.timeoutId &&= (clearTimeout(this.timeoutId), null), this.intervalId &&= (clearInterval(this.intervalId), null);
	}
	increaseValue(e) {
		e.preventDefault(), this.triggerInputChange("increase");
	}
	decreaseValue(e) {
		e.preventDefault(), this.triggerInputChange("decrease");
	}
	triggerInputChange(e) {
		let { inputRef: { current: t }, readOnly: n } = this.props;
		if (!t || n) return;
		let r = this.getNewValue(e), i = new Event("input", { bubbles: !0 }), a = Object.getPrototypeOf(t);
		(Object.getOwnPropertyDescriptor(a, "value")?.set)?.call(t, r), t.dispatchEvent(i), t.focus();
	}
	render() {
		return /* @__PURE__ */ a("div", {
			className: q.root,
			"data-testid": Oe,
			children: [
				/* @__PURE__ */ i("button", {
					className: n(q.button, q.buttonUp),
					tabIndex: -1,
					onClick: this.increaseValue,
					onMouseDown: this.startIncreaseValue,
					children: /* @__PURE__ */ i(N, { name: "angle-up" })
				}),
				/* @__PURE__ */ i("span", { className: q.spacer }),
				/* @__PURE__ */ i("button", {
					className: n(q.button, q.buttonDown),
					tabIndex: -1,
					onClick: this.decreaseValue,
					onMouseDown: this.startDecreaseValue,
					children: /* @__PURE__ */ i(N, { name: "angle-down" })
				})
			]
		});
	}
}, J = {
	rootReadOnly: "h-inputText--inputText__rootReadOnly",
	container: "h-inputText--inputText__container",
	rootHasIcon: "h-inputText--inputText__rootHasIcon",
	rootTypeNumber: "h-inputText--inputText__rootTypeNumber",
	input: "h-inputText--inputText__input"
}, Ae = "inputText", je = l(function(e, t) {
	let r = h(null);
	p(t, () => r.current);
	let { className: o, disabled: s, readOnly: c, type: l = "text", name: u, prefix: d, suffix: f, icon: m, status: g, min: _, max: v, step: y, hideNumberArrows: b = !1, active: x = !1, ...S } = e;
	return /* @__PURE__ */ i(Te, {
		className: n(o, {
			[J.rootTypeNumber]: l === "number",
			[J.rootHasIcon]: !!m,
			[J.rootReadOnly]: c
		}),
		status: g,
		disabled: s,
		active: x,
		prefix: d,
		suffix: f,
		icon: m,
		children: /* @__PURE__ */ a("div", {
			className: J.container,
			children: [/* @__PURE__ */ i("input", {
				"data-testid": Ae,
				dir: "auto",
				id: u,
				name: u,
				ref: r,
				...S,
				min: _,
				max: v,
				step: y,
				type: l,
				disabled: s,
				readOnly: c,
				className: J.input
			}), l === "number" && !b && /* @__PURE__ */ i(ke, {
				min: _,
				max: v,
				step: y,
				inputRef: r,
				readOnly: c
			})]
		})
	});
}), Me = _, Ne = v, Pe = {
	root: "h-emojiPicker--emojiCategory__root",
	rootActive: "h-emojiPicker--emojiCategory__rootActive"
}, Fe = ({ category: e, active: t, gotoCategory: r }) => /* @__PURE__ */ i("button", {
	type: "button",
	className: n({
		[Pe.root]: !0,
		[Pe.rootActive]: t
	}),
	title: e.name,
	onClick: () => r(e.key),
	children: /* @__PURE__ */ i(N, { name: e.icon })
}, e.key);
Fe.displayName = "EmojiCategory";
var Ie = { root: "h-emojiPicker--emojiButton__root" }, Le = ({ emoji: e, onSelect: t }) => {
	let { emoji: n } = e;
	return /* @__PURE__ */ i("button", {
		type: "button",
		onClick: () => t(n),
		className: Ie.root,
		children: n
	});
};
Le.displayName = "Emoji";
var Re = { sectionHeader: "h-emojiPicker--emojiSection__sectionHeader" }, Y = ({ emojis: e, category: t, onSelect: n, sectionRef: r }) => /* @__PURE__ */ a("div", { children: [/* @__PURE__ */ i("div", {
	ref: r,
	"data-ref": t.key,
	className: "tracker"
}), !!e.length && /* @__PURE__ */ a("div", { children: [/* @__PURE__ */ i(z.Paragraph, {
	as: "div",
	variant: "4",
	subdued: !0,
	className: Re.sectionHeader,
	children: t.name
}), e.map((e) => /* @__PURE__ */ i(Le, {
	emoji: e,
	onSelect: n
}, e.emoji))] })] }, t.key);
Y.displayName = "EmojiSection";
var X = {
	root: "h-emojiPicker--emojiPicker__root",
	search: "h-emojiPicker--emojiPicker__search",
	categories: "h-emojiPicker--emojiPicker__categories",
	container: "h-emojiPicker--emojiPicker__container",
	grid: "h-emojiPicker--emojiPicker__grid",
	empty: "h-emojiPicker--emojiPicker__empty"
}, Z = {
	categories: [
		{
			key: 0,
			name: "Frequently used",
			icon: "clock"
		},
		{
			key: 1,
			name: "Smileys & People",
			icon: "smile"
		},
		{
			key: 2,
			name: "Animals & Nature",
			icon: "sun"
		},
		{
			key: 3,
			name: "Food & Drink",
			icon: "hamburger"
		},
		{
			key: 4,
			name: "Activities",
			icon: "american-football"
		},
		{
			key: 5,
			name: "Travel & Places",
			icon: "plane"
		},
		{
			key: 6,
			name: "Objects",
			icon: "lightbulb"
		},
		{
			key: 7,
			name: "Symbols",
			icon: "info"
		},
		{
			key: 8,
			name: "Flags",
			icon: "flag"
		}
	],
	emojis: [
		[],
		[
			{
				emoji: "😀",
				name: "GRINNING FACE",
				added_in: "6.1",
				shortName: "grinning",
				shortNames: ["grinning"],
				category: 1
			},
			{
				emoji: "😁",
				name: "GRINNING FACE WITH SMILING EYES",
				added_in: "6.0",
				shortName: "grin",
				shortNames: ["grin"],
				category: 1
			},
			{
				emoji: "😂",
				name: "FACE WITH TEARS OF JOY",
				added_in: "6.0",
				shortName: "joy",
				shortNames: ["joy"],
				category: 1
			},
			{
				emoji: "😃",
				name: "SMILING FACE WITH OPEN MOUTH",
				added_in: "6.0",
				shortName: "smiley",
				shortNames: ["smiley"],
				category: 1
			},
			{
				emoji: "😄",
				name: "SMILING FACE WITH OPEN MOUTH AND SMILING EYES",
				added_in: "6.0",
				shortName: "smile",
				shortNames: ["smile"],
				category: 1
			},
			{
				emoji: "😅",
				name: "SMILING FACE WITH OPEN MOUTH AND COLD SWEAT",
				added_in: "6.0",
				shortName: "sweat_smile",
				shortNames: ["sweat_smile"],
				category: 1
			},
			{
				emoji: "😆",
				name: "SMILING FACE WITH OPEN MOUTH AND TIGHTLY-CLOSED EYES",
				added_in: "6.0",
				shortName: "laughing",
				shortNames: ["laughing", "satisfied"],
				category: 1
			},
			{
				emoji: "😇",
				name: "SMILING FACE WITH HALO",
				added_in: "6.0",
				shortName: "innocent",
				shortNames: ["innocent"],
				category: 1
			},
			{
				emoji: "😉",
				name: "WINKING FACE",
				added_in: "6.0",
				shortName: "wink",
				shortNames: ["wink"],
				category: 1
			},
			{
				emoji: "😊",
				name: "SMILING FACE WITH SMILING EYES",
				added_in: "6.0",
				shortName: "blush",
				shortNames: ["blush"],
				category: 1
			},
			{
				emoji: "😋",
				name: "FACE SAVOURING DELICIOUS FOOD",
				added_in: "6.0",
				shortName: "yum",
				shortNames: ["yum"],
				category: 1
			},
			{
				emoji: "😌",
				name: "RELIEVED FACE",
				added_in: "6.0",
				shortName: "relieved",
				shortNames: ["relieved"],
				category: 1
			},
			{
				emoji: "😍",
				name: "SMILING FACE WITH HEART-SHAPED EYES",
				added_in: "6.0",
				shortName: "heart_eyes",
				shortNames: ["heart_eyes"],
				category: 1
			},
			{
				emoji: "😎",
				name: "SMILING FACE WITH SUNGLASSES",
				added_in: "6.0",
				shortName: "sunglasses",
				shortNames: ["sunglasses"],
				category: 1
			},
			{
				emoji: "😏",
				name: "SMIRKING FACE",
				added_in: "6.0",
				shortName: "smirk",
				shortNames: ["smirk"],
				category: 1
			},
			{
				emoji: "😐",
				name: "NEUTRAL FACE",
				added_in: "6.0",
				shortName: "neutral_face",
				shortNames: ["neutral_face"],
				category: 1
			},
			{
				emoji: "😑",
				name: "EXPRESSIONLESS FACE",
				added_in: "6.1",
				shortName: "expressionless",
				shortNames: ["expressionless"],
				category: 1
			},
			{
				emoji: "😒",
				name: "UNAMUSED FACE",
				added_in: "6.0",
				shortName: "unamused",
				shortNames: ["unamused"],
				category: 1
			},
			{
				emoji: "😓",
				name: "FACE WITH COLD SWEAT",
				added_in: "6.0",
				shortName: "sweat",
				shortNames: ["sweat"],
				category: 1
			},
			{
				emoji: "😔",
				name: "PENSIVE FACE",
				added_in: "6.0",
				shortName: "pensive",
				shortNames: ["pensive"],
				category: 1
			},
			{
				emoji: "😕",
				name: "CONFUSED FACE",
				added_in: "6.1",
				shortName: "confused",
				shortNames: ["confused"],
				category: 1
			},
			{
				emoji: "😖",
				name: "CONFOUNDED FACE",
				added_in: "6.0",
				shortName: "confounded",
				shortNames: ["confounded"],
				category: 1
			},
			{
				emoji: "😗",
				name: "KISSING FACE",
				added_in: "6.1",
				shortName: "kissing",
				shortNames: ["kissing"],
				category: 1
			},
			{
				emoji: "😘",
				name: "FACE THROWING A KISS",
				added_in: "6.0",
				shortName: "kissing_heart",
				shortNames: ["kissing_heart"],
				category: 1
			},
			{
				emoji: "😙",
				name: "KISSING FACE WITH SMILING EYES",
				added_in: "6.1",
				shortName: "kissing_smiling_eyes",
				shortNames: ["kissing_smiling_eyes"],
				category: 1
			},
			{
				emoji: "😚",
				name: "KISSING FACE WITH CLOSED EYES",
				added_in: "6.0",
				shortName: "kissing_closed_eyes",
				shortNames: ["kissing_closed_eyes"],
				category: 1
			},
			{
				emoji: "😛",
				name: "FACE WITH STUCK-OUT TONGUE",
				added_in: "6.1",
				shortName: "stuck_out_tongue",
				shortNames: ["stuck_out_tongue"],
				category: 1
			},
			{
				emoji: "😜",
				name: "FACE WITH STUCK-OUT TONGUE AND WINKING EYE",
				added_in: "6.0",
				shortName: "stuck_out_tongue_winking_eye",
				shortNames: ["stuck_out_tongue_winking_eye"],
				category: 1
			},
			{
				emoji: "😝",
				name: "FACE WITH STUCK-OUT TONGUE AND TIGHTLY-CLOSED EYES",
				added_in: "6.0",
				shortName: "stuck_out_tongue_closed_eyes",
				shortNames: ["stuck_out_tongue_closed_eyes"],
				category: 1
			},
			{
				emoji: "😞",
				name: "DISAPPOINTED FACE",
				added_in: "6.0",
				shortName: "disappointed",
				shortNames: ["disappointed"],
				category: 1
			},
			{
				emoji: "😟",
				name: "WORRIED FACE",
				added_in: "6.1",
				shortName: "worried",
				shortNames: ["worried"],
				category: 1
			},
			{
				emoji: "😠",
				name: "ANGRY FACE",
				added_in: "6.0",
				shortName: "angry",
				shortNames: ["angry"],
				category: 1
			},
			{
				emoji: "😡",
				name: "POUTING FACE",
				added_in: "6.0",
				shortName: "rage",
				shortNames: ["rage"],
				category: 1
			},
			{
				emoji: "😢",
				name: "CRYING FACE",
				added_in: "6.0",
				shortName: "cry",
				shortNames: ["cry"],
				category: 1
			},
			{
				emoji: "😣",
				name: "PERSEVERING FACE",
				added_in: "6.0",
				shortName: "persevere",
				shortNames: ["persevere"],
				category: 1
			},
			{
				emoji: "😤",
				name: "FACE WITH LOOK OF TRIUMPH",
				added_in: "6.0",
				shortName: "triumph",
				shortNames: ["triumph"],
				category: 1
			},
			{
				emoji: "😥",
				name: "DISAPPOINTED BUT RELIEVED FACE",
				added_in: "6.0",
				shortName: "disappointed_relieved",
				shortNames: ["disappointed_relieved"],
				category: 1
			},
			{
				emoji: "😦",
				name: "FROWNING FACE WITH OPEN MOUTH",
				added_in: "6.1",
				shortName: "frowning",
				shortNames: ["frowning"],
				category: 1
			},
			{
				emoji: "😧",
				name: "ANGUISHED FACE",
				added_in: "6.1",
				shortName: "anguished",
				shortNames: ["anguished"],
				category: 1
			},
			{
				emoji: "😨",
				name: "FEARFUL FACE",
				added_in: "6.0",
				shortName: "fearful",
				shortNames: ["fearful"],
				category: 1
			},
			{
				emoji: "😩",
				name: "WEARY FACE",
				added_in: "6.0",
				shortName: "weary",
				shortNames: ["weary"],
				category: 1
			},
			{
				emoji: "😪",
				name: "SLEEPY FACE",
				added_in: "6.0",
				shortName: "sleepy",
				shortNames: ["sleepy"],
				category: 1
			},
			{
				emoji: "😫",
				name: "TIRED FACE",
				added_in: "6.0",
				shortName: "tired_face",
				shortNames: ["tired_face"],
				category: 1
			},
			{
				emoji: "😬",
				name: "GRIMACING FACE",
				added_in: "6.1",
				shortName: "grimacing",
				shortNames: ["grimacing"],
				category: 1
			},
			{
				emoji: "😭",
				name: "LOUDLY CRYING FACE",
				added_in: "6.0",
				shortName: "sob",
				shortNames: ["sob"],
				category: 1
			},
			{
				emoji: "😮",
				name: "FACE WITH OPEN MOUTH",
				added_in: "6.1",
				shortName: "open_mouth",
				shortNames: ["open_mouth"],
				category: 1
			},
			{
				emoji: "😯",
				name: "HUSHED FACE",
				added_in: "6.1",
				shortName: "hushed",
				shortNames: ["hushed"],
				category: 1
			},
			{
				emoji: "😰",
				name: "FACE WITH OPEN MOUTH AND COLD SWEAT",
				added_in: "6.0",
				shortName: "cold_sweat",
				shortNames: ["cold_sweat"],
				category: 1
			},
			{
				emoji: "😱",
				name: "FACE SCREAMING IN FEAR",
				added_in: "6.0",
				shortName: "scream",
				shortNames: ["scream"],
				category: 1
			},
			{
				emoji: "😲",
				name: "ASTONISHED FACE",
				added_in: "6.0",
				shortName: "astonished",
				shortNames: ["astonished"],
				category: 1
			},
			{
				emoji: "😳",
				name: "FLUSHED FACE",
				added_in: "6.0",
				shortName: "flushed",
				shortNames: ["flushed"],
				category: 1
			},
			{
				emoji: "😴",
				name: "SLEEPING FACE",
				added_in: "6.1",
				shortName: "sleeping",
				shortNames: ["sleeping"],
				category: 1
			},
			{
				emoji: "😵",
				name: "DIZZY FACE",
				added_in: "6.0",
				shortName: "dizzy_face",
				shortNames: ["dizzy_face"],
				category: 1
			},
			{
				emoji: "😶",
				name: "FACE WITHOUT MOUTH",
				added_in: "6.0",
				shortName: "no_mouth",
				shortNames: ["no_mouth"],
				category: 1
			},
			{
				emoji: "😷",
				name: "FACE WITH MEDICAL MASK",
				added_in: "6.0",
				shortName: "mask",
				shortNames: ["mask"],
				category: 1
			},
			{
				emoji: "🙂",
				name: "SLIGHTLY SMILING FACE",
				added_in: "7.0",
				shortName: "slightly_smiling_face",
				shortNames: ["slightly_smiling_face"],
				category: 1
			},
			{
				emoji: "👿",
				name: "IMP",
				added_in: "6.0",
				shortName: "imp",
				shortNames: ["imp"],
				category: 1
			},
			{
				emoji: "😈",
				name: "SMILING FACE WITH HORNS",
				added_in: "6.0",
				shortName: "smiling_imp",
				shortNames: ["smiling_imp"],
				category: 1
			},
			{
				emoji: "👆",
				name: "WHITE UP POINTING BACKHAND INDEX",
				added_in: "6.0",
				shortName: "point_up_2",
				shortNames: ["point_up_2"],
				category: 1
			},
			{
				emoji: "👇",
				name: "WHITE DOWN POINTING BACKHAND INDEX",
				added_in: "6.0",
				shortName: "point_down",
				shortNames: ["point_down"],
				category: 1
			},
			{
				emoji: "👈",
				name: "WHITE LEFT POINTING BACKHAND INDEX",
				added_in: "6.0",
				shortName: "point_left",
				shortNames: ["point_left"],
				category: 1
			},
			{
				emoji: "👉",
				name: "WHITE RIGHT POINTING BACKHAND INDEX",
				added_in: "6.0",
				shortName: "point_right",
				shortNames: ["point_right"],
				category: 1
			},
			{
				emoji: "👊",
				name: "FISTED HAND SIGN",
				added_in: "6.0",
				shortName: "facepunch",
				shortNames: ["facepunch", "punch"],
				category: 1
			},
			{
				emoji: "👋",
				name: "WAVING HAND SIGN",
				added_in: "6.0",
				shortName: "wave",
				shortNames: ["wave"],
				category: 1
			},
			{
				emoji: "👌",
				name: "OK HAND SIGN",
				added_in: "6.0",
				shortName: "ok_hand",
				shortNames: ["ok_hand"],
				category: 1
			},
			{
				emoji: "👍",
				name: "THUMBS UP SIGN",
				added_in: "6.0",
				shortName: "+1",
				shortNames: ["+1", "thumbsup"],
				category: 1
			},
			{
				emoji: "👎",
				name: "THUMBS DOWN SIGN",
				added_in: "6.0",
				shortName: "-1",
				shortNames: ["-1", "thumbsdown"],
				category: 1
			},
			{
				emoji: "👏",
				name: "CLAPPING HANDS SIGN",
				added_in: "6.0",
				shortName: "clap",
				shortNames: ["clap"],
				category: 1
			},
			{
				emoji: "👐",
				name: "OPEN HANDS SIGN",
				added_in: "6.0",
				shortName: "open_hands",
				shortNames: ["open_hands"],
				category: 1
			},
			{
				emoji: "🙌",
				name: "PERSON RAISING BOTH HANDS IN CELEBRATION",
				added_in: "6.0",
				shortName: "raised_hands",
				shortNames: ["raised_hands"],
				category: 1
			},
			{
				emoji: "🙏",
				name: "PERSON WITH FOLDED HANDS",
				added_in: "6.0",
				shortName: "pray",
				shortNames: ["pray"],
				category: 1
			},
			{
				emoji: "☝️",
				name: "WHITE UP POINTING INDEX",
				added_in: "1.1",
				shortName: "point_up",
				shortNames: ["point_up"],
				category: 1
			},
			{
				emoji: "✊",
				name: "RAISED FIST",
				added_in: "6.0",
				shortName: "fist",
				shortNames: ["fist"],
				category: 1
			},
			{
				emoji: "✋",
				name: "RAISED HAND",
				added_in: "6.0",
				shortName: "hand",
				shortNames: ["hand", "raised_hand"],
				category: 1
			},
			{
				emoji: "✌️",
				name: "VICTORY HAND",
				added_in: "1.1",
				shortName: "v",
				shortNames: ["v"],
				category: 1
			},
			{
				emoji: "😸",
				name: "GRINNING CAT FACE WITH SMILING EYES",
				added_in: "6.0",
				shortName: "smile_cat",
				shortNames: ["smile_cat"],
				category: 1
			},
			{
				emoji: "😹",
				name: "CAT FACE WITH TEARS OF JOY",
				added_in: "6.0",
				shortName: "joy_cat",
				shortNames: ["joy_cat"],
				category: 1
			},
			{
				emoji: "😺",
				name: "SMILING CAT FACE WITH OPEN MOUTH",
				added_in: "6.0",
				shortName: "smiley_cat",
				shortNames: ["smiley_cat"],
				category: 1
			},
			{
				emoji: "😻",
				name: "SMILING CAT FACE WITH HEART-SHAPED EYES",
				added_in: "6.0",
				shortName: "heart_eyes_cat",
				shortNames: ["heart_eyes_cat"],
				category: 1
			},
			{
				emoji: "😼",
				name: "CAT FACE WITH WRY SMILE",
				added_in: "6.0",
				shortName: "smirk_cat",
				shortNames: ["smirk_cat"],
				category: 1
			},
			{
				emoji: "😽",
				name: "KISSING CAT FACE WITH CLOSED EYES",
				added_in: "6.0",
				shortName: "kissing_cat",
				shortNames: ["kissing_cat"],
				category: 1
			},
			{
				emoji: "😾",
				name: "POUTING CAT FACE",
				added_in: "6.0",
				shortName: "pouting_cat",
				shortNames: ["pouting_cat"],
				category: 1
			},
			{
				emoji: "😿",
				name: "CRYING CAT FACE",
				added_in: "6.0",
				shortName: "crying_cat_face",
				shortNames: ["crying_cat_face"],
				category: 1
			},
			{
				emoji: "🙀",
				name: "WEARY CAT FACE",
				added_in: "6.0",
				shortName: "scream_cat",
				shortNames: ["scream_cat"],
				category: 1
			},
			{
				emoji: "🙈",
				name: "SEE-NO-EVIL MONKEY",
				added_in: "6.0",
				shortName: "see_no_evil",
				shortNames: ["see_no_evil"],
				category: 1
			},
			{
				emoji: "🙉",
				name: "HEAR-NO-EVIL MONKEY",
				added_in: "6.0",
				shortName: "hear_no_evil",
				shortNames: ["hear_no_evil"],
				category: 1
			},
			{
				emoji: "🙊",
				name: "SPEAK-NO-EVIL MONKEY",
				added_in: "6.0",
				shortName: "speak_no_evil",
				shortNames: ["speak_no_evil"],
				category: 1
			},
			{
				emoji: "🎅",
				name: "FATHER CHRISTMAS",
				added_in: "6.0",
				shortName: "santa",
				shortNames: ["santa"],
				category: 1
			},
			{
				emoji: "👦",
				name: "BOY",
				added_in: "6.0",
				shortName: "boy",
				shortNames: ["boy"],
				category: 1
			},
			{
				emoji: "👧",
				name: "GIRL",
				added_in: "6.0",
				shortName: "girl",
				shortNames: ["girl"],
				category: 1
			},
			{
				emoji: "👨‍👨‍👦",
				name: null,
				added_in: "6.0",
				shortName: "man-man-boy",
				shortNames: ["man-man-boy"],
				category: 1
			},
			{
				emoji: "👨‍👨‍👦‍👦",
				name: null,
				added_in: "6.0",
				shortName: "man-man-boy-boy",
				shortNames: ["man-man-boy-boy"],
				category: 1
			},
			{
				emoji: "👨‍👨‍👧",
				name: null,
				added_in: "6.0",
				shortName: "man-man-girl",
				shortNames: ["man-man-girl"],
				category: 1
			},
			{
				emoji: "👨‍👨‍👧‍👦",
				name: null,
				added_in: "6.0",
				shortName: "man-man-girl-boy",
				shortNames: ["man-man-girl-boy"],
				category: 1
			},
			{
				emoji: "👨‍👨‍👧‍👧",
				name: null,
				added_in: "6.0",
				shortName: "man-man-girl-girl",
				shortNames: ["man-man-girl-girl"],
				category: 1
			},
			{
				emoji: "👨‍👩‍👦",
				name: null,
				added_in: "6.0",
				shortName: "man-woman-boy",
				shortNames: ["man-woman-boy", "family"],
				category: 1
			},
			{
				emoji: "👨‍👩‍👦‍👦",
				name: null,
				added_in: "6.0",
				shortName: "man-woman-boy-boy",
				shortNames: ["man-woman-boy-boy"],
				category: 1
			},
			{
				emoji: "👨‍👩‍👧",
				name: null,
				added_in: "6.0",
				shortName: "man-woman-girl",
				shortNames: ["man-woman-girl"],
				category: 1
			},
			{
				emoji: "👨‍👩‍👧‍👦",
				name: null,
				added_in: "6.0",
				shortName: "man-woman-girl-boy",
				shortNames: ["man-woman-girl-boy"],
				category: 1
			},
			{
				emoji: "👨‍👩‍👧‍👧",
				name: null,
				added_in: "6.0",
				shortName: "man-woman-girl-girl",
				shortNames: ["man-woman-girl-girl"],
				category: 1
			},
			{
				emoji: "👨‍❤️‍👨",
				name: null,
				added_in: "6.0",
				shortName: "man-heart-man",
				shortNames: ["man-heart-man"],
				category: 1
			},
			{
				emoji: "👨‍❤️‍💋‍👨",
				name: null,
				added_in: "6.0",
				shortName: "man-kiss-man",
				shortNames: ["man-kiss-man"],
				category: 1
			},
			{
				emoji: "👨",
				name: "MAN",
				added_in: "6.0",
				shortName: "man",
				shortNames: ["man"],
				category: 1
			},
			{
				emoji: "👩‍👩‍👦",
				name: null,
				added_in: "6.0",
				shortName: "woman-woman-boy",
				shortNames: ["woman-woman-boy"],
				category: 1
			},
			{
				emoji: "👩‍👩‍👦‍👦",
				name: null,
				added_in: "6.0",
				shortName: "woman-woman-boy-boy",
				shortNames: ["woman-woman-boy-boy"],
				category: 1
			},
			{
				emoji: "👩‍👩‍👧",
				name: null,
				added_in: "6.0",
				shortName: "woman-woman-girl",
				shortNames: ["woman-woman-girl"],
				category: 1
			},
			{
				emoji: "👩‍👩‍👧‍👦",
				name: null,
				added_in: "6.0",
				shortName: "woman-woman-girl-boy",
				shortNames: ["woman-woman-girl-boy"],
				category: 1
			},
			{
				emoji: "👩‍👩‍👧‍👧",
				name: null,
				added_in: "6.0",
				shortName: "woman-woman-girl-girl",
				shortNames: ["woman-woman-girl-girl"],
				category: 1
			},
			{
				emoji: "👩‍❤️‍👩",
				name: null,
				added_in: "6.0",
				shortName: "woman-heart-woman",
				shortNames: ["woman-heart-woman"],
				category: 1
			},
			{
				emoji: "👩‍❤️‍💋‍👩",
				name: null,
				added_in: "6.0",
				shortName: "woman-kiss-woman",
				shortNames: ["woman-kiss-woman"],
				category: 1
			},
			{
				emoji: "👩",
				name: "WOMAN",
				added_in: "6.0",
				shortName: "woman",
				shortNames: ["woman"],
				category: 1
			},
			{
				emoji: "👫",
				name: "MAN AND WOMAN HOLDING HANDS",
				added_in: "6.0",
				shortName: "couple",
				shortNames: ["couple", "man_and_woman_holding_hands"],
				category: 1
			},
			{
				emoji: "👬",
				name: "TWO MEN HOLDING HANDS",
				added_in: "6.0",
				shortName: "two_men_holding_hands",
				shortNames: ["two_men_holding_hands"],
				category: 1
			},
			{
				emoji: "👭",
				name: "TWO WOMEN HOLDING HANDS",
				added_in: "6.0",
				shortName: "two_women_holding_hands",
				shortNames: ["two_women_holding_hands"],
				category: 1
			},
			{
				emoji: "👲",
				name: "MAN WITH GUA PI MAO",
				added_in: "6.0",
				shortName: "man_with_gua_pi_mao",
				shortNames: ["man_with_gua_pi_mao"],
				category: 1
			},
			{
				emoji: "👴",
				name: "OLDER MAN",
				added_in: "6.0",
				shortName: "older_man",
				shortNames: ["older_man"],
				category: 1
			},
			{
				emoji: "👵",
				name: "OLDER WOMAN",
				added_in: "6.0",
				shortName: "older_woman",
				shortNames: ["older_woman"],
				category: 1
			},
			{
				emoji: "👰",
				name: "BRIDE WITH VEIL",
				added_in: "6.0",
				shortName: "bride_with_veil",
				shortNames: ["bride_with_veil"],
				category: 1
			},
			{
				emoji: "👶",
				name: "BABY",
				added_in: "6.0",
				shortName: "baby",
				shortNames: ["baby"],
				category: 1
			},
			{
				emoji: "👸",
				name: "PRINCESS",
				added_in: "6.0",
				shortName: "princess",
				shortNames: ["princess"],
				category: 1
			},
			{
				emoji: "👼",
				name: "BABY ANGEL",
				added_in: "6.0",
				shortName: "angel",
				shortNames: ["angel"],
				category: 1
			},
			{
				emoji: "🎩",
				name: "TOP HAT",
				added_in: "6.0",
				shortName: "tophat",
				shortNames: ["tophat"],
				category: 1
			},
			{
				emoji: "👒",
				name: "WOMANS HAT",
				added_in: "6.0",
				shortName: "womans_hat",
				shortNames: ["womans_hat"],
				category: 1
			},
			{
				emoji: "👕",
				name: "T-SHIRT",
				added_in: "6.0",
				shortName: "shirt",
				shortNames: ["shirt", "tshirt"],
				category: 1
			},
			{
				emoji: "👚",
				name: "WOMANS CLOTHES",
				added_in: "6.0",
				shortName: "womans_clothes",
				shortNames: ["womans_clothes"],
				category: 1
			},
			{
				emoji: "👜",
				name: "HANDBAG",
				added_in: "6.0",
				shortName: "handbag",
				shortNames: ["handbag"],
				category: 1
			},
			{
				emoji: "👞",
				name: "MANS SHOE",
				added_in: "6.0",
				shortName: "mans_shoe",
				shortNames: ["mans_shoe", "shoe"],
				category: 1
			},
			{
				emoji: "👟",
				name: "ATHLETIC SHOE",
				added_in: "6.0",
				shortName: "athletic_shoe",
				shortNames: ["athletic_shoe"],
				category: 1
			},
			{
				emoji: "👠",
				name: "HIGH-HEELED SHOE",
				added_in: "6.0",
				shortName: "high_heel",
				shortNames: ["high_heel"],
				category: 1
			},
			{
				emoji: "👡",
				name: "WOMANS SANDAL",
				added_in: "6.0",
				shortName: "sandal",
				shortNames: ["sandal"],
				category: 1
			},
			{
				emoji: "👢",
				name: "WOMANS BOOTS",
				added_in: "6.0",
				shortName: "boot",
				shortNames: ["boot"],
				category: 1
			},
			{
				emoji: "🎒",
				name: "SCHOOL SATCHEL",
				added_in: "6.0",
				shortName: "school_satchel",
				shortNames: ["school_satchel"],
				category: 1
			},
			{
				emoji: "🎓",
				name: "GRADUATION CAP",
				added_in: "6.0",
				shortName: "mortar_board",
				shortNames: ["mortar_board"],
				category: 1
			},
			{
				emoji: "🏂",
				name: "SNOWBOARDER",
				added_in: "6.0",
				shortName: "snowboarder",
				shortNames: ["snowboarder"],
				category: 1
			},
			{
				emoji: "🏇",
				name: "HORSE RACING",
				added_in: "6.0",
				shortName: "horse_racing",
				shortNames: ["horse_racing"],
				category: 1
			},
			{
				emoji: "👀",
				name: "EYES",
				added_in: "6.0",
				shortName: "eyes",
				shortNames: ["eyes"],
				category: 1
			},
			{
				emoji: "👂",
				name: "EAR",
				added_in: "6.0",
				shortName: "ear",
				shortNames: ["ear"],
				category: 1
			},
			{
				emoji: "👃",
				name: "NOSE",
				added_in: "6.0",
				shortName: "nose",
				shortNames: ["nose"],
				category: 1
			},
			{
				emoji: "👄",
				name: "MOUTH",
				added_in: "6.0",
				shortName: "lips",
				shortNames: ["lips"],
				category: 1
			},
			{
				emoji: "👅",
				name: "TONGUE",
				added_in: "6.0",
				shortName: "tongue",
				shortNames: ["tongue"],
				category: 1
			},
			{
				emoji: "👑",
				name: "CROWN",
				added_in: "6.0",
				shortName: "crown",
				shortNames: ["crown"],
				category: 1
			},
			{
				emoji: "👓",
				name: "EYEGLASSES",
				added_in: "6.0",
				shortName: "eyeglasses",
				shortNames: ["eyeglasses"],
				category: 1
			},
			{
				emoji: "👔",
				name: "NECKTIE",
				added_in: "6.0",
				shortName: "necktie",
				shortNames: ["necktie"],
				category: 1
			},
			{
				emoji: "👖",
				name: "JEANS",
				added_in: "6.0",
				shortName: "jeans",
				shortNames: ["jeans"],
				category: 1
			},
			{
				emoji: "👗",
				name: "DRESS",
				added_in: "6.0",
				shortName: "dress",
				shortNames: ["dress"],
				category: 1
			},
			{
				emoji: "👘",
				name: "KIMONO",
				added_in: "6.0",
				shortName: "kimono",
				shortNames: ["kimono"],
				category: 1
			},
			{
				emoji: "👙",
				name: "BIKINI",
				added_in: "6.0",
				shortName: "bikini",
				shortNames: ["bikini"],
				category: 1
			},
			{
				emoji: "👛",
				name: "PURSE",
				added_in: "6.0",
				shortName: "purse",
				shortNames: ["purse"],
				category: 1
			},
			{
				emoji: "👝",
				name: "POUCH",
				added_in: "6.0",
				shortName: "pouch",
				shortNames: ["pouch"],
				category: 1
			},
			{
				emoji: "👣",
				name: "FOOTPRINTS",
				added_in: "6.0",
				shortName: "footprints",
				shortNames: ["footprints"],
				category: 1
			},
			{
				emoji: "👤",
				name: "BUST IN SILHOUETTE",
				added_in: "6.0",
				shortName: "bust_in_silhouette",
				shortNames: ["bust_in_silhouette"],
				category: 1
			},
			{
				emoji: "👥",
				name: "BUSTS IN SILHOUETTE",
				added_in: "6.0",
				shortName: "busts_in_silhouette",
				shortNames: ["busts_in_silhouette"],
				category: 1
			},
			{
				emoji: "👹",
				name: "JAPANESE OGRE",
				added_in: "6.0",
				shortName: "japanese_ogre",
				shortNames: ["japanese_ogre"],
				category: 1
			},
			{
				emoji: "👺",
				name: "JAPANESE GOBLIN",
				added_in: "6.0",
				shortName: "japanese_goblin",
				shortNames: ["japanese_goblin"],
				category: 1
			},
			{
				emoji: "👻",
				name: "GHOST",
				added_in: "6.0",
				shortName: "ghost",
				shortNames: ["ghost"],
				category: 1
			},
			{
				emoji: "👽",
				name: "EXTRATERRESTRIAL ALIEN",
				added_in: "6.0",
				shortName: "alien",
				shortNames: ["alien"],
				category: 1
			},
			{
				emoji: "👾",
				name: "ALIEN MONSTER",
				added_in: "6.0",
				shortName: "space_invader",
				shortNames: ["space_invader"],
				category: 1
			},
			{
				emoji: "💀",
				name: "SKULL",
				added_in: "6.0",
				shortName: "skull",
				shortNames: ["skull"],
				category: 1
			},
			{
				emoji: "💃",
				name: "DANCER",
				added_in: "6.0",
				shortName: "dancer",
				shortNames: ["dancer"],
				category: 1
			},
			{
				emoji: "💄",
				name: "LIPSTICK",
				added_in: "6.0",
				shortName: "lipstick",
				shortNames: ["lipstick"],
				category: 1
			},
			{
				emoji: "💅",
				name: "NAIL POLISH",
				added_in: "6.0",
				shortName: "nail_care",
				shortNames: ["nail_care"],
				category: 1
			},
			{
				emoji: "💋",
				name: "KISS MARK",
				added_in: "6.0",
				shortName: "kiss",
				shortNames: ["kiss"],
				category: 1
			},
			{
				emoji: "💌",
				name: "LOVE LETTER",
				added_in: "6.0",
				shortName: "love_letter",
				shortNames: ["love_letter"],
				category: 1
			},
			{
				emoji: "💍",
				name: "RING",
				added_in: "6.0",
				shortName: "ring",
				shortNames: ["ring"],
				category: 1
			},
			{
				emoji: "💎",
				name: "GEM STONE",
				added_in: "6.0",
				shortName: "gem",
				shortNames: ["gem"],
				category: 1
			},
			{
				emoji: "💓",
				name: "BEATING HEART",
				added_in: "6.0",
				shortName: "heartbeat",
				shortNames: ["heartbeat"],
				category: 1
			},
			{
				emoji: "💔",
				name: "BROKEN HEART",
				added_in: "6.0",
				shortName: "broken_heart",
				shortNames: ["broken_heart"],
				category: 1
			},
			{
				emoji: "💕",
				name: "TWO HEARTS",
				added_in: "6.0",
				shortName: "two_hearts",
				shortNames: ["two_hearts"],
				category: 1
			},
			{
				emoji: "💖",
				name: "SPARKLING HEART",
				added_in: "6.0",
				shortName: "sparkling_heart",
				shortNames: ["sparkling_heart"],
				category: 1
			},
			{
				emoji: "💗",
				name: "GROWING HEART",
				added_in: "6.0",
				shortName: "heartpulse",
				shortNames: ["heartpulse"],
				category: 1
			},
			{
				emoji: "💘",
				name: "HEART WITH ARROW",
				added_in: "6.0",
				shortName: "cupid",
				shortNames: ["cupid"],
				category: 1
			},
			{
				emoji: "💙",
				name: "BLUE HEART",
				added_in: "6.0",
				shortName: "blue_heart",
				shortNames: ["blue_heart"],
				category: 1
			},
			{
				emoji: "💚",
				name: "GREEN HEART",
				added_in: "6.0",
				shortName: "green_heart",
				shortNames: ["green_heart"],
				category: 1
			},
			{
				emoji: "💛",
				name: "YELLOW HEART",
				added_in: "6.0",
				shortName: "yellow_heart",
				shortNames: ["yellow_heart"],
				category: 1
			},
			{
				emoji: "💜",
				name: "PURPLE HEART",
				added_in: "6.0",
				shortName: "purple_heart",
				shortNames: ["purple_heart"],
				category: 1
			},
			{
				emoji: "💝",
				name: "HEART WITH RIBBON",
				added_in: "6.0",
				shortName: "gift_heart",
				shortNames: ["gift_heart"],
				category: 1
			},
			{
				emoji: "💞",
				name: "REVOLVING HEARTS",
				added_in: "6.0",
				shortName: "revolving_hearts",
				shortNames: ["revolving_hearts"],
				category: 1
			},
			{
				emoji: "💟",
				name: "HEART DECORATION",
				added_in: "6.0",
				shortName: "heart_decoration",
				shortNames: ["heart_decoration"],
				category: 1
			},
			{
				emoji: "💢",
				name: "ANGER SYMBOL",
				added_in: "6.0",
				shortName: "anger",
				shortNames: ["anger"],
				category: 1
			},
			{
				emoji: "💣",
				name: "BOMB",
				added_in: "6.0",
				shortName: "bomb",
				shortNames: ["bomb"],
				category: 1
			},
			{
				emoji: "💤",
				name: "SLEEPING SYMBOL",
				added_in: "6.0",
				shortName: "zzz",
				shortNames: ["zzz"],
				category: 1
			},
			{
				emoji: "💥",
				name: "COLLISION SYMBOL",
				added_in: "6.0",
				shortName: "boom",
				shortNames: ["boom", "collision"],
				category: 1
			},
			{
				emoji: "💦",
				name: "SPLASHING SWEAT SYMBOL",
				added_in: "6.0",
				shortName: "sweat_drops",
				shortNames: ["sweat_drops"],
				category: 1
			},
			{
				emoji: "💨",
				name: "DASH SYMBOL",
				added_in: "6.0",
				shortName: "dash",
				shortNames: ["dash"],
				category: 1
			},
			{
				emoji: "💩",
				name: "PILE OF POO",
				added_in: "6.0",
				shortName: "hankey",
				shortNames: [
					"hankey",
					"poop",
					"shit"
				],
				category: 1
			},
			{
				emoji: "💪",
				name: "FLEXED BICEPS",
				added_in: "6.0",
				shortName: "muscle",
				shortNames: ["muscle"],
				category: 1
			},
			{
				emoji: "💫",
				name: "DIZZY SYMBOL",
				added_in: "6.0",
				shortName: "dizzy",
				shortNames: ["dizzy"],
				category: 1
			},
			{
				emoji: "💬",
				name: "SPEECH BALLOON",
				added_in: "6.0",
				shortName: "speech_balloon",
				shortNames: ["speech_balloon"],
				category: 1
			},
			{
				emoji: "💭",
				name: "THOUGHT BALLOON",
				added_in: "6.0",
				shortName: "thought_balloon",
				shortNames: ["thought_balloon"],
				category: 1
			},
			{
				emoji: "🛀",
				name: "BATH",
				added_in: "6.0",
				shortName: "bath",
				shortNames: ["bath"],
				category: 1
			},
			{
				emoji: "❤️",
				name: "HEAVY BLACK HEART",
				added_in: "1.1",
				shortName: "heart",
				shortNames: ["heart"],
				category: 1
			}
		],
		[
			{
				emoji: "🐭",
				name: "MOUSE FACE",
				added_in: "6.0",
				shortName: "mouse",
				shortNames: ["mouse"],
				category: 2
			},
			{
				emoji: "🐮",
				name: "COW FACE",
				added_in: "6.0",
				shortName: "cow",
				shortNames: ["cow"],
				category: 2
			},
			{
				emoji: "🐯",
				name: "TIGER FACE",
				added_in: "6.0",
				shortName: "tiger",
				shortNames: ["tiger"],
				category: 2
			},
			{
				emoji: "🐰",
				name: "RABBIT FACE",
				added_in: "6.0",
				shortName: "rabbit",
				shortNames: ["rabbit"],
				category: 2
			},
			{
				emoji: "🐲",
				name: "DRAGON FACE",
				added_in: "6.0",
				shortName: "dragon_face",
				shortNames: ["dragon_face"],
				category: 2
			},
			{
				emoji: "🐴",
				name: "HORSE FACE",
				added_in: "6.0",
				shortName: "horse",
				shortNames: ["horse"],
				category: 2
			},
			{
				emoji: "🐵",
				name: "MONKEY FACE",
				added_in: "6.0",
				shortName: "monkey_face",
				shortNames: ["monkey_face"],
				category: 2
			},
			{
				emoji: "🐶",
				name: "DOG FACE",
				added_in: "6.0",
				shortName: "dog",
				shortNames: ["dog"],
				category: 2
			},
			{
				emoji: "🐷",
				name: "PIG FACE",
				added_in: "6.0",
				shortName: "pig",
				shortNames: ["pig"],
				category: 2
			},
			{
				emoji: "🐸",
				name: "FROG FACE",
				added_in: "6.0",
				shortName: "frog",
				shortNames: ["frog"],
				category: 2
			},
			{
				emoji: "🐹",
				name: "HAMSTER FACE",
				added_in: "6.0",
				shortName: "hamster",
				shortNames: ["hamster"],
				category: 2
			},
			{
				emoji: "🐺",
				name: "WOLF FACE",
				added_in: "6.0",
				shortName: "wolf",
				shortNames: ["wolf"],
				category: 2
			},
			{
				emoji: "🐻",
				name: "BEAR FACE",
				added_in: "6.0",
				shortName: "bear",
				shortNames: ["bear"],
				category: 2
			},
			{
				emoji: "🐼",
				name: "PANDA FACE",
				added_in: "6.0",
				shortName: "panda_face",
				shortNames: ["panda_face"],
				category: 2
			},
			{
				emoji: "🐱",
				name: "CAT FACE",
				added_in: "6.0",
				shortName: "cat",
				shortNames: ["cat"],
				category: 2
			},
			{
				emoji: "🐒",
				name: "MONKEY",
				added_in: "6.0",
				shortName: "monkey",
				shortNames: ["monkey"],
				category: 2
			},
			{
				emoji: "🐤",
				name: "BABY CHICK",
				added_in: "6.0",
				shortName: "baby_chick",
				shortNames: ["baby_chick"],
				category: 2
			},
			{
				emoji: "🐥",
				name: "FRONT-FACING BABY CHICK",
				added_in: "6.0",
				shortName: "hatched_chick",
				shortNames: ["hatched_chick"],
				category: 2
			},
			{
				emoji: "🐣",
				name: "HATCHING CHICK",
				added_in: "6.0",
				shortName: "hatching_chick",
				shortNames: ["hatching_chick"],
				category: 2
			},
			{
				emoji: "🌱",
				name: "SEEDLING",
				added_in: "6.0",
				shortName: "seedling",
				shortNames: ["seedling"],
				category: 2
			},
			{
				emoji: "🌲",
				name: "EVERGREEN TREE",
				added_in: "6.0",
				shortName: "evergreen_tree",
				shortNames: ["evergreen_tree"],
				category: 2
			},
			{
				emoji: "🌳",
				name: "DECIDUOUS TREE",
				added_in: "6.0",
				shortName: "deciduous_tree",
				shortNames: ["deciduous_tree"],
				category: 2
			},
			{
				emoji: "🌴",
				name: "PALM TREE",
				added_in: "6.0",
				shortName: "palm_tree",
				shortNames: ["palm_tree"],
				category: 2
			},
			{
				emoji: "🌵",
				name: "CACTUS",
				added_in: "6.0",
				shortName: "cactus",
				shortNames: ["cactus"],
				category: 2
			},
			{
				emoji: "🌷",
				name: "TULIP",
				added_in: "6.0",
				shortName: "tulip",
				shortNames: ["tulip"],
				category: 2
			},
			{
				emoji: "🌸",
				name: "CHERRY BLOSSOM",
				added_in: "6.0",
				shortName: "cherry_blossom",
				shortNames: ["cherry_blossom"],
				category: 2
			},
			{
				emoji: "🌹",
				name: "ROSE",
				added_in: "6.0",
				shortName: "rose",
				shortNames: ["rose"],
				category: 2
			},
			{
				emoji: "🌺",
				name: "HIBISCUS",
				added_in: "6.0",
				shortName: "hibiscus",
				shortNames: ["hibiscus"],
				category: 2
			},
			{
				emoji: "🌻",
				name: "SUNFLOWER",
				added_in: "6.0",
				shortName: "sunflower",
				shortNames: ["sunflower"],
				category: 2
			},
			{
				emoji: "🌼",
				name: "BLOSSOM",
				added_in: "6.0",
				shortName: "blossom",
				shortNames: ["blossom"],
				category: 2
			},
			{
				emoji: "🌾",
				name: "EAR OF RICE",
				added_in: "6.0",
				shortName: "ear_of_rice",
				shortNames: ["ear_of_rice"],
				category: 2
			},
			{
				emoji: "🌿",
				name: "HERB",
				added_in: "6.0",
				shortName: "herb",
				shortNames: ["herb"],
				category: 2
			},
			{
				emoji: "🍀",
				name: "FOUR LEAF CLOVER",
				added_in: "6.0",
				shortName: "four_leaf_clover",
				shortNames: ["four_leaf_clover"],
				category: 2
			},
			{
				emoji: "🍁",
				name: "MAPLE LEAF",
				added_in: "6.0",
				shortName: "maple_leaf",
				shortNames: ["maple_leaf"],
				category: 2
			},
			{
				emoji: "🍂",
				name: "FALLEN LEAF",
				added_in: "6.0",
				shortName: "fallen_leaf",
				shortNames: ["fallen_leaf"],
				category: 2
			},
			{
				emoji: "🍃",
				name: "LEAF FLUTTERING IN WIND",
				added_in: "6.0",
				shortName: "leaves",
				shortNames: ["leaves"],
				category: 2
			},
			{
				emoji: "🐀",
				name: "RAT",
				added_in: "6.0",
				shortName: "rat",
				shortNames: ["rat"],
				category: 2
			},
			{
				emoji: "🐁",
				name: "MOUSE",
				added_in: "6.0",
				shortName: "mouse2",
				shortNames: ["mouse2"],
				category: 2
			},
			{
				emoji: "🐂",
				name: "OX",
				added_in: "6.0",
				shortName: "ox",
				shortNames: ["ox"],
				category: 2
			},
			{
				emoji: "🐃",
				name: "WATER BUFFALO",
				added_in: "6.0",
				shortName: "water_buffalo",
				shortNames: ["water_buffalo"],
				category: 2
			},
			{
				emoji: "🐄",
				name: "COW",
				added_in: "6.0",
				shortName: "cow2",
				shortNames: ["cow2"],
				category: 2
			},
			{
				emoji: "🐅",
				name: "TIGER",
				added_in: "6.0",
				shortName: "tiger2",
				shortNames: ["tiger2"],
				category: 2
			},
			{
				emoji: "🐆",
				name: "LEOPARD",
				added_in: "6.0",
				shortName: "leopard",
				shortNames: ["leopard"],
				category: 2
			},
			{
				emoji: "🐇",
				name: "RABBIT",
				added_in: "6.0",
				shortName: "rabbit2",
				shortNames: ["rabbit2"],
				category: 2
			},
			{
				emoji: "🐈",
				name: "CAT",
				added_in: "6.0",
				shortName: "cat2",
				shortNames: ["cat2"],
				category: 2
			},
			{
				emoji: "🐉",
				name: "DRAGON",
				added_in: "6.0",
				shortName: "dragon",
				shortNames: ["dragon"],
				category: 2
			},
			{
				emoji: "🐊",
				name: "CROCODILE",
				added_in: "6.0",
				shortName: "crocodile",
				shortNames: ["crocodile"],
				category: 2
			},
			{
				emoji: "🐋",
				name: "WHALE",
				added_in: "6.0",
				shortName: "whale2",
				shortNames: ["whale2"],
				category: 2
			},
			{
				emoji: "🐌",
				name: "SNAIL",
				added_in: "6.0",
				shortName: "snail",
				shortNames: ["snail"],
				category: 2
			},
			{
				emoji: "🐍",
				name: "SNAKE",
				added_in: "6.0",
				shortName: "snake",
				shortNames: ["snake"],
				category: 2
			},
			{
				emoji: "🐎",
				name: "HORSE",
				added_in: "6.0",
				shortName: "racehorse",
				shortNames: ["racehorse"],
				category: 2
			},
			{
				emoji: "🐏",
				name: "RAM",
				added_in: "6.0",
				shortName: "ram",
				shortNames: ["ram"],
				category: 2
			},
			{
				emoji: "🐐",
				name: "GOAT",
				added_in: "6.0",
				shortName: "goat",
				shortNames: ["goat"],
				category: 2
			},
			{
				emoji: "🐑",
				name: "SHEEP",
				added_in: "6.0",
				shortName: "sheep",
				shortNames: ["sheep"],
				category: 2
			},
			{
				emoji: "🐓",
				name: "ROOSTER",
				added_in: "6.0",
				shortName: "rooster",
				shortNames: ["rooster"],
				category: 2
			},
			{
				emoji: "🐔",
				name: "CHICKEN",
				added_in: "6.0",
				shortName: "chicken",
				shortNames: ["chicken"],
				category: 2
			},
			{
				emoji: "🐕",
				name: "DOG",
				added_in: "6.0",
				shortName: "dog2",
				shortNames: ["dog2"],
				category: 2
			},
			{
				emoji: "🐖",
				name: "PIG",
				added_in: "6.0",
				shortName: "pig2",
				shortNames: ["pig2"],
				category: 2
			},
			{
				emoji: "🐗",
				name: "BOAR",
				added_in: "6.0",
				shortName: "boar",
				shortNames: ["boar"],
				category: 2
			},
			{
				emoji: "🐘",
				name: "ELEPHANT",
				added_in: "6.0",
				shortName: "elephant",
				shortNames: ["elephant"],
				category: 2
			},
			{
				emoji: "🐙",
				name: "OCTOPUS",
				added_in: "6.0",
				shortName: "octopus",
				shortNames: ["octopus"],
				category: 2
			},
			{
				emoji: "🐚",
				name: "SPIRAL SHELL",
				added_in: "6.0",
				shortName: "shell",
				shortNames: ["shell"],
				category: 2
			},
			{
				emoji: "🐛",
				name: "BUG",
				added_in: "6.0",
				shortName: "bug",
				shortNames: ["bug"],
				category: 2
			},
			{
				emoji: "🐜",
				name: "ANT",
				added_in: "6.0",
				shortName: "ant",
				shortNames: ["ant"],
				category: 2
			},
			{
				emoji: "🐝",
				name: "HONEYBEE",
				added_in: "6.0",
				shortName: "bee",
				shortNames: ["bee", "honeybee"],
				category: 2
			},
			{
				emoji: "🐞",
				name: "LADY BEETLE",
				added_in: "6.0",
				shortName: "beetle",
				shortNames: ["beetle"],
				category: 2
			},
			{
				emoji: "🐟",
				name: "FISH",
				added_in: "6.0",
				shortName: "fish",
				shortNames: ["fish"],
				category: 2
			},
			{
				emoji: "🐠",
				name: "TROPICAL FISH",
				added_in: "6.0",
				shortName: "tropical_fish",
				shortNames: ["tropical_fish"],
				category: 2
			},
			{
				emoji: "🐡",
				name: "BLOWFISH",
				added_in: "6.0",
				shortName: "blowfish",
				shortNames: ["blowfish"],
				category: 2
			},
			{
				emoji: "🐢",
				name: "TURTLE",
				added_in: "6.0",
				shortName: "turtle",
				shortNames: ["turtle"],
				category: 2
			},
			{
				emoji: "🐦",
				name: "BIRD",
				added_in: "6.0",
				shortName: "bird",
				shortNames: ["bird"],
				category: 2
			},
			{
				emoji: "🐧",
				name: "PENGUIN",
				added_in: "6.0",
				shortName: "penguin",
				shortNames: ["penguin"],
				category: 2
			},
			{
				emoji: "🐨",
				name: "KOALA",
				added_in: "6.0",
				shortName: "koala",
				shortNames: ["koala"],
				category: 2
			},
			{
				emoji: "🐩",
				name: "POODLE",
				added_in: "6.0",
				shortName: "poodle",
				shortNames: ["poodle"],
				category: 2
			},
			{
				emoji: "🐪",
				name: "DROMEDARY CAMEL",
				added_in: "6.0",
				shortName: "dromedary_camel",
				shortNames: ["dromedary_camel"],
				category: 2
			},
			{
				emoji: "🐫",
				name: "BACTRIAN CAMEL",
				added_in: "6.0",
				shortName: "camel",
				shortNames: ["camel"],
				category: 2
			},
			{
				emoji: "🐬",
				name: "DOLPHIN",
				added_in: "6.0",
				shortName: "dolphin",
				shortNames: ["dolphin", "flipper"],
				category: 2
			},
			{
				emoji: "🐳",
				name: "SPOUTING WHALE",
				added_in: "6.0",
				shortName: "whale",
				shortNames: ["whale"],
				category: 2
			},
			{
				emoji: "🐽",
				name: "PIG NOSE",
				added_in: "6.0",
				shortName: "pig_nose",
				shortNames: ["pig_nose"],
				category: 2
			},
			{
				emoji: "🐾",
				name: "PAW PRINTS",
				added_in: "6.0",
				shortName: "feet",
				shortNames: ["feet", "paw_prints"],
				category: 2
			},
			{
				emoji: "💐",
				name: "BOUQUET",
				added_in: "6.0",
				shortName: "bouquet",
				shortNames: ["bouquet"],
				category: 2
			},
			{
				emoji: "💮",
				name: "WHITE FLOWER",
				added_in: "6.0",
				shortName: "white_flower",
				shortNames: ["white_flower"],
				category: 2
			}
		],
		[
			{
				emoji: "🍤",
				name: "FRIED SHRIMP",
				added_in: "6.0",
				shortName: "fried_shrimp",
				shortNames: ["fried_shrimp"],
				category: 3
			},
			{
				emoji: "🍗",
				name: "POULTRY LEG",
				added_in: "6.0",
				shortName: "poultry_leg",
				shortNames: ["poultry_leg"],
				category: 3
			},
			{
				emoji: "🍵",
				name: "TEACUP WITHOUT HANDLE",
				added_in: "6.0",
				shortName: "tea",
				shortNames: ["tea"],
				category: 3
			},
			{
				emoji: "🍼",
				name: "BABY BOTTLE",
				added_in: "6.0",
				shortName: "baby_bottle",
				shortNames: ["baby_bottle"],
				category: 3
			},
			{
				emoji: "🌰",
				name: "CHESTNUT",
				added_in: "6.0",
				shortName: "chestnut",
				shortNames: ["chestnut"],
				category: 3
			},
			{
				emoji: "🌽",
				name: "EAR OF MAIZE",
				added_in: "6.0",
				shortName: "corn",
				shortNames: ["corn"],
				category: 3
			},
			{
				emoji: "🍄",
				name: "MUSHROOM",
				added_in: "6.0",
				shortName: "mushroom",
				shortNames: ["mushroom"],
				category: 3
			},
			{
				emoji: "🍅",
				name: "TOMATO",
				added_in: "6.0",
				shortName: "tomato",
				shortNames: ["tomato"],
				category: 3
			},
			{
				emoji: "🍆",
				name: "AUBERGINE",
				added_in: "6.0",
				shortName: "eggplant",
				shortNames: ["eggplant"],
				category: 3
			},
			{
				emoji: "🍇",
				name: "GRAPES",
				added_in: "6.0",
				shortName: "grapes",
				shortNames: ["grapes"],
				category: 3
			},
			{
				emoji: "🍈",
				name: "MELON",
				added_in: "6.0",
				shortName: "melon",
				shortNames: ["melon"],
				category: 3
			},
			{
				emoji: "🍉",
				name: "WATERMELON",
				added_in: "6.0",
				shortName: "watermelon",
				shortNames: ["watermelon"],
				category: 3
			},
			{
				emoji: "🍊",
				name: "TANGERINE",
				added_in: "6.0",
				shortName: "tangerine",
				shortNames: ["tangerine"],
				category: 3
			},
			{
				emoji: "🍋",
				name: "LEMON",
				added_in: "6.0",
				shortName: "lemon",
				shortNames: ["lemon"],
				category: 3
			},
			{
				emoji: "🍌",
				name: "BANANA",
				added_in: "6.0",
				shortName: "banana",
				shortNames: ["banana"],
				category: 3
			},
			{
				emoji: "🍍",
				name: "PINEAPPLE",
				added_in: "6.0",
				shortName: "pineapple",
				shortNames: ["pineapple"],
				category: 3
			},
			{
				emoji: "🍎",
				name: "RED APPLE",
				added_in: "6.0",
				shortName: "apple",
				shortNames: ["apple"],
				category: 3
			},
			{
				emoji: "🍏",
				name: "GREEN APPLE",
				added_in: "6.0",
				shortName: "green_apple",
				shortNames: ["green_apple"],
				category: 3
			},
			{
				emoji: "🍐",
				name: "PEAR",
				added_in: "6.0",
				shortName: "pear",
				shortNames: ["pear"],
				category: 3
			},
			{
				emoji: "🍑",
				name: "PEACH",
				added_in: "6.0",
				shortName: "peach",
				shortNames: ["peach"],
				category: 3
			},
			{
				emoji: "🍒",
				name: "CHERRIES",
				added_in: "6.0",
				shortName: "cherries",
				shortNames: ["cherries"],
				category: 3
			},
			{
				emoji: "🍓",
				name: "STRAWBERRY",
				added_in: "6.0",
				shortName: "strawberry",
				shortNames: ["strawberry"],
				category: 3
			},
			{
				emoji: "🍔",
				name: "HAMBURGER",
				added_in: "6.0",
				shortName: "hamburger",
				shortNames: ["hamburger"],
				category: 3
			},
			{
				emoji: "🍕",
				name: "SLICE OF PIZZA",
				added_in: "6.0",
				shortName: "pizza",
				shortNames: ["pizza"],
				category: 3
			},
			{
				emoji: "🍖",
				name: "MEAT ON BONE",
				added_in: "6.0",
				shortName: "meat_on_bone",
				shortNames: ["meat_on_bone"],
				category: 3
			},
			{
				emoji: "🍘",
				name: "RICE CRACKER",
				added_in: "6.0",
				shortName: "rice_cracker",
				shortNames: ["rice_cracker"],
				category: 3
			},
			{
				emoji: "🍙",
				name: "RICE BALL",
				added_in: "6.0",
				shortName: "rice_ball",
				shortNames: ["rice_ball"],
				category: 3
			},
			{
				emoji: "🍚",
				name: "COOKED RICE",
				added_in: "6.0",
				shortName: "rice",
				shortNames: ["rice"],
				category: 3
			},
			{
				emoji: "🍛",
				name: "CURRY AND RICE",
				added_in: "6.0",
				shortName: "curry",
				shortNames: ["curry"],
				category: 3
			},
			{
				emoji: "🍜",
				name: "STEAMING BOWL",
				added_in: "6.0",
				shortName: "ramen",
				shortNames: ["ramen"],
				category: 3
			},
			{
				emoji: "🍝",
				name: "SPAGHETTI",
				added_in: "6.0",
				shortName: "spaghetti",
				shortNames: ["spaghetti"],
				category: 3
			},
			{
				emoji: "🍞",
				name: "BREAD",
				added_in: "6.0",
				shortName: "bread",
				shortNames: ["bread"],
				category: 3
			},
			{
				emoji: "🍟",
				name: "FRENCH FRIES",
				added_in: "6.0",
				shortName: "fries",
				shortNames: ["fries"],
				category: 3
			},
			{
				emoji: "🍠",
				name: "ROASTED SWEET POTATO",
				added_in: "6.0",
				shortName: "sweet_potato",
				shortNames: ["sweet_potato"],
				category: 3
			},
			{
				emoji: "🍡",
				name: "DANGO",
				added_in: "6.0",
				shortName: "dango",
				shortNames: ["dango"],
				category: 3
			},
			{
				emoji: "🍢",
				name: "ODEN",
				added_in: "6.0",
				shortName: "oden",
				shortNames: ["oden"],
				category: 3
			},
			{
				emoji: "🍣",
				name: "SUSHI",
				added_in: "6.0",
				shortName: "sushi",
				shortNames: ["sushi"],
				category: 3
			},
			{
				emoji: "🍥",
				name: "FISH CAKE WITH SWIRL DESIGN",
				added_in: "6.0",
				shortName: "fish_cake",
				shortNames: ["fish_cake"],
				category: 3
			},
			{
				emoji: "🍦",
				name: "SOFT ICE CREAM",
				added_in: "6.0",
				shortName: "icecream",
				shortNames: ["icecream"],
				category: 3
			},
			{
				emoji: "🍧",
				name: "SHAVED ICE",
				added_in: "6.0",
				shortName: "shaved_ice",
				shortNames: ["shaved_ice"],
				category: 3
			},
			{
				emoji: "🍨",
				name: "ICE CREAM",
				added_in: "6.0",
				shortName: "ice_cream",
				shortNames: ["ice_cream"],
				category: 3
			},
			{
				emoji: "🍩",
				name: "DOUGHNUT",
				added_in: "6.0",
				shortName: "doughnut",
				shortNames: ["doughnut"],
				category: 3
			},
			{
				emoji: "🍪",
				name: "COOKIE",
				added_in: "6.0",
				shortName: "cookie",
				shortNames: ["cookie"],
				category: 3
			},
			{
				emoji: "🍫",
				name: "CHOCOLATE BAR",
				added_in: "6.0",
				shortName: "chocolate_bar",
				shortNames: ["chocolate_bar"],
				category: 3
			},
			{
				emoji: "🍬",
				name: "CANDY",
				added_in: "6.0",
				shortName: "candy",
				shortNames: ["candy"],
				category: 3
			},
			{
				emoji: "🍭",
				name: "LOLLIPOP",
				added_in: "6.0",
				shortName: "lollipop",
				shortNames: ["lollipop"],
				category: 3
			},
			{
				emoji: "🍮",
				name: "CUSTARD",
				added_in: "6.0",
				shortName: "custard",
				shortNames: ["custard"],
				category: 3
			},
			{
				emoji: "🍯",
				name: "HONEY POT",
				added_in: "6.0",
				shortName: "honey_pot",
				shortNames: ["honey_pot"],
				category: 3
			},
			{
				emoji: "🍰",
				name: "SHORTCAKE",
				added_in: "6.0",
				shortName: "cake",
				shortNames: ["cake"],
				category: 3
			},
			{
				emoji: "🍱",
				name: "BENTO BOX",
				added_in: "6.0",
				shortName: "bento",
				shortNames: ["bento"],
				category: 3
			},
			{
				emoji: "🍲",
				name: "POT OF FOOD",
				added_in: "6.0",
				shortName: "stew",
				shortNames: ["stew"],
				category: 3
			},
			{
				emoji: "🍳",
				name: "COOKING",
				added_in: "6.0",
				shortName: "fried_egg",
				shortNames: ["fried_egg", "cooking"],
				category: 3
			},
			{
				emoji: "🍴",
				name: "FORK AND KNIFE",
				added_in: "6.0",
				shortName: "fork_and_knife",
				shortNames: ["fork_and_knife"],
				category: 3
			},
			{
				emoji: "🍶",
				name: "SAKE BOTTLE AND CUP",
				added_in: "6.0",
				shortName: "sake",
				shortNames: ["sake"],
				category: 3
			},
			{
				emoji: "🍷",
				name: "WINE GLASS",
				added_in: "6.0",
				shortName: "wine_glass",
				shortNames: ["wine_glass"],
				category: 3
			},
			{
				emoji: "🍸",
				name: "COCKTAIL GLASS",
				added_in: "6.0",
				shortName: "cocktail",
				shortNames: ["cocktail"],
				category: 3
			},
			{
				emoji: "🍹",
				name: "TROPICAL DRINK",
				added_in: "6.0",
				shortName: "tropical_drink",
				shortNames: ["tropical_drink"],
				category: 3
			},
			{
				emoji: "🍺",
				name: "BEER MUG",
				added_in: "6.0",
				shortName: "beer",
				shortNames: ["beer"],
				category: 3
			},
			{
				emoji: "🍻",
				name: "CLINKING BEER MUGS",
				added_in: "6.0",
				shortName: "beers",
				shortNames: ["beers"],
				category: 3
			},
			{
				emoji: "🎂",
				name: "BIRTHDAY CAKE",
				added_in: "6.0",
				shortName: "birthday",
				shortNames: ["birthday"],
				category: 3
			},
			{
				emoji: "🔪",
				name: "HOCHO",
				added_in: "6.0",
				shortName: "hocho",
				shortNames: ["hocho", "knife"],
				category: 3
			},
			{
				emoji: "☕",
				name: "HOT BEVERAGE",
				added_in: "4.0",
				shortName: "coffee",
				shortNames: ["coffee"],
				category: 3
			}
		],
		[
			{
				emoji: "🎽",
				name: "RUNNING SHIRT WITH SASH",
				added_in: "6.0",
				shortName: "running_shirt_with_sash",
				shortNames: ["running_shirt_with_sash"],
				category: 4
			},
			{
				emoji: "🀄",
				name: "MAHJONG TILE RED DRAGON",
				added_in: "5.1",
				shortName: "mahjong",
				shortNames: ["mahjong"],
				category: 4
			},
			{
				emoji: "🃏",
				name: "PLAYING CARD BLACK JOKER",
				added_in: "6.0",
				shortName: "black_joker",
				shortNames: ["black_joker"],
				category: 4
			},
			{
				emoji: "🎀",
				name: "RIBBON",
				added_in: "6.0",
				shortName: "ribbon",
				shortNames: ["ribbon"],
				category: 4
			},
			{
				emoji: "🎁",
				name: "WRAPPED PRESENT",
				added_in: "6.0",
				shortName: "gift",
				shortNames: ["gift"],
				category: 4
			},
			{
				emoji: "🎃",
				name: "JACK-O-LANTERN",
				added_in: "6.0",
				shortName: "jack_o_lantern",
				shortNames: ["jack_o_lantern"],
				category: 4
			},
			{
				emoji: "🎄",
				name: "CHRISTMAS TREE",
				added_in: "6.0",
				shortName: "christmas_tree",
				shortNames: ["christmas_tree"],
				category: 4
			},
			{
				emoji: "🎆",
				name: "FIREWORKS",
				added_in: "6.0",
				shortName: "fireworks",
				shortNames: ["fireworks"],
				category: 4
			},
			{
				emoji: "🎇",
				name: "FIREWORK SPARKLER",
				added_in: "6.0",
				shortName: "sparkler",
				shortNames: ["sparkler"],
				category: 4
			},
			{
				emoji: "🎈",
				name: "BALLOON",
				added_in: "6.0",
				shortName: "balloon",
				shortNames: ["balloon"],
				category: 4
			},
			{
				emoji: "🎉",
				name: "PARTY POPPER",
				added_in: "6.0",
				shortName: "tada",
				shortNames: ["tada"],
				category: 4
			},
			{
				emoji: "🎊",
				name: "CONFETTI BALL",
				added_in: "6.0",
				shortName: "confetti_ball",
				shortNames: ["confetti_ball"],
				category: 4
			},
			{
				emoji: "🎋",
				name: "TANABATA TREE",
				added_in: "6.0",
				shortName: "tanabata_tree",
				shortNames: ["tanabata_tree"],
				category: 4
			},
			{
				emoji: "🎍",
				name: "PINE DECORATION",
				added_in: "6.0",
				shortName: "bamboo",
				shortNames: ["bamboo"],
				category: 4
			},
			{
				emoji: "🎎",
				name: "JAPANESE DOLLS",
				added_in: "6.0",
				shortName: "dolls",
				shortNames: ["dolls"],
				category: 4
			},
			{
				emoji: "🎏",
				name: "CARP STREAMER",
				added_in: "6.0",
				shortName: "flags",
				shortNames: ["flags"],
				category: 4
			},
			{
				emoji: "🎐",
				name: "WIND CHIME",
				added_in: "6.0",
				shortName: "wind_chime",
				shortNames: ["wind_chime"],
				category: 4
			},
			{
				emoji: "🎑",
				name: "MOON VIEWING CEREMONY",
				added_in: "6.0",
				shortName: "rice_scene",
				shortNames: ["rice_scene"],
				category: 4
			},
			{
				emoji: "🎣",
				name: "FISHING POLE AND FISH",
				added_in: "6.0",
				shortName: "fishing_pole_and_fish",
				shortNames: ["fishing_pole_and_fish"],
				category: 4
			},
			{
				emoji: "🎫",
				name: "TICKET",
				added_in: "6.0",
				shortName: "ticket",
				shortNames: ["ticket"],
				category: 4
			},
			{
				emoji: "🎮",
				name: "VIDEO GAME",
				added_in: "6.0",
				shortName: "video_game",
				shortNames: ["video_game"],
				category: 4
			},
			{
				emoji: "🎯",
				name: "DIRECT HIT",
				added_in: "6.0",
				shortName: "dart",
				shortNames: ["dart"],
				category: 4
			},
			{
				emoji: "🎱",
				name: "BILLIARDS",
				added_in: "6.0",
				shortName: "8ball",
				shortNames: ["8ball"],
				category: 4
			},
			{
				emoji: "🎲",
				name: "GAME DIE",
				added_in: "6.0",
				shortName: "game_die",
				shortNames: ["game_die"],
				category: 4
			},
			{
				emoji: "🎳",
				name: "BOWLING",
				added_in: "6.0",
				shortName: "bowling",
				shortNames: ["bowling"],
				category: 4
			},
			{
				emoji: "🎴",
				name: "FLOWER PLAYING CARDS",
				added_in: "6.0",
				shortName: "flower_playing_cards",
				shortNames: ["flower_playing_cards"],
				category: 4
			},
			{
				emoji: "🎾",
				name: "TENNIS RACQUET AND BALL",
				added_in: "6.0",
				shortName: "tennis",
				shortNames: ["tennis"],
				category: 4
			},
			{
				emoji: "🎿",
				name: "SKI AND SKI BOOT",
				added_in: "6.0",
				shortName: "ski",
				shortNames: ["ski"],
				category: 4
			},
			{
				emoji: "🏀",
				name: "BASKETBALL AND HOOP",
				added_in: "6.0",
				shortName: "basketball",
				shortNames: ["basketball"],
				category: 4
			},
			{
				emoji: "🏆",
				name: "TROPHY",
				added_in: "6.0",
				shortName: "trophy",
				shortNames: ["trophy"],
				category: 4
			},
			{
				emoji: "🏈",
				name: "AMERICAN FOOTBALL",
				added_in: "6.0",
				shortName: "football",
				shortNames: ["football"],
				category: 4
			},
			{
				emoji: "🏉",
				name: "RUGBY FOOTBALL",
				added_in: "6.0",
				shortName: "rugby_football",
				shortNames: ["rugby_football"],
				category: 4
			},
			{
				emoji: "♠️",
				name: "BLACK SPADE SUIT",
				added_in: "1.1",
				shortName: "spades",
				shortNames: ["spades"],
				category: 4
			},
			{
				emoji: "♣️",
				name: "BLACK CLUB SUIT",
				added_in: "1.1",
				shortName: "clubs",
				shortNames: ["clubs"],
				category: 4
			},
			{
				emoji: "♥️",
				name: "BLACK HEART SUIT",
				added_in: "1.1",
				shortName: "hearts",
				shortNames: ["hearts"],
				category: 4
			},
			{
				emoji: "♦️",
				name: "BLACK DIAMOND SUIT",
				added_in: "1.1",
				shortName: "diamonds",
				shortNames: ["diamonds"],
				category: 4
			},
			{
				emoji: "⚽",
				name: "SOCCER BALL",
				added_in: "5.2",
				shortName: "soccer",
				shortNames: ["soccer"],
				category: 4
			},
			{
				emoji: "⚾",
				name: "BASEBALL",
				added_in: "5.2",
				shortName: "baseball",
				shortNames: ["baseball"],
				category: 4
			},
			{
				emoji: "⛳",
				name: "FLAG IN HOLE",
				added_in: "5.2",
				shortName: "golf",
				shortNames: ["golf"],
				category: 4
			},
			{
				emoji: "✨",
				name: "SPARKLES",
				added_in: "6.0",
				shortName: "sparkles",
				shortNames: ["sparkles"],
				category: 4
			}
		],
		[
			{
				emoji: "🌚",
				name: "NEW MOON WITH FACE",
				added_in: "6.0",
				shortName: "new_moon_with_face",
				shortNames: ["new_moon_with_face"],
				category: 5
			},
			{
				emoji: "🌛",
				name: "FIRST QUARTER MOON WITH FACE",
				added_in: "6.0",
				shortName: "first_quarter_moon_with_face",
				shortNames: ["first_quarter_moon_with_face"],
				category: 5
			},
			{
				emoji: "🌜",
				name: "LAST QUARTER MOON WITH FACE",
				added_in: "6.0",
				shortName: "last_quarter_moon_with_face",
				shortNames: ["last_quarter_moon_with_face"],
				category: 5
			},
			{
				emoji: "🌝",
				name: "FULL MOON WITH FACE",
				added_in: "6.0",
				shortName: "full_moon_with_face",
				shortNames: ["full_moon_with_face"],
				category: 5
			},
			{
				emoji: "🌞",
				name: "SUN WITH FACE",
				added_in: "6.0",
				shortName: "sun_with_face",
				shortNames: ["sun_with_face"],
				category: 5
			},
			{
				emoji: "🕐",
				name: "CLOCK FACE ONE OCLOCK",
				added_in: "6.0",
				shortName: "clock1",
				shortNames: ["clock1"],
				category: 5
			},
			{
				emoji: "🕑",
				name: "CLOCK FACE TWO OCLOCK",
				added_in: "6.0",
				shortName: "clock2",
				shortNames: ["clock2"],
				category: 5
			},
			{
				emoji: "🕒",
				name: "CLOCK FACE THREE OCLOCK",
				added_in: "6.0",
				shortName: "clock3",
				shortNames: ["clock3"],
				category: 5
			},
			{
				emoji: "🕓",
				name: "CLOCK FACE FOUR OCLOCK",
				added_in: "6.0",
				shortName: "clock4",
				shortNames: ["clock4"],
				category: 5
			},
			{
				emoji: "🕔",
				name: "CLOCK FACE FIVE OCLOCK",
				added_in: "6.0",
				shortName: "clock5",
				shortNames: ["clock5"],
				category: 5
			},
			{
				emoji: "🕕",
				name: "CLOCK FACE SIX OCLOCK",
				added_in: "6.0",
				shortName: "clock6",
				shortNames: ["clock6"],
				category: 5
			},
			{
				emoji: "🕖",
				name: "CLOCK FACE SEVEN OCLOCK",
				added_in: "6.0",
				shortName: "clock7",
				shortNames: ["clock7"],
				category: 5
			},
			{
				emoji: "🕗",
				name: "CLOCK FACE EIGHT OCLOCK",
				added_in: "6.0",
				shortName: "clock8",
				shortNames: ["clock8"],
				category: 5
			},
			{
				emoji: "🕘",
				name: "CLOCK FACE NINE OCLOCK",
				added_in: "6.0",
				shortName: "clock9",
				shortNames: ["clock9"],
				category: 5
			},
			{
				emoji: "🕙",
				name: "CLOCK FACE TEN OCLOCK",
				added_in: "6.0",
				shortName: "clock10",
				shortNames: ["clock10"],
				category: 5
			},
			{
				emoji: "🕚",
				name: "CLOCK FACE ELEVEN OCLOCK",
				added_in: "6.0",
				shortName: "clock11",
				shortNames: ["clock11"],
				category: 5
			},
			{
				emoji: "🕛",
				name: "CLOCK FACE TWELVE OCLOCK",
				added_in: "6.0",
				shortName: "clock12",
				shortNames: ["clock12"],
				category: 5
			},
			{
				emoji: "🕜",
				name: "CLOCK FACE ONE-THIRTY",
				added_in: "6.0",
				shortName: "clock130",
				shortNames: ["clock130"],
				category: 5
			},
			{
				emoji: "🕝",
				name: "CLOCK FACE TWO-THIRTY",
				added_in: "6.0",
				shortName: "clock230",
				shortNames: ["clock230"],
				category: 5
			},
			{
				emoji: "🕞",
				name: "CLOCK FACE THREE-THIRTY",
				added_in: "6.0",
				shortName: "clock330",
				shortNames: ["clock330"],
				category: 5
			},
			{
				emoji: "🕟",
				name: "CLOCK FACE FOUR-THIRTY",
				added_in: "6.0",
				shortName: "clock430",
				shortNames: ["clock430"],
				category: 5
			},
			{
				emoji: "🕠",
				name: "CLOCK FACE FIVE-THIRTY",
				added_in: "6.0",
				shortName: "clock530",
				shortNames: ["clock530"],
				category: 5
			},
			{
				emoji: "🕡",
				name: "CLOCK FACE SIX-THIRTY",
				added_in: "6.0",
				shortName: "clock630",
				shortNames: ["clock630"],
				category: 5
			},
			{
				emoji: "🕢",
				name: "CLOCK FACE SEVEN-THIRTY",
				added_in: "6.0",
				shortName: "clock730",
				shortNames: ["clock730"],
				category: 5
			},
			{
				emoji: "🕣",
				name: "CLOCK FACE EIGHT-THIRTY",
				added_in: "6.0",
				shortName: "clock830",
				shortNames: ["clock830"],
				category: 5
			},
			{
				emoji: "🕤",
				name: "CLOCK FACE NINE-THIRTY",
				added_in: "6.0",
				shortName: "clock930",
				shortNames: ["clock930"],
				category: 5
			},
			{
				emoji: "🕥",
				name: "CLOCK FACE TEN-THIRTY",
				added_in: "6.0",
				shortName: "clock1030",
				shortNames: ["clock1030"],
				category: 5
			},
			{
				emoji: "🕦",
				name: "CLOCK FACE ELEVEN-THIRTY",
				added_in: "6.0",
				shortName: "clock1130",
				shortNames: ["clock1130"],
				category: 5
			},
			{
				emoji: "🕧",
				name: "CLOCK FACE TWELVE-THIRTY",
				added_in: "6.0",
				shortName: "clock1230",
				shortNames: ["clock1230"],
				category: 5
			},
			{
				emoji: "⛄",
				name: "SNOWMAN WITHOUT SNOW",
				added_in: "5.2",
				shortName: "snowman_without_snow",
				shortNames: ["snowman_without_snow"],
				category: 5
			},
			{
				emoji: "🌀",
				name: "CYCLONE",
				added_in: "6.0",
				shortName: "cyclone",
				shortNames: ["cyclone"],
				category: 5
			},
			{
				emoji: "🌁",
				name: "FOGGY",
				added_in: "6.0",
				shortName: "foggy",
				shortNames: ["foggy"],
				category: 5
			},
			{
				emoji: "🌂",
				name: "CLOSED UMBRELLA",
				added_in: "6.0",
				shortName: "closed_umbrella",
				shortNames: ["closed_umbrella"],
				category: 5
			},
			{
				emoji: "🌃",
				name: "NIGHT WITH STARS",
				added_in: "6.0",
				shortName: "night_with_stars",
				shortNames: ["night_with_stars"],
				category: 5
			},
			{
				emoji: "🌄",
				name: "SUNRISE OVER MOUNTAINS",
				added_in: "6.0",
				shortName: "sunrise_over_mountains",
				shortNames: ["sunrise_over_mountains"],
				category: 5
			},
			{
				emoji: "🌅",
				name: "SUNRISE",
				added_in: "6.0",
				shortName: "sunrise",
				shortNames: ["sunrise"],
				category: 5
			},
			{
				emoji: "🌆",
				name: "CITYSCAPE AT DUSK",
				added_in: "6.0",
				shortName: "city_sunset",
				shortNames: ["city_sunset"],
				category: 5
			},
			{
				emoji: "🌇",
				name: "SUNSET OVER BUILDINGS",
				added_in: "6.0",
				shortName: "city_sunrise",
				shortNames: ["city_sunrise"],
				category: 5
			},
			{
				emoji: "🌈",
				name: "RAINBOW",
				added_in: "6.0",
				shortName: "rainbow",
				shortNames: ["rainbow"],
				category: 5
			},
			{
				emoji: "🌉",
				name: "BRIDGE AT NIGHT",
				added_in: "6.0",
				shortName: "bridge_at_night",
				shortNames: ["bridge_at_night"],
				category: 5
			},
			{
				emoji: "🌊",
				name: "WATER WAVE",
				added_in: "6.0",
				shortName: "ocean",
				shortNames: ["ocean"],
				category: 5
			},
			{
				emoji: "🌋",
				name: "VOLCANO",
				added_in: "6.0",
				shortName: "volcano",
				shortNames: ["volcano"],
				category: 5
			},
			{
				emoji: "🌌",
				name: "MILKY WAY",
				added_in: "6.0",
				shortName: "milky_way",
				shortNames: ["milky_way"],
				category: 5
			},
			{
				emoji: "🌍",
				name: "EARTH GLOBE EUROPE-AFRICA",
				added_in: "6.0",
				shortName: "earth_africa",
				shortNames: ["earth_africa"],
				category: 5
			},
			{
				emoji: "🌎",
				name: "EARTH GLOBE AMERICAS",
				added_in: "6.0",
				shortName: "earth_americas",
				shortNames: ["earth_americas"],
				category: 5
			},
			{
				emoji: "🌏",
				name: "EARTH GLOBE ASIA-AUSTRALIA",
				added_in: "6.0",
				shortName: "earth_asia",
				shortNames: ["earth_asia"],
				category: 5
			},
			{
				emoji: "🌐",
				name: "GLOBE WITH MERIDIANS",
				added_in: "6.0",
				shortName: "globe_with_meridians",
				shortNames: ["globe_with_meridians"],
				category: 5
			},
			{
				emoji: "🌑",
				name: "NEW MOON SYMBOL",
				added_in: "6.0",
				shortName: "new_moon",
				shortNames: ["new_moon"],
				category: 5
			},
			{
				emoji: "🌒",
				name: "WAXING CRESCENT MOON SYMBOL",
				added_in: "6.0",
				shortName: "waxing_crescent_moon",
				shortNames: ["waxing_crescent_moon"],
				category: 5
			},
			{
				emoji: "🌓",
				name: "FIRST QUARTER MOON SYMBOL",
				added_in: "6.0",
				shortName: "first_quarter_moon",
				shortNames: ["first_quarter_moon"],
				category: 5
			},
			{
				emoji: "🌔",
				name: "WAXING GIBBOUS MOON SYMBOL",
				added_in: "6.0",
				shortName: "moon",
				shortNames: ["moon", "waxing_gibbous_moon"],
				category: 5
			},
			{
				emoji: "🌕",
				name: "FULL MOON SYMBOL",
				added_in: "6.0",
				shortName: "full_moon",
				shortNames: ["full_moon"],
				category: 5
			},
			{
				emoji: "🌖",
				name: "WANING GIBBOUS MOON SYMBOL",
				added_in: "6.0",
				shortName: "waning_gibbous_moon",
				shortNames: ["waning_gibbous_moon"],
				category: 5
			},
			{
				emoji: "🌗",
				name: "LAST QUARTER MOON SYMBOL",
				added_in: "6.0",
				shortName: "last_quarter_moon",
				shortNames: ["last_quarter_moon"],
				category: 5
			},
			{
				emoji: "🌘",
				name: "WANING CRESCENT MOON SYMBOL",
				added_in: "6.0",
				shortName: "waning_crescent_moon",
				shortNames: ["waning_crescent_moon"],
				category: 5
			},
			{
				emoji: "🌙",
				name: "CRESCENT MOON",
				added_in: "6.0",
				shortName: "crescent_moon",
				shortNames: ["crescent_moon"],
				category: 5
			},
			{
				emoji: "🌟",
				name: "GLOWING STAR",
				added_in: "6.0",
				shortName: "star2",
				shortNames: ["star2"],
				category: 5
			},
			{
				emoji: "🌠",
				name: "SHOOTING STAR",
				added_in: "6.0",
				shortName: "stars",
				shortNames: ["stars"],
				category: 5
			},
			{
				emoji: "🎠",
				name: "CAROUSEL HORSE",
				added_in: "6.0",
				shortName: "carousel_horse",
				shortNames: ["carousel_horse"],
				category: 5
			},
			{
				emoji: "🎡",
				name: "FERRIS WHEEL",
				added_in: "6.0",
				shortName: "ferris_wheel",
				shortNames: ["ferris_wheel"],
				category: 5
			},
			{
				emoji: "🎢",
				name: "ROLLER COASTER",
				added_in: "6.0",
				shortName: "roller_coaster",
				shortNames: ["roller_coaster"],
				category: 5
			},
			{
				emoji: "🎨",
				name: "ARTIST PALETTE",
				added_in: "6.0",
				shortName: "art",
				shortNames: ["art"],
				category: 5
			},
			{
				emoji: "🎪",
				name: "CIRCUS TENT",
				added_in: "6.0",
				shortName: "circus_tent",
				shortNames: ["circus_tent"],
				category: 5
			},
			{
				emoji: "🎭",
				name: "PERFORMING ARTS",
				added_in: "6.0",
				shortName: "performing_arts",
				shortNames: ["performing_arts"],
				category: 5
			},
			{
				emoji: "🎰",
				name: "SLOT MACHINE",
				added_in: "6.0",
				shortName: "slot_machine",
				shortNames: ["slot_machine"],
				category: 5
			},
			{
				emoji: "🏠",
				name: "HOUSE BUILDING",
				added_in: "6.0",
				shortName: "house",
				shortNames: ["house"],
				category: 5
			},
			{
				emoji: "🏡",
				name: "HOUSE WITH GARDEN",
				added_in: "6.0",
				shortName: "house_with_garden",
				shortNames: ["house_with_garden"],
				category: 5
			},
			{
				emoji: "🏢",
				name: "OFFICE BUILDING",
				added_in: "6.0",
				shortName: "office",
				shortNames: ["office"],
				category: 5
			},
			{
				emoji: "🏣",
				name: "JAPANESE POST OFFICE",
				added_in: "6.0",
				shortName: "post_office",
				shortNames: ["post_office"],
				category: 5
			},
			{
				emoji: "🏤",
				name: "EUROPEAN POST OFFICE",
				added_in: "6.0",
				shortName: "european_post_office",
				shortNames: ["european_post_office"],
				category: 5
			},
			{
				emoji: "🏥",
				name: "HOSPITAL",
				added_in: "6.0",
				shortName: "hospital",
				shortNames: ["hospital"],
				category: 5
			},
			{
				emoji: "🏦",
				name: "BANK",
				added_in: "6.0",
				shortName: "bank",
				shortNames: ["bank"],
				category: 5
			},
			{
				emoji: "🏨",
				name: "HOTEL",
				added_in: "6.0",
				shortName: "hotel",
				shortNames: ["hotel"],
				category: 5
			},
			{
				emoji: "🏩",
				name: "LOVE HOTEL",
				added_in: "6.0",
				shortName: "love_hotel",
				shortNames: ["love_hotel"],
				category: 5
			},
			{
				emoji: "🏪",
				name: "CONVENIENCE STORE",
				added_in: "6.0",
				shortName: "convenience_store",
				shortNames: ["convenience_store"],
				category: 5
			},
			{
				emoji: "🏫",
				name: "SCHOOL",
				added_in: "6.0",
				shortName: "school",
				shortNames: ["school"],
				category: 5
			},
			{
				emoji: "🏬",
				name: "DEPARTMENT STORE",
				added_in: "6.0",
				shortName: "department_store",
				shortNames: ["department_store"],
				category: 5
			},
			{
				emoji: "🏭",
				name: "FACTORY",
				added_in: "6.0",
				shortName: "factory",
				shortNames: ["factory"],
				category: 5
			},
			{
				emoji: "🏯",
				name: "JAPANESE CASTLE",
				added_in: "6.0",
				shortName: "japanese_castle",
				shortNames: ["japanese_castle"],
				category: 5
			},
			{
				emoji: "🏰",
				name: "EUROPEAN CASTLE",
				added_in: "6.0",
				shortName: "european_castle",
				shortNames: ["european_castle"],
				category: 5
			},
			{
				emoji: "💈",
				name: "BARBER POLE",
				added_in: "6.0",
				shortName: "barber",
				shortNames: ["barber"],
				category: 5
			},
			{
				emoji: "💒",
				name: "WEDDING",
				added_in: "6.0",
				shortName: "wedding",
				shortNames: ["wedding"],
				category: 5
			},
			{
				emoji: "💧",
				name: "DROPLET",
				added_in: "6.0",
				shortName: "droplet",
				shortNames: ["droplet"],
				category: 5
			},
			{
				emoji: "💺",
				name: "SEAT",
				added_in: "6.0",
				shortName: "seat",
				shortNames: ["seat"],
				category: 5
			},
			{
				emoji: "🔥",
				name: "FIRE",
				added_in: "6.0",
				shortName: "fire",
				shortNames: ["fire"],
				category: 5
			},
			{
				emoji: "🗻",
				name: "MOUNT FUJI",
				added_in: "6.0",
				shortName: "mount_fuji",
				shortNames: ["mount_fuji"],
				category: 5
			},
			{
				emoji: "🗼",
				name: "TOKYO TOWER",
				added_in: "6.0",
				shortName: "tokyo_tower",
				shortNames: ["tokyo_tower"],
				category: 5
			},
			{
				emoji: "🗽",
				name: "STATUE OF LIBERTY",
				added_in: "6.0",
				shortName: "statue_of_liberty",
				shortNames: ["statue_of_liberty"],
				category: 5
			},
			{
				emoji: "🗾",
				name: "SILHOUETTE OF JAPAN",
				added_in: "6.0",
				shortName: "japan",
				shortNames: ["japan"],
				category: 5
			},
			{
				emoji: "🚀",
				name: "ROCKET",
				added_in: "6.0",
				shortName: "rocket",
				shortNames: ["rocket"],
				category: 5
			},
			{
				emoji: "🚁",
				name: "HELICOPTER",
				added_in: "6.0",
				shortName: "helicopter",
				shortNames: ["helicopter"],
				category: 5
			},
			{
				emoji: "🚂",
				name: "STEAM LOCOMOTIVE",
				added_in: "6.0",
				shortName: "steam_locomotive",
				shortNames: ["steam_locomotive"],
				category: 5
			},
			{
				emoji: "🚃",
				name: "RAILWAY CAR",
				added_in: "6.0",
				shortName: "railway_car",
				shortNames: ["railway_car"],
				category: 5
			},
			{
				emoji: "🚄",
				name: "HIGH-SPEED TRAIN",
				added_in: "6.0",
				shortName: "bullettrain_side",
				shortNames: ["bullettrain_side"],
				category: 5
			},
			{
				emoji: "🚅",
				name: "HIGH-SPEED TRAIN WITH BULLET NOSE",
				added_in: "6.0",
				shortName: "bullettrain_front",
				shortNames: ["bullettrain_front"],
				category: 5
			},
			{
				emoji: "🚆",
				name: "TRAIN",
				added_in: "6.0",
				shortName: "train2",
				shortNames: ["train2"],
				category: 5
			},
			{
				emoji: "🚇",
				name: "METRO",
				added_in: "6.0",
				shortName: "metro",
				shortNames: ["metro"],
				category: 5
			},
			{
				emoji: "🚈",
				name: "LIGHT RAIL",
				added_in: "6.0",
				shortName: "light_rail",
				shortNames: ["light_rail"],
				category: 5
			},
			{
				emoji: "🚉",
				name: "STATION",
				added_in: "6.0",
				shortName: "station",
				shortNames: ["station"],
				category: 5
			},
			{
				emoji: "🚊",
				name: "TRAM",
				added_in: "6.0",
				shortName: "tram",
				shortNames: ["tram"],
				category: 5
			},
			{
				emoji: "🚋",
				name: "TRAM CAR",
				added_in: "6.0",
				shortName: "train",
				shortNames: ["train"],
				category: 5
			},
			{
				emoji: "🚌",
				name: "BUS",
				added_in: "6.0",
				shortName: "bus",
				shortNames: ["bus"],
				category: 5
			},
			{
				emoji: "🚍",
				name: "ONCOMING BUS",
				added_in: "6.0",
				shortName: "oncoming_bus",
				shortNames: ["oncoming_bus"],
				category: 5
			},
			{
				emoji: "🚎",
				name: "TROLLEYBUS",
				added_in: "6.0",
				shortName: "trolleybus",
				shortNames: ["trolleybus"],
				category: 5
			},
			{
				emoji: "🚏",
				name: "BUS STOP",
				added_in: "6.0",
				shortName: "busstop",
				shortNames: ["busstop"],
				category: 5
			},
			{
				emoji: "🚐",
				name: "MINIBUS",
				added_in: "6.0",
				shortName: "minibus",
				shortNames: ["minibus"],
				category: 5
			},
			{
				emoji: "🚑",
				name: "AMBULANCE",
				added_in: "6.0",
				shortName: "ambulance",
				shortNames: ["ambulance"],
				category: 5
			},
			{
				emoji: "🚒",
				name: "FIRE ENGINE",
				added_in: "6.0",
				shortName: "fire_engine",
				shortNames: ["fire_engine"],
				category: 5
			},
			{
				emoji: "🚓",
				name: "POLICE CAR",
				added_in: "6.0",
				shortName: "police_car",
				shortNames: ["police_car"],
				category: 5
			},
			{
				emoji: "🚔",
				name: "ONCOMING POLICE CAR",
				added_in: "6.0",
				shortName: "oncoming_police_car",
				shortNames: ["oncoming_police_car"],
				category: 5
			},
			{
				emoji: "🚕",
				name: "TAXI",
				added_in: "6.0",
				shortName: "taxi",
				shortNames: ["taxi"],
				category: 5
			},
			{
				emoji: "🚖",
				name: "ONCOMING TAXI",
				added_in: "6.0",
				shortName: "oncoming_taxi",
				shortNames: ["oncoming_taxi"],
				category: 5
			},
			{
				emoji: "🚗",
				name: "AUTOMOBILE",
				added_in: "6.0",
				shortName: "car",
				shortNames: ["car", "red_car"],
				category: 5
			},
			{
				emoji: "🚘",
				name: "ONCOMING AUTOMOBILE",
				added_in: "6.0",
				shortName: "oncoming_automobile",
				shortNames: ["oncoming_automobile"],
				category: 5
			},
			{
				emoji: "🚙",
				name: "RECREATIONAL VEHICLE",
				added_in: "6.0",
				shortName: "blue_car",
				shortNames: ["blue_car"],
				category: 5
			},
			{
				emoji: "🚚",
				name: "DELIVERY TRUCK",
				added_in: "6.0",
				shortName: "truck",
				shortNames: ["truck"],
				category: 5
			},
			{
				emoji: "🚛",
				name: "ARTICULATED LORRY",
				added_in: "6.0",
				shortName: "articulated_lorry",
				shortNames: ["articulated_lorry"],
				category: 5
			},
			{
				emoji: "🚜",
				name: "TRACTOR",
				added_in: "6.0",
				shortName: "tractor",
				shortNames: ["tractor"],
				category: 5
			},
			{
				emoji: "🚝",
				name: "MONORAIL",
				added_in: "6.0",
				shortName: "monorail",
				shortNames: ["monorail"],
				category: 5
			},
			{
				emoji: "🚞",
				name: "MOUNTAIN RAILWAY",
				added_in: "6.0",
				shortName: "mountain_railway",
				shortNames: ["mountain_railway"],
				category: 5
			},
			{
				emoji: "🚟",
				name: "SUSPENSION RAILWAY",
				added_in: "6.0",
				shortName: "suspension_railway",
				shortNames: ["suspension_railway"],
				category: 5
			},
			{
				emoji: "🚠",
				name: "MOUNTAIN CABLEWAY",
				added_in: "6.0",
				shortName: "mountain_cableway",
				shortNames: ["mountain_cableway"],
				category: 5
			},
			{
				emoji: "🚡",
				name: "AERIAL TRAMWAY",
				added_in: "6.0",
				shortName: "aerial_tramway",
				shortNames: ["aerial_tramway"],
				category: 5
			},
			{
				emoji: "🚢",
				name: "SHIP",
				added_in: "6.0",
				shortName: "ship",
				shortNames: ["ship"],
				category: 5
			},
			{
				emoji: "🚤",
				name: "SPEEDBOAT",
				added_in: "6.0",
				shortName: "speedboat",
				shortNames: ["speedboat"],
				category: 5
			},
			{
				emoji: "🚥",
				name: "HORIZONTAL TRAFFIC LIGHT",
				added_in: "6.0",
				shortName: "traffic_light",
				shortNames: ["traffic_light"],
				category: 5
			},
			{
				emoji: "🚦",
				name: "VERTICAL TRAFFIC LIGHT",
				added_in: "6.0",
				shortName: "vertical_traffic_light",
				shortNames: ["vertical_traffic_light"],
				category: 5
			},
			{
				emoji: "🚧",
				name: "CONSTRUCTION SIGN",
				added_in: "6.0",
				shortName: "construction",
				shortNames: ["construction"],
				category: 5
			},
			{
				emoji: "🚨",
				name: "POLICE CARS REVOLVING LIGHT",
				added_in: "6.0",
				shortName: "rotating_light",
				shortNames: ["rotating_light"],
				category: 5
			},
			{
				emoji: "🚪",
				name: "DOOR",
				added_in: "6.0",
				shortName: "door",
				shortNames: ["door"],
				category: 5
			},
			{
				emoji: "🚲",
				name: "BICYCLE",
				added_in: "6.0",
				shortName: "bike",
				shortNames: ["bike"],
				category: 5
			},
			{
				emoji: "🚽",
				name: "TOILET",
				added_in: "6.0",
				shortName: "toilet",
				shortNames: ["toilet"],
				category: 5
			},
			{
				emoji: "🚿",
				name: "SHOWER",
				added_in: "6.0",
				shortName: "shower",
				shortNames: ["shower"],
				category: 5
			},
			{
				emoji: "🛁",
				name: "BATHTUB",
				added_in: "6.0",
				shortName: "bathtub",
				shortNames: ["bathtub"],
				category: 5
			},
			{
				emoji: "⌚",
				name: "WATCH",
				added_in: "1.1",
				shortName: "watch",
				shortNames: ["watch"],
				category: 5
			},
			{
				emoji: "⌛",
				name: "HOURGLASS",
				added_in: "1.1",
				shortName: "hourglass",
				shortNames: ["hourglass"],
				category: 5
			},
			{
				emoji: "⏰",
				name: "ALARM CLOCK",
				added_in: "6.0",
				shortName: "alarm_clock",
				shortNames: ["alarm_clock"],
				category: 5
			},
			{
				emoji: "⏳",
				name: "HOURGLASS WITH FLOWING SAND",
				added_in: "6.0",
				shortName: "hourglass_flowing_sand",
				shortNames: ["hourglass_flowing_sand"],
				category: 5
			},
			{
				emoji: "☀️",
				name: "BLACK SUN WITH RAYS",
				added_in: "1.1",
				shortName: "sunny",
				shortNames: ["sunny"],
				category: 5
			},
			{
				emoji: "☁️",
				name: "CLOUD",
				added_in: "1.1",
				shortName: "cloud",
				shortNames: ["cloud"],
				category: 5
			},
			{
				emoji: "☔",
				name: "UMBRELLA WITH RAIN DROPS",
				added_in: "4.0",
				shortName: "umbrella_with_rain_drops",
				shortNames: ["umbrella_with_rain_drops"],
				category: 5
			},
			{
				emoji: "♨️",
				name: "HOT SPRINGS",
				added_in: "1.1",
				shortName: "hotsprings",
				shortNames: ["hotsprings"],
				category: 5
			},
			{
				emoji: "⚓",
				name: "ANCHOR",
				added_in: "4.1",
				shortName: "anchor",
				shortNames: ["anchor"],
				category: 5
			},
			{
				emoji: "⚡",
				name: "HIGH VOLTAGE SIGN",
				added_in: "4.0",
				shortName: "zap",
				shortNames: ["zap"],
				category: 5
			},
			{
				emoji: "⛅",
				name: "SUN BEHIND CLOUD",
				added_in: "5.2",
				shortName: "partly_sunny",
				shortNames: ["partly_sunny"],
				category: 5
			},
			{
				emoji: "⛪",
				name: "CHURCH",
				added_in: "5.2",
				shortName: "church",
				shortNames: ["church"],
				category: 5
			},
			{
				emoji: "⛲",
				name: "FOUNTAIN",
				added_in: "5.2",
				shortName: "fountain",
				shortNames: ["fountain"],
				category: 5
			},
			{
				emoji: "⛵",
				name: "SAILBOAT",
				added_in: "5.2",
				shortName: "boat",
				shortNames: ["boat", "sailboat"],
				category: 5
			},
			{
				emoji: "⛺",
				name: "TENT",
				added_in: "5.2",
				shortName: "tent",
				shortNames: ["tent"],
				category: 5
			},
			{
				emoji: "⛽",
				name: "FUEL PUMP",
				added_in: "5.2",
				shortName: "fuelpump",
				shortNames: ["fuelpump"],
				category: 5
			},
			{
				emoji: "✈️",
				name: "AIRPLANE",
				added_in: "1.1",
				shortName: "airplane",
				shortNames: ["airplane"],
				category: 5
			},
			{
				emoji: "❄️",
				name: "SNOWFLAKE",
				added_in: "1.1",
				shortName: "snowflake",
				shortNames: ["snowflake"],
				category: 5
			},
			{
				emoji: "⭐",
				name: "WHITE MEDIUM STAR",
				added_in: "5.1",
				shortName: "star",
				shortNames: ["star"],
				category: 5
			}
		],
		[
			{
				emoji: "📇",
				name: "CARD INDEX",
				added_in: "6.0",
				shortName: "card_index",
				shortNames: ["card_index"],
				category: 6
			},
			{
				emoji: "🎤",
				name: "MICROPHONE",
				added_in: "6.0",
				shortName: "microphone",
				shortNames: ["microphone"],
				category: 6
			},
			{
				emoji: "🎥",
				name: "MOVIE CAMERA",
				added_in: "6.0",
				shortName: "movie_camera",
				shortNames: ["movie_camera"],
				category: 6
			},
			{
				emoji: "🎧",
				name: "HEADPHONE",
				added_in: "6.0",
				shortName: "headphones",
				shortNames: ["headphones"],
				category: 6
			},
			{
				emoji: "🎬",
				name: "CLAPPER BOARD",
				added_in: "6.0",
				shortName: "clapper",
				shortNames: ["clapper"],
				category: 6
			},
			{
				emoji: "🎵",
				name: "MUSICAL NOTE",
				added_in: "6.0",
				shortName: "musical_note",
				shortNames: ["musical_note"],
				category: 6
			},
			{
				emoji: "🎶",
				name: "MULTIPLE MUSICAL NOTES",
				added_in: "6.0",
				shortName: "notes",
				shortNames: ["notes"],
				category: 6
			},
			{
				emoji: "🎷",
				name: "SAXOPHONE",
				added_in: "6.0",
				shortName: "saxophone",
				shortNames: ["saxophone"],
				category: 6
			},
			{
				emoji: "🎸",
				name: "GUITAR",
				added_in: "6.0",
				shortName: "guitar",
				shortNames: ["guitar"],
				category: 6
			},
			{
				emoji: "🎹",
				name: "MUSICAL KEYBOARD",
				added_in: "6.0",
				shortName: "musical_keyboard",
				shortNames: ["musical_keyboard"],
				category: 6
			},
			{
				emoji: "🎺",
				name: "TRUMPET",
				added_in: "6.0",
				shortName: "trumpet",
				shortNames: ["trumpet"],
				category: 6
			},
			{
				emoji: "🎻",
				name: "VIOLIN",
				added_in: "6.0",
				shortName: "violin",
				shortNames: ["violin"],
				category: 6
			},
			{
				emoji: "🎼",
				name: "MUSICAL SCORE",
				added_in: "6.0",
				shortName: "musical_score",
				shortNames: ["musical_score"],
				category: 6
			},
			{
				emoji: "🏮",
				name: "IZAKAYA LANTERN",
				added_in: "6.0",
				shortName: "izakaya_lantern",
				shortNames: ["izakaya_lantern", "lantern"],
				category: 6
			},
			{
				emoji: "💉",
				name: "SYRINGE",
				added_in: "6.0",
				shortName: "syringe",
				shortNames: ["syringe"],
				category: 6
			},
			{
				emoji: "💊",
				name: "PILL",
				added_in: "6.0",
				shortName: "pill",
				shortNames: ["pill"],
				category: 6
			},
			{
				emoji: "💡",
				name: "ELECTRIC LIGHT BULB",
				added_in: "6.0",
				shortName: "bulb",
				shortNames: ["bulb"],
				category: 6
			},
			{
				emoji: "💰",
				name: "MONEY BAG",
				added_in: "6.0",
				shortName: "moneybag",
				shortNames: ["moneybag"],
				category: 6
			},
			{
				emoji: "💱",
				name: "CURRENCY EXCHANGE",
				added_in: "6.0",
				shortName: "currency_exchange",
				shortNames: ["currency_exchange"],
				category: 6
			},
			{
				emoji: "💲",
				name: "HEAVY DOLLAR SIGN",
				added_in: "6.0",
				shortName: "heavy_dollar_sign",
				shortNames: ["heavy_dollar_sign"],
				category: 6
			},
			{
				emoji: "💳",
				name: "CREDIT CARD",
				added_in: "6.0",
				shortName: "credit_card",
				shortNames: ["credit_card"],
				category: 6
			},
			{
				emoji: "💴",
				name: "BANKNOTE WITH YEN SIGN",
				added_in: "6.0",
				shortName: "yen",
				shortNames: ["yen"],
				category: 6
			},
			{
				emoji: "💵",
				name: "BANKNOTE WITH DOLLAR SIGN",
				added_in: "6.0",
				shortName: "dollar",
				shortNames: ["dollar"],
				category: 6
			},
			{
				emoji: "💶",
				name: "BANKNOTE WITH EURO SIGN",
				added_in: "6.0",
				shortName: "euro",
				shortNames: ["euro"],
				category: 6
			},
			{
				emoji: "💷",
				name: "BANKNOTE WITH POUND SIGN",
				added_in: "6.0",
				shortName: "pound",
				shortNames: ["pound"],
				category: 6
			},
			{
				emoji: "💸",
				name: "MONEY WITH WINGS",
				added_in: "6.0",
				shortName: "money_with_wings",
				shortNames: ["money_with_wings"],
				category: 6
			},
			{
				emoji: "💹",
				name: "CHART WITH UPWARDS TREND AND YEN SIGN",
				added_in: "6.0",
				shortName: "chart",
				shortNames: ["chart"],
				category: 6
			},
			{
				emoji: "💻",
				name: "PERSONAL COMPUTER",
				added_in: "6.0",
				shortName: "computer",
				shortNames: ["computer"],
				category: 6
			},
			{
				emoji: "💼",
				name: "BRIEFCASE",
				added_in: "6.0",
				shortName: "briefcase",
				shortNames: ["briefcase"],
				category: 6
			},
			{
				emoji: "💽",
				name: "MINIDISC",
				added_in: "6.0",
				shortName: "minidisc",
				shortNames: ["minidisc"],
				category: 6
			},
			{
				emoji: "💾",
				name: "FLOPPY DISK",
				added_in: "6.0",
				shortName: "floppy_disk",
				shortNames: ["floppy_disk"],
				category: 6
			},
			{
				emoji: "💿",
				name: "OPTICAL DISC",
				added_in: "6.0",
				shortName: "cd",
				shortNames: ["cd"],
				category: 6
			},
			{
				emoji: "📀",
				name: "DVD",
				added_in: "6.0",
				shortName: "dvd",
				shortNames: ["dvd"],
				category: 6
			},
			{
				emoji: "📁",
				name: "FILE FOLDER",
				added_in: "6.0",
				shortName: "file_folder",
				shortNames: ["file_folder"],
				category: 6
			},
			{
				emoji: "📂",
				name: "OPEN FILE FOLDER",
				added_in: "6.0",
				shortName: "open_file_folder",
				shortNames: ["open_file_folder"],
				category: 6
			},
			{
				emoji: "📃",
				name: "PAGE WITH CURL",
				added_in: "6.0",
				shortName: "page_with_curl",
				shortNames: ["page_with_curl"],
				category: 6
			},
			{
				emoji: "📄",
				name: "PAGE FACING UP",
				added_in: "6.0",
				shortName: "page_facing_up",
				shortNames: ["page_facing_up"],
				category: 6
			},
			{
				emoji: "📅",
				name: "CALENDAR",
				added_in: "6.0",
				shortName: "date",
				shortNames: ["date"],
				category: 6
			},
			{
				emoji: "📆",
				name: "TEAR-OFF CALENDAR",
				added_in: "6.0",
				shortName: "calendar",
				shortNames: ["calendar"],
				category: 6
			},
			{
				emoji: "📈",
				name: "CHART WITH UPWARDS TREND",
				added_in: "6.0",
				shortName: "chart_with_upwards_trend",
				shortNames: ["chart_with_upwards_trend"],
				category: 6
			},
			{
				emoji: "📉",
				name: "CHART WITH DOWNWARDS TREND",
				added_in: "6.0",
				shortName: "chart_with_downwards_trend",
				shortNames: ["chart_with_downwards_trend"],
				category: 6
			},
			{
				emoji: "📊",
				name: "BAR CHART",
				added_in: "6.0",
				shortName: "bar_chart",
				shortNames: ["bar_chart"],
				category: 6
			},
			{
				emoji: "📋",
				name: "CLIPBOARD",
				added_in: "6.0",
				shortName: "clipboard",
				shortNames: ["clipboard"],
				category: 6
			},
			{
				emoji: "📌",
				name: "PUSHPIN",
				added_in: "6.0",
				shortName: "pushpin",
				shortNames: ["pushpin"],
				category: 6
			},
			{
				emoji: "📍",
				name: "ROUND PUSHPIN",
				added_in: "6.0",
				shortName: "round_pushpin",
				shortNames: ["round_pushpin"],
				category: 6
			},
			{
				emoji: "📎",
				name: "PAPERCLIP",
				added_in: "6.0",
				shortName: "paperclip",
				shortNames: ["paperclip"],
				category: 6
			},
			{
				emoji: "📏",
				name: "STRAIGHT RULER",
				added_in: "6.0",
				shortName: "straight_ruler",
				shortNames: ["straight_ruler"],
				category: 6
			},
			{
				emoji: "📐",
				name: "TRIANGULAR RULER",
				added_in: "6.0",
				shortName: "triangular_ruler",
				shortNames: ["triangular_ruler"],
				category: 6
			},
			{
				emoji: "📑",
				name: "BOOKMARK TABS",
				added_in: "6.0",
				shortName: "bookmark_tabs",
				shortNames: ["bookmark_tabs"],
				category: 6
			},
			{
				emoji: "📒",
				name: "LEDGER",
				added_in: "6.0",
				shortName: "ledger",
				shortNames: ["ledger"],
				category: 6
			},
			{
				emoji: "📓",
				name: "NOTEBOOK",
				added_in: "6.0",
				shortName: "notebook",
				shortNames: ["notebook"],
				category: 6
			},
			{
				emoji: "📔",
				name: "NOTEBOOK WITH DECORATIVE COVER",
				added_in: "6.0",
				shortName: "notebook_with_decorative_cover",
				shortNames: ["notebook_with_decorative_cover"],
				category: 6
			},
			{
				emoji: "📕",
				name: "CLOSED BOOK",
				added_in: "6.0",
				shortName: "closed_book",
				shortNames: ["closed_book"],
				category: 6
			},
			{
				emoji: "📖",
				name: "OPEN BOOK",
				added_in: "6.0",
				shortName: "book",
				shortNames: ["book", "open_book"],
				category: 6
			},
			{
				emoji: "📗",
				name: "GREEN BOOK",
				added_in: "6.0",
				shortName: "green_book",
				shortNames: ["green_book"],
				category: 6
			},
			{
				emoji: "📘",
				name: "BLUE BOOK",
				added_in: "6.0",
				shortName: "blue_book",
				shortNames: ["blue_book"],
				category: 6
			},
			{
				emoji: "📙",
				name: "ORANGE BOOK",
				added_in: "6.0",
				shortName: "orange_book",
				shortNames: ["orange_book"],
				category: 6
			},
			{
				emoji: "📚",
				name: "BOOKS",
				added_in: "6.0",
				shortName: "books",
				shortNames: ["books"],
				category: 6
			},
			{
				emoji: "📜",
				name: "SCROLL",
				added_in: "6.0",
				shortName: "scroll",
				shortNames: ["scroll"],
				category: 6
			},
			{
				emoji: "📝",
				name: "MEMO",
				added_in: "6.0",
				shortName: "memo",
				shortNames: ["memo", "pencil"],
				category: 6
			},
			{
				emoji: "📞",
				name: "TELEPHONE RECEIVER",
				added_in: "6.0",
				shortName: "telephone_receiver",
				shortNames: ["telephone_receiver"],
				category: 6
			},
			{
				emoji: "📟",
				name: "PAGER",
				added_in: "6.0",
				shortName: "pager",
				shortNames: ["pager"],
				category: 6
			},
			{
				emoji: "📠",
				name: "FAX MACHINE",
				added_in: "6.0",
				shortName: "fax",
				shortNames: ["fax"],
				category: 6
			},
			{
				emoji: "📡",
				name: "SATELLITE ANTENNA",
				added_in: "6.0",
				shortName: "satellite_antenna",
				shortNames: ["satellite_antenna"],
				category: 6
			},
			{
				emoji: "📢",
				name: "PUBLIC ADDRESS LOUDSPEAKER",
				added_in: "6.0",
				shortName: "loudspeaker",
				shortNames: ["loudspeaker"],
				category: 6
			},
			{
				emoji: "📣",
				name: "CHEERING MEGAPHONE",
				added_in: "6.0",
				shortName: "mega",
				shortNames: ["mega"],
				category: 6
			},
			{
				emoji: "📤",
				name: "OUTBOX TRAY",
				added_in: "6.0",
				shortName: "outbox_tray",
				shortNames: ["outbox_tray"],
				category: 6
			},
			{
				emoji: "📥",
				name: "INBOX TRAY",
				added_in: "6.0",
				shortName: "inbox_tray",
				shortNames: ["inbox_tray"],
				category: 6
			},
			{
				emoji: "📦",
				name: "PACKAGE",
				added_in: "6.0",
				shortName: "package",
				shortNames: ["package"],
				category: 6
			},
			{
				emoji: "📧",
				name: "E-MAIL SYMBOL",
				added_in: "6.0",
				shortName: "e-mail",
				shortNames: ["e-mail"],
				category: 6
			},
			{
				emoji: "📨",
				name: "INCOMING ENVELOPE",
				added_in: "6.0",
				shortName: "incoming_envelope",
				shortNames: ["incoming_envelope"],
				category: 6
			},
			{
				emoji: "📩",
				name: "ENVELOPE WITH DOWNWARDS ARROW ABOVE",
				added_in: "6.0",
				shortName: "envelope_with_arrow",
				shortNames: ["envelope_with_arrow"],
				category: 6
			},
			{
				emoji: "📪",
				name: "CLOSED MAILBOX WITH LOWERED FLAG",
				added_in: "6.0",
				shortName: "mailbox_closed",
				shortNames: ["mailbox_closed"],
				category: 6
			},
			{
				emoji: "📫",
				name: "CLOSED MAILBOX WITH RAISED FLAG",
				added_in: "6.0",
				shortName: "mailbox",
				shortNames: ["mailbox"],
				category: 6
			},
			{
				emoji: "📬",
				name: "OPEN MAILBOX WITH RAISED FLAG",
				added_in: "6.0",
				shortName: "mailbox_with_mail",
				shortNames: ["mailbox_with_mail"],
				category: 6
			},
			{
				emoji: "📭",
				name: "OPEN MAILBOX WITH LOWERED FLAG",
				added_in: "6.0",
				shortName: "mailbox_with_no_mail",
				shortNames: ["mailbox_with_no_mail"],
				category: 6
			},
			{
				emoji: "📮",
				name: "POSTBOX",
				added_in: "6.0",
				shortName: "postbox",
				shortNames: ["postbox"],
				category: 6
			},
			{
				emoji: "📯",
				name: "POSTAL HORN",
				added_in: "6.0",
				shortName: "postal_horn",
				shortNames: ["postal_horn"],
				category: 6
			},
			{
				emoji: "📰",
				name: "NEWSPAPER",
				added_in: "6.0",
				shortName: "newspaper",
				shortNames: ["newspaper"],
				category: 6
			},
			{
				emoji: "📱",
				name: "MOBILE PHONE",
				added_in: "6.0",
				shortName: "iphone",
				shortNames: ["iphone"],
				category: 6
			},
			{
				emoji: "📲",
				name: "MOBILE PHONE WITH RIGHTWARDS ARROW AT LEFT",
				added_in: "6.0",
				shortName: "calling",
				shortNames: ["calling"],
				category: 6
			},
			{
				emoji: "📷",
				name: "CAMERA",
				added_in: "6.0",
				shortName: "camera",
				shortNames: ["camera"],
				category: 6
			},
			{
				emoji: "📹",
				name: "VIDEO CAMERA",
				added_in: "6.0",
				shortName: "video_camera",
				shortNames: ["video_camera"],
				category: 6
			},
			{
				emoji: "📺",
				name: "TELEVISION",
				added_in: "6.0",
				shortName: "tv",
				shortNames: ["tv"],
				category: 6
			},
			{
				emoji: "📻",
				name: "RADIO",
				added_in: "6.0",
				shortName: "radio",
				shortNames: ["radio"],
				category: 6
			},
			{
				emoji: "📼",
				name: "VIDEOCASSETTE",
				added_in: "6.0",
				shortName: "vhs",
				shortNames: ["vhs"],
				category: 6
			},
			{
				emoji: "🔇",
				name: "SPEAKER WITH CANCELLATION STROKE",
				added_in: "6.0",
				shortName: "mute",
				shortNames: ["mute"],
				category: 6
			},
			{
				emoji: "🔈",
				name: "SPEAKER",
				added_in: "6.0",
				shortName: "speaker",
				shortNames: ["speaker"],
				category: 6
			},
			{
				emoji: "🔉",
				name: "SPEAKER WITH ONE SOUND WAVE",
				added_in: "6.0",
				shortName: "sound",
				shortNames: ["sound"],
				category: 6
			},
			{
				emoji: "🔊",
				name: "SPEAKER WITH THREE SOUND WAVES",
				added_in: "6.0",
				shortName: "loud_sound",
				shortNames: ["loud_sound"],
				category: 6
			},
			{
				emoji: "🔋",
				name: "BATTERY",
				added_in: "6.0",
				shortName: "battery",
				shortNames: ["battery"],
				category: 6
			},
			{
				emoji: "🔌",
				name: "ELECTRIC PLUG",
				added_in: "6.0",
				shortName: "electric_plug",
				shortNames: ["electric_plug"],
				category: 6
			},
			{
				emoji: "🔍",
				name: "LEFT-POINTING MAGNIFYING GLASS",
				added_in: "6.0",
				shortName: "mag",
				shortNames: ["mag"],
				category: 6
			},
			{
				emoji: "🔎",
				name: "RIGHT-POINTING MAGNIFYING GLASS",
				added_in: "6.0",
				shortName: "mag_right",
				shortNames: ["mag_right"],
				category: 6
			},
			{
				emoji: "🔏",
				name: "LOCK WITH INK PEN",
				added_in: "6.0",
				shortName: "lock_with_ink_pen",
				shortNames: ["lock_with_ink_pen"],
				category: 6
			},
			{
				emoji: "🔐",
				name: "CLOSED LOCK WITH KEY",
				added_in: "6.0",
				shortName: "closed_lock_with_key",
				shortNames: ["closed_lock_with_key"],
				category: 6
			},
			{
				emoji: "🔑",
				name: "KEY",
				added_in: "6.0",
				shortName: "key",
				shortNames: ["key"],
				category: 6
			},
			{
				emoji: "🔒",
				name: "LOCK",
				added_in: "6.0",
				shortName: "lock",
				shortNames: ["lock"],
				category: 6
			},
			{
				emoji: "🔓",
				name: "OPEN LOCK",
				added_in: "6.0",
				shortName: "unlock",
				shortNames: ["unlock"],
				category: 6
			},
			{
				emoji: "🔔",
				name: "BELL",
				added_in: "6.0",
				shortName: "bell",
				shortNames: ["bell"],
				category: 6
			},
			{
				emoji: "🔕",
				name: "BELL WITH CANCELLATION STROKE",
				added_in: "6.0",
				shortName: "no_bell",
				shortNames: ["no_bell"],
				category: 6
			},
			{
				emoji: "🔖",
				name: "BOOKMARK",
				added_in: "6.0",
				shortName: "bookmark",
				shortNames: ["bookmark"],
				category: 6
			},
			{
				emoji: "🔗",
				name: "LINK SYMBOL",
				added_in: "6.0",
				shortName: "link",
				shortNames: ["link"],
				category: 6
			},
			{
				emoji: "🔦",
				name: "ELECTRIC TORCH",
				added_in: "6.0",
				shortName: "flashlight",
				shortNames: ["flashlight"],
				category: 6
			},
			{
				emoji: "🔧",
				name: "WRENCH",
				added_in: "6.0",
				shortName: "wrench",
				shortNames: ["wrench"],
				category: 6
			},
			{
				emoji: "🔨",
				name: "HAMMER",
				added_in: "6.0",
				shortName: "hammer",
				shortNames: ["hammer"],
				category: 6
			},
			{
				emoji: "🔩",
				name: "NUT AND BOLT",
				added_in: "6.0",
				shortName: "nut_and_bolt",
				shortNames: ["nut_and_bolt"],
				category: 6
			},
			{
				emoji: "🔫",
				name: "PISTOL",
				added_in: "6.0",
				shortName: "gun",
				shortNames: ["gun"],
				category: 6
			},
			{
				emoji: "🔬",
				name: "MICROSCOPE",
				added_in: "6.0",
				shortName: "microscope",
				shortNames: ["microscope"],
				category: 6
			},
			{
				emoji: "🔭",
				name: "TELESCOPE",
				added_in: "6.0",
				shortName: "telescope",
				shortNames: ["telescope"],
				category: 6
			},
			{
				emoji: "🔮",
				name: "CRYSTAL BALL",
				added_in: "6.0",
				shortName: "crystal_ball",
				shortNames: ["crystal_ball"],
				category: 6
			},
			{
				emoji: "🗿",
				name: "MOYAI",
				added_in: "6.0",
				shortName: "moyai",
				shortNames: ["moyai"],
				category: 6
			},
			{
				emoji: "🚬",
				name: "SMOKING SYMBOL",
				added_in: "6.0",
				shortName: "smoking",
				shortNames: ["smoking"],
				category: 6
			},
			{
				emoji: "☎️",
				name: "BLACK TELEPHONE",
				added_in: "1.1",
				shortName: "phone",
				shortNames: ["phone", "telephone"],
				category: 6
			},
			{
				emoji: "✂️",
				name: "BLACK SCISSORS",
				added_in: "1.1",
				shortName: "scissors",
				shortNames: ["scissors"],
				category: 6
			},
			{
				emoji: "✉️",
				name: "ENVELOPE",
				added_in: "1.1",
				shortName: "email",
				shortNames: ["email", "envelope"],
				category: 6
			},
			{
				emoji: "✏️",
				name: "PENCIL",
				added_in: "1.1",
				shortName: "pencil2",
				shortNames: ["pencil2"],
				category: 6
			},
			{
				emoji: "✒️",
				name: "BLACK NIB",
				added_in: "1.1",
				shortName: "black_nib",
				shortNames: ["black_nib"],
				category: 6
			}
		],
		[
			{
				emoji: "🚼",
				name: "BABY SYMBOL",
				added_in: "6.0",
				shortName: "baby_symbol",
				shortNames: ["baby_symbol"],
				category: 7
			},
			{
				emoji: "🅰️",
				name: "NEGATIVE SQUARED LATIN CAPITAL LETTER A",
				added_in: "6.0",
				shortName: "a",
				shortNames: ["a"],
				category: 7
			},
			{
				emoji: "🅱️",
				name: "NEGATIVE SQUARED LATIN CAPITAL LETTER B",
				added_in: "6.0",
				shortName: "b",
				shortNames: ["b"],
				category: 7
			},
			{
				emoji: "🅾️",
				name: "NEGATIVE SQUARED LATIN CAPITAL LETTER O",
				added_in: "6.0",
				shortName: "o2",
				shortNames: ["o2"],
				category: 7
			},
			{
				emoji: "🅿️",
				name: "NEGATIVE SQUARED LATIN CAPITAL LETTER P",
				added_in: "5.2",
				shortName: "parking",
				shortNames: ["parking"],
				category: 7
			},
			{
				emoji: "🆎",
				name: "NEGATIVE SQUARED AB",
				added_in: "6.0",
				shortName: "ab",
				shortNames: ["ab"],
				category: 7
			},
			{
				emoji: "🆑",
				name: "SQUARED CL",
				added_in: "6.0",
				shortName: "cl",
				shortNames: ["cl"],
				category: 7
			},
			{
				emoji: "🆒",
				name: "SQUARED COOL",
				added_in: "6.0",
				shortName: "cool",
				shortNames: ["cool"],
				category: 7
			},
			{
				emoji: "🆓",
				name: "SQUARED FREE",
				added_in: "6.0",
				shortName: "free",
				shortNames: ["free"],
				category: 7
			},
			{
				emoji: "🆔",
				name: "SQUARED ID",
				added_in: "6.0",
				shortName: "id",
				shortNames: ["id"],
				category: 7
			},
			{
				emoji: "🆕",
				name: "SQUARED NEW",
				added_in: "6.0",
				shortName: "new",
				shortNames: ["new"],
				category: 7
			},
			{
				emoji: "🆖",
				name: "SQUARED NG",
				added_in: "6.0",
				shortName: "ng",
				shortNames: ["ng"],
				category: 7
			},
			{
				emoji: "🆗",
				name: "SQUARED OK",
				added_in: "6.0",
				shortName: "ok",
				shortNames: ["ok"],
				category: 7
			},
			{
				emoji: "🆘",
				name: "SQUARED SOS",
				added_in: "6.0",
				shortName: "sos",
				shortNames: ["sos"],
				category: 7
			},
			{
				emoji: "🆙",
				name: "SQUARED UP WITH EXCLAMATION MARK",
				added_in: "6.0",
				shortName: "up",
				shortNames: ["up"],
				category: 7
			},
			{
				emoji: "🆚",
				name: "SQUARED VS",
				added_in: "6.0",
				shortName: "vs",
				shortNames: ["vs"],
				category: 7
			},
			{
				emoji: "🈁",
				name: "SQUARED KATAKANA KOKO",
				added_in: "6.0",
				shortName: "koko",
				shortNames: ["koko"],
				category: 7
			},
			{
				emoji: "🈂️",
				name: "SQUARED KATAKANA SA",
				added_in: "6.0",
				shortName: "sa",
				shortNames: ["sa"],
				category: 7
			},
			{
				emoji: "🈚",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-7121",
				added_in: "5.2",
				shortName: "u7121",
				shortNames: ["u7121"],
				category: 7
			},
			{
				emoji: "🈯",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-6307",
				added_in: "5.2",
				shortName: "u6307",
				shortNames: ["u6307"],
				category: 7
			},
			{
				emoji: "🈲",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-7981",
				added_in: "6.0",
				shortName: "u7981",
				shortNames: ["u7981"],
				category: 7
			},
			{
				emoji: "🈳",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-7A7A",
				added_in: "6.0",
				shortName: "u7a7a",
				shortNames: ["u7a7a"],
				category: 7
			},
			{
				emoji: "🈴",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-5408",
				added_in: "6.0",
				shortName: "u5408",
				shortNames: ["u5408"],
				category: 7
			},
			{
				emoji: "🈵",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-6E80",
				added_in: "6.0",
				shortName: "u6e80",
				shortNames: ["u6e80"],
				category: 7
			},
			{
				emoji: "🈶",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-6709",
				added_in: "6.0",
				shortName: "u6709",
				shortNames: ["u6709"],
				category: 7
			},
			{
				emoji: "🈷️",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-6708",
				added_in: "6.0",
				shortName: "u6708",
				shortNames: ["u6708"],
				category: 7
			},
			{
				emoji: "🈸",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-7533",
				added_in: "6.0",
				shortName: "u7533",
				shortNames: ["u7533"],
				category: 7
			},
			{
				emoji: "🈹",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-5272",
				added_in: "6.0",
				shortName: "u5272",
				shortNames: ["u5272"],
				category: 7
			},
			{
				emoji: "🈺",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-55B6",
				added_in: "6.0",
				shortName: "u55b6",
				shortNames: ["u55b6"],
				category: 7
			},
			{
				emoji: "🉐",
				name: "CIRCLED IDEOGRAPH ADVANTAGE",
				added_in: "6.0",
				shortName: "ideograph_advantage",
				shortNames: ["ideograph_advantage"],
				category: 7
			},
			{
				emoji: "🉑",
				name: "CIRCLED IDEOGRAPH ACCEPT",
				added_in: "6.0",
				shortName: "accept",
				shortNames: ["accept"],
				category: 7
			},
			{
				emoji: "🎦",
				name: "CINEMA",
				added_in: "6.0",
				shortName: "cinema",
				shortNames: ["cinema"],
				category: 7
			},
			{
				emoji: "🏧",
				name: "AUTOMATED TELLER MACHINE",
				added_in: "6.0",
				shortName: "atm",
				shortNames: ["atm"],
				category: 7
			},
			{
				emoji: "💠",
				name: "DIAMOND SHAPE WITH A DOT INSIDE",
				added_in: "6.0",
				shortName: "diamond_shape_with_a_dot_inside",
				shortNames: ["diamond_shape_with_a_dot_inside"],
				category: 7
			},
			{
				emoji: "💯",
				name: "HUNDRED POINTS SYMBOL",
				added_in: "6.0",
				shortName: "100",
				shortNames: ["100"],
				category: 7
			},
			{
				emoji: "📛",
				name: "NAME BADGE",
				added_in: "6.0",
				shortName: "name_badge",
				shortNames: ["name_badge"],
				category: 7
			},
			{
				emoji: "📳",
				name: "VIBRATION MODE",
				added_in: "6.0",
				shortName: "vibration_mode",
				shortNames: ["vibration_mode"],
				category: 7
			},
			{
				emoji: "📴",
				name: "MOBILE PHONE OFF",
				added_in: "6.0",
				shortName: "mobile_phone_off",
				shortNames: ["mobile_phone_off"],
				category: 7
			},
			{
				emoji: "📵",
				name: "NO MOBILE PHONES",
				added_in: "6.0",
				shortName: "no_mobile_phones",
				shortNames: ["no_mobile_phones"],
				category: 7
			},
			{
				emoji: "📶",
				name: "ANTENNA WITH BARS",
				added_in: "6.0",
				shortName: "signal_strength",
				shortNames: ["signal_strength"],
				category: 7
			},
			{
				emoji: "🔀",
				name: "TWISTED RIGHTWARDS ARROWS",
				added_in: "6.0",
				shortName: "twisted_rightwards_arrows",
				shortNames: ["twisted_rightwards_arrows"],
				category: 7
			},
			{
				emoji: "🔁",
				name: "CLOCKWISE RIGHTWARDS AND LEFTWARDS OPEN CIRCLE ARROWS",
				added_in: "6.0",
				shortName: "repeat",
				shortNames: ["repeat"],
				category: 7
			},
			{
				emoji: "🔂",
				name: "CLOCKWISE RIGHTWARDS AND LEFTWARDS OPEN CIRCLE ARROWS WITH CIRCLED ONE OVERLAY",
				added_in: "6.0",
				shortName: "repeat_one",
				shortNames: ["repeat_one"],
				category: 7
			},
			{
				emoji: "🔃",
				name: "CLOCKWISE DOWNWARDS AND UPWARDS OPEN CIRCLE ARROWS",
				added_in: "6.0",
				shortName: "arrows_clockwise",
				shortNames: ["arrows_clockwise"],
				category: 7
			},
			{
				emoji: "🔄",
				name: "ANTICLOCKWISE DOWNWARDS AND UPWARDS OPEN CIRCLE ARROWS",
				added_in: "6.0",
				shortName: "arrows_counterclockwise",
				shortNames: ["arrows_counterclockwise"],
				category: 7
			},
			{
				emoji: "🔅",
				name: "LOW BRIGHTNESS SYMBOL",
				added_in: "6.0",
				shortName: "low_brightness",
				shortNames: ["low_brightness"],
				category: 7
			},
			{
				emoji: "🔆",
				name: "HIGH BRIGHTNESS SYMBOL",
				added_in: "6.0",
				shortName: "high_brightness",
				shortNames: ["high_brightness"],
				category: 7
			},
			{
				emoji: "🔘",
				name: "RADIO BUTTON",
				added_in: "6.0",
				shortName: "radio_button",
				shortNames: ["radio_button"],
				category: 7
			},
			{
				emoji: "🔙",
				name: "BACK WITH LEFTWARDS ARROW ABOVE",
				added_in: "6.0",
				shortName: "back",
				shortNames: ["back"],
				category: 7
			},
			{
				emoji: "🔚",
				name: "END WITH LEFTWARDS ARROW ABOVE",
				added_in: "6.0",
				shortName: "end",
				shortNames: ["end"],
				category: 7
			},
			{
				emoji: "🔛",
				name: "ON WITH EXCLAMATION MARK WITH LEFT RIGHT ARROW ABOVE",
				added_in: "6.0",
				shortName: "on",
				shortNames: ["on"],
				category: 7
			},
			{
				emoji: "🔜",
				name: "SOON WITH RIGHTWARDS ARROW ABOVE",
				added_in: "6.0",
				shortName: "soon",
				shortNames: ["soon"],
				category: 7
			},
			{
				emoji: "🔝",
				name: "TOP WITH UPWARDS ARROW ABOVE",
				added_in: "6.0",
				shortName: "top",
				shortNames: ["top"],
				category: 7
			},
			{
				emoji: "🔞",
				name: "NO ONE UNDER EIGHTEEN SYMBOL",
				added_in: "6.0",
				shortName: "underage",
				shortNames: ["underage"],
				category: 7
			},
			{
				emoji: "🔟",
				name: "KEYCAP TEN",
				added_in: "6.0",
				shortName: "keycap_ten",
				shortNames: ["keycap_ten"],
				category: 7
			},
			{
				emoji: "🔠",
				name: "INPUT SYMBOL FOR LATIN CAPITAL LETTERS",
				added_in: "6.0",
				shortName: "capital_abcd",
				shortNames: ["capital_abcd"],
				category: 7
			},
			{
				emoji: "🔡",
				name: "INPUT SYMBOL FOR LATIN SMALL LETTERS",
				added_in: "6.0",
				shortName: "abcd",
				shortNames: ["abcd"],
				category: 7
			},
			{
				emoji: "🔢",
				name: "INPUT SYMBOL FOR NUMBERS",
				added_in: "6.0",
				shortName: "1234",
				shortNames: ["1234"],
				category: 7
			},
			{
				emoji: "🔣",
				name: "INPUT SYMBOL FOR SYMBOLS",
				added_in: "6.0",
				shortName: "symbols",
				shortNames: ["symbols"],
				category: 7
			},
			{
				emoji: "🔤",
				name: "INPUT SYMBOL FOR LATIN LETTERS",
				added_in: "6.0",
				shortName: "abc",
				shortNames: ["abc"],
				category: 7
			},
			{
				emoji: "🔯",
				name: "SIX POINTED STAR WITH MIDDLE DOT",
				added_in: "6.0",
				shortName: "six_pointed_star",
				shortNames: ["six_pointed_star"],
				category: 7
			},
			{
				emoji: "🔰",
				name: "JAPANESE SYMBOL FOR BEGINNER",
				added_in: "6.0",
				shortName: "beginner",
				shortNames: ["beginner"],
				category: 7
			},
			{
				emoji: "🔱",
				name: "TRIDENT EMBLEM",
				added_in: "6.0",
				shortName: "trident",
				shortNames: ["trident"],
				category: 7
			},
			{
				emoji: "🔲",
				name: "BLACK SQUARE BUTTON",
				added_in: "6.0",
				shortName: "black_square_button",
				shortNames: ["black_square_button"],
				category: 7
			},
			{
				emoji: "🔳",
				name: "WHITE SQUARE BUTTON",
				added_in: "6.0",
				shortName: "white_square_button",
				shortNames: ["white_square_button"],
				category: 7
			},
			{
				emoji: "🔴",
				name: "LARGE RED CIRCLE",
				added_in: "6.0",
				shortName: "red_circle",
				shortNames: ["red_circle"],
				category: 7
			},
			{
				emoji: "🔵",
				name: "LARGE BLUE CIRCLE",
				added_in: "6.0",
				shortName: "large_blue_circle",
				shortNames: ["large_blue_circle"],
				category: 7
			},
			{
				emoji: "🔶",
				name: "LARGE ORANGE DIAMOND",
				added_in: "6.0",
				shortName: "large_orange_diamond",
				shortNames: ["large_orange_diamond"],
				category: 7
			},
			{
				emoji: "🔷",
				name: "LARGE BLUE DIAMOND",
				added_in: "6.0",
				shortName: "large_blue_diamond",
				shortNames: ["large_blue_diamond"],
				category: 7
			},
			{
				emoji: "🔸",
				name: "SMALL ORANGE DIAMOND",
				added_in: "6.0",
				shortName: "small_orange_diamond",
				shortNames: ["small_orange_diamond"],
				category: 7
			},
			{
				emoji: "🔹",
				name: "SMALL BLUE DIAMOND",
				added_in: "6.0",
				shortName: "small_blue_diamond",
				shortNames: ["small_blue_diamond"],
				category: 7
			},
			{
				emoji: "🔺",
				name: "UP-POINTING RED TRIANGLE",
				added_in: "6.0",
				shortName: "small_red_triangle",
				shortNames: ["small_red_triangle"],
				category: 7
			},
			{
				emoji: "🔻",
				name: "DOWN-POINTING RED TRIANGLE",
				added_in: "6.0",
				shortName: "small_red_triangle_down",
				shortNames: ["small_red_triangle_down"],
				category: 7
			},
			{
				emoji: "🔼",
				name: "UP-POINTING SMALL RED TRIANGLE",
				added_in: "6.0",
				shortName: "arrow_up_small",
				shortNames: ["arrow_up_small"],
				category: 7
			},
			{
				emoji: "🔽",
				name: "DOWN-POINTING SMALL RED TRIANGLE",
				added_in: "6.0",
				shortName: "arrow_down_small",
				shortNames: ["arrow_down_small"],
				category: 7
			},
			{
				emoji: "🚫",
				name: "NO ENTRY SIGN",
				added_in: "6.0",
				shortName: "no_entry_sign",
				shortNames: ["no_entry_sign"],
				category: 7
			},
			{
				emoji: "🚭",
				name: "NO SMOKING SYMBOL",
				added_in: "6.0",
				shortName: "no_smoking",
				shortNames: ["no_smoking"],
				category: 7
			},
			{
				emoji: "🚮",
				name: "PUT LITTER IN ITS PLACE SYMBOL",
				added_in: "6.0",
				shortName: "put_litter_in_its_place",
				shortNames: ["put_litter_in_its_place"],
				category: 7
			},
			{
				emoji: "🚯",
				name: "DO NOT LITTER SYMBOL",
				added_in: "6.0",
				shortName: "do_not_litter",
				shortNames: ["do_not_litter"],
				category: 7
			},
			{
				emoji: "🚰",
				name: "POTABLE WATER SYMBOL",
				added_in: "6.0",
				shortName: "potable_water",
				shortNames: ["potable_water"],
				category: 7
			},
			{
				emoji: "🚱",
				name: "NON-POTABLE WATER SYMBOL",
				added_in: "6.0",
				shortName: "non-potable_water",
				shortNames: ["non-potable_water"],
				category: 7
			},
			{
				emoji: "🚳",
				name: "NO BICYCLES",
				added_in: "6.0",
				shortName: "no_bicycles",
				shortNames: ["no_bicycles"],
				category: 7
			},
			{
				emoji: "🚷",
				name: "NO PEDESTRIANS",
				added_in: "6.0",
				shortName: "no_pedestrians",
				shortNames: ["no_pedestrians"],
				category: 7
			},
			{
				emoji: "🚸",
				name: "CHILDREN CROSSING",
				added_in: "6.0",
				shortName: "children_crossing",
				shortNames: ["children_crossing"],
				category: 7
			},
			{
				emoji: "🚹",
				name: "MENS SYMBOL",
				added_in: "6.0",
				shortName: "mens",
				shortNames: ["mens"],
				category: 7
			},
			{
				emoji: "🚺",
				name: "WOMENS SYMBOL",
				added_in: "6.0",
				shortName: "womens",
				shortNames: ["womens"],
				category: 7
			},
			{
				emoji: "🚻",
				name: "RESTROOM",
				added_in: "6.0",
				shortName: "restroom",
				shortNames: ["restroom"],
				category: 7
			},
			{
				emoji: "🚾",
				name: "WATER CLOSET",
				added_in: "6.0",
				shortName: "wc",
				shortNames: ["wc"],
				category: 7
			},
			{
				emoji: "🛂",
				name: "PASSPORT CONTROL",
				added_in: "6.0",
				shortName: "passport_control",
				shortNames: ["passport_control"],
				category: 7
			},
			{
				emoji: "🛃",
				name: "CUSTOMS",
				added_in: "6.0",
				shortName: "customs",
				shortNames: ["customs"],
				category: 7
			},
			{
				emoji: "🛄",
				name: "BAGGAGE CLAIM",
				added_in: "6.0",
				shortName: "baggage_claim",
				shortNames: ["baggage_claim"],
				category: 7
			},
			{
				emoji: "🛅",
				name: "LEFT LUGGAGE",
				added_in: "6.0",
				shortName: "left_luggage",
				shortNames: ["left_luggage"],
				category: 7
			},
			{
				emoji: "‼️",
				name: "DOUBLE EXCLAMATION MARK",
				added_in: "1.1",
				shortName: "bangbang",
				shortNames: ["bangbang"],
				category: 7
			},
			{
				emoji: "⁉️",
				name: "EXCLAMATION QUESTION MARK",
				added_in: "3.0",
				shortName: "interrobang",
				shortNames: ["interrobang"],
				category: 7
			},
			{
				emoji: "™️",
				name: "TRADE MARK SIGN",
				added_in: "1.1",
				shortName: "tm",
				shortNames: ["tm"],
				category: 7
			},
			{
				emoji: "ℹ️",
				name: "INFORMATION SOURCE",
				added_in: "3.0",
				shortName: "information_source",
				shortNames: ["information_source"],
				category: 7
			},
			{
				emoji: "↔️",
				name: "LEFT RIGHT ARROW",
				added_in: "1.1",
				shortName: "left_right_arrow",
				shortNames: ["left_right_arrow"],
				category: 7
			},
			{
				emoji: "↕️",
				name: "UP DOWN ARROW",
				added_in: "1.1",
				shortName: "arrow_up_down",
				shortNames: ["arrow_up_down"],
				category: 7
			},
			{
				emoji: "↖️",
				name: "NORTH WEST ARROW",
				added_in: "1.1",
				shortName: "arrow_upper_left",
				shortNames: ["arrow_upper_left"],
				category: 7
			},
			{
				emoji: "↗️",
				name: "NORTH EAST ARROW",
				added_in: "1.1",
				shortName: "arrow_upper_right",
				shortNames: ["arrow_upper_right"],
				category: 7
			},
			{
				emoji: "↘️",
				name: "SOUTH EAST ARROW",
				added_in: "1.1",
				shortName: "arrow_lower_right",
				shortNames: ["arrow_lower_right"],
				category: 7
			},
			{
				emoji: "↙️",
				name: "SOUTH WEST ARROW",
				added_in: "1.1",
				shortName: "arrow_lower_left",
				shortNames: ["arrow_lower_left"],
				category: 7
			},
			{
				emoji: "↩️",
				name: "LEFTWARDS ARROW WITH HOOK",
				added_in: "1.1",
				shortName: "leftwards_arrow_with_hook",
				shortNames: ["leftwards_arrow_with_hook"],
				category: 7
			},
			{
				emoji: "↪️",
				name: "RIGHTWARDS ARROW WITH HOOK",
				added_in: "1.1",
				shortName: "arrow_right_hook",
				shortNames: ["arrow_right_hook"],
				category: 7
			},
			{
				emoji: "⏩",
				name: "BLACK RIGHT-POINTING DOUBLE TRIANGLE",
				added_in: "6.0",
				shortName: "fast_forward",
				shortNames: ["fast_forward"],
				category: 7
			},
			{
				emoji: "⏪",
				name: "BLACK LEFT-POINTING DOUBLE TRIANGLE",
				added_in: "6.0",
				shortName: "rewind",
				shortNames: ["rewind"],
				category: 7
			},
			{
				emoji: "⏫",
				name: "BLACK UP-POINTING DOUBLE TRIANGLE",
				added_in: "6.0",
				shortName: "arrow_double_up",
				shortNames: ["arrow_double_up"],
				category: 7
			},
			{
				emoji: "⏬",
				name: "BLACK DOWN-POINTING DOUBLE TRIANGLE",
				added_in: "6.0",
				shortName: "arrow_double_down",
				shortNames: ["arrow_double_down"],
				category: 7
			},
			{
				emoji: "Ⓜ️",
				name: "CIRCLED LATIN CAPITAL LETTER M",
				added_in: "1.1",
				shortName: "m",
				shortNames: ["m"],
				category: 7
			},
			{
				emoji: "▪️",
				name: "BLACK SMALL SQUARE",
				added_in: "1.1",
				shortName: "black_small_square",
				shortNames: ["black_small_square"],
				category: 7
			},
			{
				emoji: "▫️",
				name: "WHITE SMALL SQUARE",
				added_in: "1.1",
				shortName: "white_small_square",
				shortNames: ["white_small_square"],
				category: 7
			},
			{
				emoji: "▶️",
				name: "BLACK RIGHT-POINTING TRIANGLE",
				added_in: "1.1",
				shortName: "arrow_forward",
				shortNames: ["arrow_forward"],
				category: 7
			},
			{
				emoji: "◀️",
				name: "BLACK LEFT-POINTING TRIANGLE",
				added_in: "1.1",
				shortName: "arrow_backward",
				shortNames: ["arrow_backward"],
				category: 7
			},
			{
				emoji: "◻️",
				name: "WHITE MEDIUM SQUARE",
				added_in: "3.2",
				shortName: "white_medium_square",
				shortNames: ["white_medium_square"],
				category: 7
			},
			{
				emoji: "◼️",
				name: "BLACK MEDIUM SQUARE",
				added_in: "3.2",
				shortName: "black_medium_square",
				shortNames: ["black_medium_square"],
				category: 7
			},
			{
				emoji: "◽",
				name: "WHITE MEDIUM SMALL SQUARE",
				added_in: "3.2",
				shortName: "white_medium_small_square",
				shortNames: ["white_medium_small_square"],
				category: 7
			},
			{
				emoji: "◾",
				name: "BLACK MEDIUM SMALL SQUARE",
				added_in: "3.2",
				shortName: "black_medium_small_square",
				shortNames: ["black_medium_small_square"],
				category: 7
			},
			{
				emoji: "☑️",
				name: "BALLOT BOX WITH CHECK",
				added_in: "1.1",
				shortName: "ballot_box_with_check",
				shortNames: ["ballot_box_with_check"],
				category: 7
			},
			{
				emoji: "♈",
				name: "ARIES",
				added_in: "1.1",
				shortName: "aries",
				shortNames: ["aries"],
				category: 7
			},
			{
				emoji: "♉",
				name: "TAURUS",
				added_in: "1.1",
				shortName: "taurus",
				shortNames: ["taurus"],
				category: 7
			},
			{
				emoji: "♊",
				name: "GEMINI",
				added_in: "1.1",
				shortName: "gemini",
				shortNames: ["gemini"],
				category: 7
			},
			{
				emoji: "♋",
				name: "CANCER",
				added_in: "1.1",
				shortName: "cancer",
				shortNames: ["cancer"],
				category: 7
			},
			{
				emoji: "♌",
				name: "LEO",
				added_in: "1.1",
				shortName: "leo",
				shortNames: ["leo"],
				category: 7
			},
			{
				emoji: "♍",
				name: "VIRGO",
				added_in: "1.1",
				shortName: "virgo",
				shortNames: ["virgo"],
				category: 7
			},
			{
				emoji: "♎",
				name: "LIBRA",
				added_in: "1.1",
				shortName: "libra",
				shortNames: ["libra"],
				category: 7
			},
			{
				emoji: "♏",
				name: "SCORPIUS",
				added_in: "1.1",
				shortName: "scorpius",
				shortNames: ["scorpius"],
				category: 7
			},
			{
				emoji: "♐",
				name: "SAGITTARIUS",
				added_in: "1.1",
				shortName: "sagittarius",
				shortNames: ["sagittarius"],
				category: 7
			},
			{
				emoji: "♑",
				name: "CAPRICORN",
				added_in: "1.1",
				shortName: "capricorn",
				shortNames: ["capricorn"],
				category: 7
			},
			{
				emoji: "♒",
				name: "AQUARIUS",
				added_in: "1.1",
				shortName: "aquarius",
				shortNames: ["aquarius"],
				category: 7
			},
			{
				emoji: "♓",
				name: "PISCES",
				added_in: "1.1",
				shortName: "pisces",
				shortNames: ["pisces"],
				category: 7
			},
			{
				emoji: "♻️",
				name: "BLACK UNIVERSAL RECYCLING SYMBOL",
				added_in: "3.2",
				shortName: "recycle",
				shortNames: ["recycle"],
				category: 7
			},
			{
				emoji: "♿",
				name: "WHEELCHAIR SYMBOL",
				added_in: "4.1",
				shortName: "wheelchair",
				shortNames: ["wheelchair"],
				category: 7
			},
			{
				emoji: "⚠️",
				name: "WARNING SIGN",
				added_in: "4.0",
				shortName: "warning",
				shortNames: ["warning"],
				category: 7
			},
			{
				emoji: "⚪",
				name: "MEDIUM WHITE CIRCLE",
				added_in: "4.1",
				shortName: "white_circle",
				shortNames: ["white_circle"],
				category: 7
			},
			{
				emoji: "⚫",
				name: "MEDIUM BLACK CIRCLE",
				added_in: "4.1",
				shortName: "black_circle",
				shortNames: ["black_circle"],
				category: 7
			},
			{
				emoji: "⛎",
				name: "OPHIUCHUS",
				added_in: "6.0",
				shortName: "ophiuchus",
				shortNames: ["ophiuchus"],
				category: 7
			},
			{
				emoji: "⛔",
				name: "NO ENTRY",
				added_in: "5.2",
				shortName: "no_entry",
				shortNames: ["no_entry"],
				category: 7
			},
			{
				emoji: "✅",
				name: "WHITE HEAVY CHECK MARK",
				added_in: "6.0",
				shortName: "white_check_mark",
				shortNames: ["white_check_mark"],
				category: 7
			},
			{
				emoji: "✔️",
				name: "HEAVY CHECK MARK",
				added_in: "1.1",
				shortName: "heavy_check_mark",
				shortNames: ["heavy_check_mark"],
				category: 7
			},
			{
				emoji: "✖️",
				name: "HEAVY MULTIPLICATION X",
				added_in: "1.1",
				shortName: "heavy_multiplication_x",
				shortNames: ["heavy_multiplication_x"],
				category: 7
			},
			{
				emoji: "✳️",
				name: "EIGHT SPOKED ASTERISK",
				added_in: "1.1",
				shortName: "eight_spoked_asterisk",
				shortNames: ["eight_spoked_asterisk"],
				category: 7
			},
			{
				emoji: "✴️",
				name: "EIGHT POINTED BLACK STAR",
				added_in: "1.1",
				shortName: "eight_pointed_black_star",
				shortNames: ["eight_pointed_black_star"],
				category: 7
			},
			{
				emoji: "❇️",
				name: "SPARKLE",
				added_in: "1.1",
				shortName: "sparkle",
				shortNames: ["sparkle"],
				category: 7
			},
			{
				emoji: "❌",
				name: "CROSS MARK",
				added_in: "6.0",
				shortName: "x",
				shortNames: ["x"],
				category: 7
			},
			{
				emoji: "❎",
				name: "NEGATIVE SQUARED CROSS MARK",
				added_in: "6.0",
				shortName: "negative_squared_cross_mark",
				shortNames: ["negative_squared_cross_mark"],
				category: 7
			},
			{
				emoji: "❓",
				name: "BLACK QUESTION MARK ORNAMENT",
				added_in: "6.0",
				shortName: "question",
				shortNames: ["question"],
				category: 7
			},
			{
				emoji: "❔",
				name: "WHITE QUESTION MARK ORNAMENT",
				added_in: "6.0",
				shortName: "grey_question",
				shortNames: ["grey_question"],
				category: 7
			},
			{
				emoji: "❕",
				name: "WHITE EXCLAMATION MARK ORNAMENT",
				added_in: "6.0",
				shortName: "grey_exclamation",
				shortNames: ["grey_exclamation"],
				category: 7
			},
			{
				emoji: "❗",
				name: "HEAVY EXCLAMATION MARK SYMBOL",
				added_in: "5.2",
				shortName: "exclamation",
				shortNames: ["exclamation", "heavy_exclamation_mark"],
				category: 7
			},
			{
				emoji: "➕",
				name: "HEAVY PLUS SIGN",
				added_in: "6.0",
				shortName: "heavy_plus_sign",
				shortNames: ["heavy_plus_sign"],
				category: 7
			},
			{
				emoji: "➖",
				name: "HEAVY MINUS SIGN",
				added_in: "6.0",
				shortName: "heavy_minus_sign",
				shortNames: ["heavy_minus_sign"],
				category: 7
			},
			{
				emoji: "➗",
				name: "HEAVY DIVISION SIGN",
				added_in: "6.0",
				shortName: "heavy_division_sign",
				shortNames: ["heavy_division_sign"],
				category: 7
			},
			{
				emoji: "➡️",
				name: "BLACK RIGHTWARDS ARROW",
				added_in: "1.1",
				shortName: "arrow_right",
				shortNames: ["arrow_right"],
				category: 7
			},
			{
				emoji: "➰",
				name: "CURLY LOOP",
				added_in: "6.0",
				shortName: "curly_loop",
				shortNames: ["curly_loop"],
				category: 7
			},
			{
				emoji: "➿",
				name: "DOUBLE CURLY LOOP",
				added_in: "6.0",
				shortName: "loop",
				shortNames: ["loop"],
				category: 7
			},
			{
				emoji: "⤴️",
				name: "ARROW POINTING RIGHTWARDS THEN CURVING UPWARDS",
				added_in: "3.2",
				shortName: "arrow_heading_up",
				shortNames: ["arrow_heading_up"],
				category: 7
			},
			{
				emoji: "⤵️",
				name: "ARROW POINTING RIGHTWARDS THEN CURVING DOWNWARDS",
				added_in: "3.2",
				shortName: "arrow_heading_down",
				shortNames: ["arrow_heading_down"],
				category: 7
			},
			{
				emoji: "⬅️",
				name: "LEFTWARDS BLACK ARROW",
				added_in: "4.0",
				shortName: "arrow_left",
				shortNames: ["arrow_left"],
				category: 7
			},
			{
				emoji: "⬆️",
				name: "UPWARDS BLACK ARROW",
				added_in: "4.0",
				shortName: "arrow_up",
				shortNames: ["arrow_up"],
				category: 7
			},
			{
				emoji: "⬇️",
				name: "DOWNWARDS BLACK ARROW",
				added_in: "4.0",
				shortName: "arrow_down",
				shortNames: ["arrow_down"],
				category: 7
			},
			{
				emoji: "⬛",
				name: "BLACK LARGE SQUARE",
				added_in: "5.1",
				shortName: "black_large_square",
				shortNames: ["black_large_square"],
				category: 7
			},
			{
				emoji: "⬜",
				name: "WHITE LARGE SQUARE",
				added_in: "5.1",
				shortName: "white_large_square",
				shortNames: ["white_large_square"],
				category: 7
			},
			{
				emoji: "⭕",
				name: "HEAVY LARGE CIRCLE",
				added_in: "5.2",
				shortName: "o",
				shortNames: ["o"],
				category: 7
			},
			{
				emoji: "〰️",
				name: "WAVY DASH",
				added_in: "1.1",
				shortName: "wavy_dash",
				shortNames: ["wavy_dash"],
				category: 7
			},
			{
				emoji: "〽️",
				name: "PART ALTERNATION MARK",
				added_in: "3.2",
				shortName: "part_alternation_mark",
				shortNames: ["part_alternation_mark"],
				category: 7
			},
			{
				emoji: "㊗️",
				name: "CIRCLED IDEOGRAPH CONGRATULATION",
				added_in: "1.1",
				shortName: "congratulations",
				shortNames: ["congratulations"],
				category: 7
			},
			{
				emoji: "㊙️",
				name: "CIRCLED IDEOGRAPH SECRET",
				added_in: "1.1",
				shortName: "secret",
				shortNames: ["secret"],
				category: 7
			}
		],
		[
			{
				emoji: "🇩🇪",
				name: "Germany Flag",
				added_in: "6.0",
				shortName: "de",
				shortNames: ["de", "flag-de"],
				category: 8
			},
			{
				emoji: "🇮🇲",
				name: "Isle of Man Flag",
				added_in: "6.0",
				shortName: "flag-im",
				shortNames: ["flag-im"],
				category: 8
			},
			{
				emoji: "🇰🇾",
				name: "Cayman Islands Flag",
				added_in: "6.0",
				shortName: "flag-ky",
				shortNames: ["flag-ky"],
				category: 8
			},
			{
				emoji: "🇴🇲",
				name: "Oman Flag",
				added_in: "6.0",
				shortName: "flag-om",
				shortNames: ["flag-om"],
				category: 8
			},
			{
				emoji: "🇷🇴",
				name: "Romania Flag",
				added_in: "6.0",
				shortName: "flag-ro",
				shortNames: ["flag-ro"],
				category: 8
			},
			{
				emoji: "🇦🇨",
				name: "Ascension Island Flag",
				added_in: "6.0",
				shortName: "flag-ac",
				shortNames: ["flag-ac"],
				category: 8
			},
			{
				emoji: "🇦🇩",
				name: "Andorra Flag",
				added_in: "6.0",
				shortName: "flag-ad",
				shortNames: ["flag-ad"],
				category: 8
			},
			{
				emoji: "🇦🇪",
				name: "United Arab Emirates Flag",
				added_in: "6.0",
				shortName: "flag-ae",
				shortNames: ["flag-ae"],
				category: 8
			},
			{
				emoji: "🇦🇫",
				name: "Afghanistan Flag",
				added_in: "6.0",
				shortName: "flag-af",
				shortNames: ["flag-af"],
				category: 8
			},
			{
				emoji: "🇦🇬",
				name: "Antigua & Barbuda Flag",
				added_in: "6.0",
				shortName: "flag-ag",
				shortNames: ["flag-ag"],
				category: 8
			},
			{
				emoji: "🇦🇮",
				name: "Anguilla Flag",
				added_in: "6.0",
				shortName: "flag-ai",
				shortNames: ["flag-ai"],
				category: 8
			},
			{
				emoji: "🇦🇱",
				name: "Albania Flag",
				added_in: "6.0",
				shortName: "flag-al",
				shortNames: ["flag-al"],
				category: 8
			},
			{
				emoji: "🇦🇲",
				name: "Armenia Flag",
				added_in: "6.0",
				shortName: "flag-am",
				shortNames: ["flag-am"],
				category: 8
			},
			{
				emoji: "🇦🇴",
				name: "Angola Flag",
				added_in: "6.0",
				shortName: "flag-ao",
				shortNames: ["flag-ao"],
				category: 8
			},
			{
				emoji: "🇦🇶",
				name: "Antarctica Flag",
				added_in: "6.0",
				shortName: "flag-aq",
				shortNames: ["flag-aq"],
				category: 8
			},
			{
				emoji: "🇦🇷",
				name: "Argentina Flag",
				added_in: "6.0",
				shortName: "flag-ar",
				shortNames: ["flag-ar"],
				category: 8
			},
			{
				emoji: "🇦🇸",
				name: "American Samoa Flag",
				added_in: "6.0",
				shortName: "flag-as",
				shortNames: ["flag-as"],
				category: 8
			},
			{
				emoji: "🇦🇹",
				name: "Austria Flag",
				added_in: "6.0",
				shortName: "flag-at",
				shortNames: ["flag-at"],
				category: 8
			},
			{
				emoji: "🇦🇺",
				name: "Australia Flag",
				added_in: "6.0",
				shortName: "flag-au",
				shortNames: ["flag-au"],
				category: 8
			},
			{
				emoji: "🇦🇼",
				name: "Aruba Flag",
				added_in: "6.0",
				shortName: "flag-aw",
				shortNames: ["flag-aw"],
				category: 8
			},
			{
				emoji: "🇦🇽",
				name: "Åland Islands Flag",
				added_in: "6.0",
				shortName: "flag-ax",
				shortNames: ["flag-ax"],
				category: 8
			},
			{
				emoji: "🇦🇿",
				name: "Azerbaijan Flag",
				added_in: "6.0",
				shortName: "flag-az",
				shortNames: ["flag-az"],
				category: 8
			},
			{
				emoji: "🇧🇧",
				name: "Barbados Flag",
				added_in: "6.0",
				shortName: "flag-bb",
				shortNames: ["flag-bb"],
				category: 8
			},
			{
				emoji: "🇧🇩",
				name: "Bangladesh Flag",
				added_in: "6.0",
				shortName: "flag-bd",
				shortNames: ["flag-bd"],
				category: 8
			},
			{
				emoji: "🇧🇪",
				name: "Belgium Flag",
				added_in: "6.0",
				shortName: "flag-be",
				shortNames: ["flag-be"],
				category: 8
			},
			{
				emoji: "🇧🇫",
				name: "Burkina Faso Flag",
				added_in: "6.0",
				shortName: "flag-bf",
				shortNames: ["flag-bf"],
				category: 8
			},
			{
				emoji: "🇧🇬",
				name: "Bulgaria Flag",
				added_in: "6.0",
				shortName: "flag-bg",
				shortNames: ["flag-bg"],
				category: 8
			},
			{
				emoji: "🇧🇭",
				name: "Bahrain Flag",
				added_in: "6.0",
				shortName: "flag-bh",
				shortNames: ["flag-bh"],
				category: 8
			},
			{
				emoji: "🇧🇮",
				name: "Burundi Flag",
				added_in: "6.0",
				shortName: "flag-bi",
				shortNames: ["flag-bi"],
				category: 8
			},
			{
				emoji: "🇧🇯",
				name: "Benin Flag",
				added_in: "6.0",
				shortName: "flag-bj",
				shortNames: ["flag-bj"],
				category: 8
			},
			{
				emoji: "🇧🇲",
				name: "Bermuda Flag",
				added_in: "6.0",
				shortName: "flag-bm",
				shortNames: ["flag-bm"],
				category: 8
			},
			{
				emoji: "🇧🇴",
				name: "Bolivia Flag",
				added_in: "6.0",
				shortName: "flag-bo",
				shortNames: ["flag-bo"],
				category: 8
			},
			{
				emoji: "🇧🇷",
				name: "Brazil Flag",
				added_in: "6.0",
				shortName: "flag-br",
				shortNames: ["flag-br"],
				category: 8
			},
			{
				emoji: "🇧🇸",
				name: "Bahamas Flag",
				added_in: "6.0",
				shortName: "flag-bs",
				shortNames: ["flag-bs"],
				category: 8
			},
			{
				emoji: "🇧🇹",
				name: "Bhutan Flag",
				added_in: "6.0",
				shortName: "flag-bt",
				shortNames: ["flag-bt"],
				category: 8
			},
			{
				emoji: "🇧🇻",
				name: "Bouvet Island Flag",
				added_in: "6.0",
				shortName: "flag-bv",
				shortNames: ["flag-bv"],
				category: 8
			},
			{
				emoji: "🇧🇼",
				name: "Botswana Flag",
				added_in: "6.0",
				shortName: "flag-bw",
				shortNames: ["flag-bw"],
				category: 8
			},
			{
				emoji: "🇧🇾",
				name: "Belarus Flag",
				added_in: "6.0",
				shortName: "flag-by",
				shortNames: ["flag-by"],
				category: 8
			},
			{
				emoji: "🇧🇿",
				name: "Belize Flag",
				added_in: "6.0",
				shortName: "flag-bz",
				shortNames: ["flag-bz"],
				category: 8
			},
			{
				emoji: "🇨🇦",
				name: "Canada Flag",
				added_in: "6.0",
				shortName: "flag-ca",
				shortNames: ["flag-ca"],
				category: 8
			},
			{
				emoji: "🇨🇨",
				name: "Cocos (Keeling) Islands Flag",
				added_in: "6.0",
				shortName: "flag-cc",
				shortNames: ["flag-cc"],
				category: 8
			},
			{
				emoji: "🇨🇩",
				name: "Congo - Kinshasa Flag",
				added_in: "6.0",
				shortName: "flag-cd",
				shortNames: ["flag-cd"],
				category: 8
			},
			{
				emoji: "🇨🇫",
				name: "Central African Republic Flag",
				added_in: "6.0",
				shortName: "flag-cf",
				shortNames: ["flag-cf"],
				category: 8
			},
			{
				emoji: "🇨🇬",
				name: "Congo - Brazzaville Flag",
				added_in: "6.0",
				shortName: "flag-cg",
				shortNames: ["flag-cg"],
				category: 8
			},
			{
				emoji: "🇨🇭",
				name: "Switzerland Flag",
				added_in: "6.0",
				shortName: "flag-ch",
				shortNames: ["flag-ch"],
				category: 8
			},
			{
				emoji: "🇨🇮",
				name: "Côte d’Ivoire Flag",
				added_in: "6.0",
				shortName: "flag-ci",
				shortNames: ["flag-ci"],
				category: 8
			},
			{
				emoji: "🇨🇰",
				name: "Cook Islands Flag",
				added_in: "6.0",
				shortName: "flag-ck",
				shortNames: ["flag-ck"],
				category: 8
			},
			{
				emoji: "🇨🇱",
				name: "Chile Flag",
				added_in: "6.0",
				shortName: "flag-cl",
				shortNames: ["flag-cl"],
				category: 8
			},
			{
				emoji: "🇨🇲",
				name: "Cameroon Flag",
				added_in: "6.0",
				shortName: "flag-cm",
				shortNames: ["flag-cm"],
				category: 8
			},
			{
				emoji: "🇨🇳",
				name: "China Flag",
				added_in: "6.0",
				shortName: "cn",
				shortNames: ["cn", "flag-cn"],
				category: 8
			},
			{
				emoji: "🇨🇴",
				name: "Colombia Flag",
				added_in: "6.0",
				shortName: "flag-co",
				shortNames: ["flag-co"],
				category: 8
			},
			{
				emoji: "🇨🇷",
				name: "Costa Rica Flag",
				added_in: "6.0",
				shortName: "flag-cr",
				shortNames: ["flag-cr"],
				category: 8
			},
			{
				emoji: "🇨🇺",
				name: "Cuba Flag",
				added_in: "6.0",
				shortName: "flag-cu",
				shortNames: ["flag-cu"],
				category: 8
			},
			{
				emoji: "🇨🇻",
				name: "Cape Verde Flag",
				added_in: "6.0",
				shortName: "flag-cv",
				shortNames: ["flag-cv"],
				category: 8
			},
			{
				emoji: "🇨🇼",
				name: "Curaçao Flag",
				added_in: "6.0",
				shortName: "flag-cw",
				shortNames: ["flag-cw"],
				category: 8
			},
			{
				emoji: "🇨🇽",
				name: "Christmas Island Flag",
				added_in: "6.0",
				shortName: "flag-cx",
				shortNames: ["flag-cx"],
				category: 8
			},
			{
				emoji: "🇨🇾",
				name: "Cyprus Flag",
				added_in: "6.0",
				shortName: "flag-cy",
				shortNames: ["flag-cy"],
				category: 8
			},
			{
				emoji: "🇨🇿",
				name: "Czechia Flag",
				added_in: "6.0",
				shortName: "flag-cz",
				shortNames: ["flag-cz"],
				category: 8
			},
			{
				emoji: "🇩🇯",
				name: "Djibouti Flag",
				added_in: "6.0",
				shortName: "flag-dj",
				shortNames: ["flag-dj"],
				category: 8
			},
			{
				emoji: "🇩🇰",
				name: "Denmark Flag",
				added_in: "6.0",
				shortName: "flag-dk",
				shortNames: ["flag-dk"],
				category: 8
			},
			{
				emoji: "🇩🇲",
				name: "Dominica Flag",
				added_in: "6.0",
				shortName: "flag-dm",
				shortNames: ["flag-dm"],
				category: 8
			},
			{
				emoji: "🇩🇴",
				name: "Dominican Republic Flag",
				added_in: "6.0",
				shortName: "flag-do",
				shortNames: ["flag-do"],
				category: 8
			},
			{
				emoji: "🇩🇿",
				name: "Algeria Flag",
				added_in: "6.0",
				shortName: "flag-dz",
				shortNames: ["flag-dz"],
				category: 8
			},
			{
				emoji: "🇪🇨",
				name: "Ecuador Flag",
				added_in: "6.0",
				shortName: "flag-ec",
				shortNames: ["flag-ec"],
				category: 8
			},
			{
				emoji: "🇪🇪",
				name: "Estonia Flag",
				added_in: "6.0",
				shortName: "flag-ee",
				shortNames: ["flag-ee"],
				category: 8
			},
			{
				emoji: "🇪🇬",
				name: "Egypt Flag",
				added_in: "6.0",
				shortName: "flag-eg",
				shortNames: ["flag-eg"],
				category: 8
			},
			{
				emoji: "🇪🇷",
				name: "Eritrea Flag",
				added_in: "6.0",
				shortName: "flag-er",
				shortNames: ["flag-er"],
				category: 8
			},
			{
				emoji: "🇪🇸",
				name: "Spain Flag",
				added_in: "6.0",
				shortName: "es",
				shortNames: ["es", "flag-es"],
				category: 8
			},
			{
				emoji: "🇪🇹",
				name: "Ethiopia Flag",
				added_in: "6.0",
				shortName: "flag-et",
				shortNames: ["flag-et"],
				category: 8
			},
			{
				emoji: "🇪🇺",
				name: "European Union Flag",
				added_in: "6.0",
				shortName: "flag-eu",
				shortNames: ["flag-eu"],
				category: 8
			},
			{
				emoji: "🇫🇮",
				name: "Finland Flag",
				added_in: "6.0",
				shortName: "flag-fi",
				shortNames: ["flag-fi"],
				category: 8
			},
			{
				emoji: "🇫🇯",
				name: "Fiji Flag",
				added_in: "6.0",
				shortName: "flag-fj",
				shortNames: ["flag-fj"],
				category: 8
			},
			{
				emoji: "🇫🇲",
				name: "Micronesia Flag",
				added_in: "6.0",
				shortName: "flag-fm",
				shortNames: ["flag-fm"],
				category: 8
			},
			{
				emoji: "🇫🇴",
				name: "Faroe Islands Flag",
				added_in: "6.0",
				shortName: "flag-fo",
				shortNames: ["flag-fo"],
				category: 8
			},
			{
				emoji: "🇫🇷",
				name: "France Flag",
				added_in: "6.0",
				shortName: "fr",
				shortNames: ["fr", "flag-fr"],
				category: 8
			},
			{
				emoji: "🇬🇦",
				name: "Gabon Flag",
				added_in: "6.0",
				shortName: "flag-ga",
				shortNames: ["flag-ga"],
				category: 8
			},
			{
				emoji: "🇬🇧",
				name: "United Kingdom Flag",
				added_in: "6.0",
				shortName: "gb",
				shortNames: [
					"gb",
					"uk",
					"flag-gb"
				],
				category: 8
			},
			{
				emoji: "🇬🇩",
				name: "Grenada Flag",
				added_in: "6.0",
				shortName: "flag-gd",
				shortNames: ["flag-gd"],
				category: 8
			},
			{
				emoji: "🇬🇪",
				name: "Georgia Flag",
				added_in: "6.0",
				shortName: "flag-ge",
				shortNames: ["flag-ge"],
				category: 8
			},
			{
				emoji: "🇬🇬",
				name: "Guernsey Flag",
				added_in: "6.0",
				shortName: "flag-gg",
				shortNames: ["flag-gg"],
				category: 8
			},
			{
				emoji: "🇬🇭",
				name: "Ghana Flag",
				added_in: "6.0",
				shortName: "flag-gh",
				shortNames: ["flag-gh"],
				category: 8
			},
			{
				emoji: "🇬🇮",
				name: "Gibraltar Flag",
				added_in: "6.0",
				shortName: "flag-gi",
				shortNames: ["flag-gi"],
				category: 8
			},
			{
				emoji: "🇬🇱",
				name: "Greenland Flag",
				added_in: "6.0",
				shortName: "flag-gl",
				shortNames: ["flag-gl"],
				category: 8
			},
			{
				emoji: "🇬🇲",
				name: "Gambia Flag",
				added_in: "6.0",
				shortName: "flag-gm",
				shortNames: ["flag-gm"],
				category: 8
			},
			{
				emoji: "🇬🇳",
				name: "Guinea Flag",
				added_in: "6.0",
				shortName: "flag-gn",
				shortNames: ["flag-gn"],
				category: 8
			},
			{
				emoji: "🇬🇶",
				name: "Equatorial Guinea Flag",
				added_in: "6.0",
				shortName: "flag-gq",
				shortNames: ["flag-gq"],
				category: 8
			},
			{
				emoji: "🇬🇷",
				name: "Greece Flag",
				added_in: "6.0",
				shortName: "flag-gr",
				shortNames: ["flag-gr"],
				category: 8
			},
			{
				emoji: "🇬🇹",
				name: "Guatemala Flag",
				added_in: "6.0",
				shortName: "flag-gt",
				shortNames: ["flag-gt"],
				category: 8
			},
			{
				emoji: "🇬🇺",
				name: "Guam Flag",
				added_in: "6.0",
				shortName: "flag-gu",
				shortNames: ["flag-gu"],
				category: 8
			},
			{
				emoji: "🇬🇼",
				name: "Guinea-Bissau Flag",
				added_in: "6.0",
				shortName: "flag-gw",
				shortNames: ["flag-gw"],
				category: 8
			},
			{
				emoji: "🇬🇾",
				name: "Guyana Flag",
				added_in: "6.0",
				shortName: "flag-gy",
				shortNames: ["flag-gy"],
				category: 8
			},
			{
				emoji: "🇭🇰",
				name: "Hong Kong SAR China Flag",
				added_in: "6.0",
				shortName: "flag-hk",
				shortNames: ["flag-hk"],
				category: 8
			},
			{
				emoji: "🇭🇲",
				name: "Heard & McDonald Islands Flag",
				added_in: "6.0",
				shortName: "flag-hm",
				shortNames: ["flag-hm"],
				category: 8
			},
			{
				emoji: "🇭🇳",
				name: "Honduras Flag",
				added_in: "6.0",
				shortName: "flag-hn",
				shortNames: ["flag-hn"],
				category: 8
			},
			{
				emoji: "🇭🇷",
				name: "Croatia Flag",
				added_in: "6.0",
				shortName: "flag-hr",
				shortNames: ["flag-hr"],
				category: 8
			},
			{
				emoji: "🇭🇹",
				name: "Haiti Flag",
				added_in: "6.0",
				shortName: "flag-ht",
				shortNames: ["flag-ht"],
				category: 8
			},
			{
				emoji: "🇭🇺",
				name: "Hungary Flag",
				added_in: "6.0",
				shortName: "flag-hu",
				shortNames: ["flag-hu"],
				category: 8
			},
			{
				emoji: "🇮🇨",
				name: "Canary Islands Flag",
				added_in: "6.0",
				shortName: "flag-ic",
				shortNames: ["flag-ic"],
				category: 8
			},
			{
				emoji: "🇮🇩",
				name: "Indonesia Flag",
				added_in: "6.0",
				shortName: "flag-id",
				shortNames: ["flag-id"],
				category: 8
			},
			{
				emoji: "🇮🇪",
				name: "Ireland Flag",
				added_in: "6.0",
				shortName: "flag-ie",
				shortNames: ["flag-ie"],
				category: 8
			},
			{
				emoji: "🇮🇱",
				name: "Israel Flag",
				added_in: "6.0",
				shortName: "flag-il",
				shortNames: ["flag-il"],
				category: 8
			},
			{
				emoji: "🇮🇳",
				name: "India Flag",
				added_in: "6.0",
				shortName: "flag-in",
				shortNames: ["flag-in"],
				category: 8
			},
			{
				emoji: "🇮🇴",
				name: "British Indian Ocean Territory Flag",
				added_in: "6.0",
				shortName: "flag-io",
				shortNames: ["flag-io"],
				category: 8
			},
			{
				emoji: "🇮🇶",
				name: "Iraq Flag",
				added_in: "6.0",
				shortName: "flag-iq",
				shortNames: ["flag-iq"],
				category: 8
			},
			{
				emoji: "🇮🇷",
				name: "Iran Flag",
				added_in: "6.0",
				shortName: "flag-ir",
				shortNames: ["flag-ir"],
				category: 8
			},
			{
				emoji: "🇮🇸",
				name: "Iceland Flag",
				added_in: "6.0",
				shortName: "flag-is",
				shortNames: ["flag-is"],
				category: 8
			},
			{
				emoji: "🇮🇹",
				name: "Italy Flag",
				added_in: "6.0",
				shortName: "it",
				shortNames: ["it", "flag-it"],
				category: 8
			},
			{
				emoji: "🇯🇪",
				name: "Jersey Flag",
				added_in: "6.0",
				shortName: "flag-je",
				shortNames: ["flag-je"],
				category: 8
			},
			{
				emoji: "🇯🇲",
				name: "Jamaica Flag",
				added_in: "6.0",
				shortName: "flag-jm",
				shortNames: ["flag-jm"],
				category: 8
			},
			{
				emoji: "🇯🇴",
				name: "Jordan Flag",
				added_in: "6.0",
				shortName: "flag-jo",
				shortNames: ["flag-jo"],
				category: 8
			},
			{
				emoji: "🇯🇵",
				name: "Japan Flag",
				added_in: "6.0",
				shortName: "jp",
				shortNames: ["jp", "flag-jp"],
				category: 8
			},
			{
				emoji: "🇰🇪",
				name: "Kenya Flag",
				added_in: "6.0",
				shortName: "flag-ke",
				shortNames: ["flag-ke"],
				category: 8
			},
			{
				emoji: "🇰🇬",
				name: "Kyrgyzstan Flag",
				added_in: "6.0",
				shortName: "flag-kg",
				shortNames: ["flag-kg"],
				category: 8
			},
			{
				emoji: "🇰🇭",
				name: "Cambodia Flag",
				added_in: "6.0",
				shortName: "flag-kh",
				shortNames: ["flag-kh"],
				category: 8
			},
			{
				emoji: "🇰🇮",
				name: "Kiribati Flag",
				added_in: "6.0",
				shortName: "flag-ki",
				shortNames: ["flag-ki"],
				category: 8
			},
			{
				emoji: "🇰🇲",
				name: "Comoros Flag",
				added_in: "6.0",
				shortName: "flag-km",
				shortNames: ["flag-km"],
				category: 8
			},
			{
				emoji: "🇰🇳",
				name: "St. Kitts & Nevis Flag",
				added_in: "6.0",
				shortName: "flag-kn",
				shortNames: ["flag-kn"],
				category: 8
			},
			{
				emoji: "🇰🇵",
				name: "North Korea Flag",
				added_in: "6.0",
				shortName: "flag-kp",
				shortNames: ["flag-kp"],
				category: 8
			},
			{
				emoji: "🇰🇷",
				name: "South Korea Flag",
				added_in: "6.0",
				shortName: "kr",
				shortNames: ["kr", "flag-kr"],
				category: 8
			},
			{
				emoji: "🇰🇼",
				name: "Kuwait Flag",
				added_in: "6.0",
				shortName: "flag-kw",
				shortNames: ["flag-kw"],
				category: 8
			},
			{
				emoji: "🇰🇿",
				name: "Kazakhstan Flag",
				added_in: "6.0",
				shortName: "flag-kz",
				shortNames: ["flag-kz"],
				category: 8
			},
			{
				emoji: "🇱🇦",
				name: "Laos Flag",
				added_in: "6.0",
				shortName: "flag-la",
				shortNames: ["flag-la"],
				category: 8
			},
			{
				emoji: "🇱🇧",
				name: "Lebanon Flag",
				added_in: "6.0",
				shortName: "flag-lb",
				shortNames: ["flag-lb"],
				category: 8
			},
			{
				emoji: "🇱🇨",
				name: "St. Lucia Flag",
				added_in: "6.0",
				shortName: "flag-lc",
				shortNames: ["flag-lc"],
				category: 8
			},
			{
				emoji: "🇱🇮",
				name: "Liechtenstein Flag",
				added_in: "6.0",
				shortName: "flag-li",
				shortNames: ["flag-li"],
				category: 8
			},
			{
				emoji: "🇱🇰",
				name: "Sri Lanka Flag",
				added_in: "6.0",
				shortName: "flag-lk",
				shortNames: ["flag-lk"],
				category: 8
			},
			{
				emoji: "🇱🇷",
				name: "Liberia Flag",
				added_in: "6.0",
				shortName: "flag-lr",
				shortNames: ["flag-lr"],
				category: 8
			},
			{
				emoji: "🇱🇸",
				name: "Lesotho Flag",
				added_in: "6.0",
				shortName: "flag-ls",
				shortNames: ["flag-ls"],
				category: 8
			},
			{
				emoji: "🇱🇹",
				name: "Lithuania Flag",
				added_in: "6.0",
				shortName: "flag-lt",
				shortNames: ["flag-lt"],
				category: 8
			},
			{
				emoji: "🇱🇺",
				name: "Luxembourg Flag",
				added_in: "6.0",
				shortName: "flag-lu",
				shortNames: ["flag-lu"],
				category: 8
			},
			{
				emoji: "🇱🇻",
				name: "Latvia Flag",
				added_in: "6.0",
				shortName: "flag-lv",
				shortNames: ["flag-lv"],
				category: 8
			},
			{
				emoji: "🇱🇾",
				name: "Libya Flag",
				added_in: "6.0",
				shortName: "flag-ly",
				shortNames: ["flag-ly"],
				category: 8
			},
			{
				emoji: "🇲🇦",
				name: "Morocco Flag",
				added_in: "6.0",
				shortName: "flag-ma",
				shortNames: ["flag-ma"],
				category: 8
			},
			{
				emoji: "🇲🇨",
				name: "Monaco Flag",
				added_in: "6.0",
				shortName: "flag-mc",
				shortNames: ["flag-mc"],
				category: 8
			},
			{
				emoji: "🇲🇩",
				name: "Moldova Flag",
				added_in: "6.0",
				shortName: "flag-md",
				shortNames: ["flag-md"],
				category: 8
			},
			{
				emoji: "🇲🇪",
				name: "Montenegro Flag",
				added_in: "6.0",
				shortName: "flag-me",
				shortNames: ["flag-me"],
				category: 8
			},
			{
				emoji: "🇲🇬",
				name: "Madagascar Flag",
				added_in: "6.0",
				shortName: "flag-mg",
				shortNames: ["flag-mg"],
				category: 8
			},
			{
				emoji: "🇲🇭",
				name: "Marshall Islands Flag",
				added_in: "6.0",
				shortName: "flag-mh",
				shortNames: ["flag-mh"],
				category: 8
			},
			{
				emoji: "🇲🇰",
				name: "Macedonia Flag",
				added_in: "6.0",
				shortName: "flag-mk",
				shortNames: ["flag-mk"],
				category: 8
			},
			{
				emoji: "🇲🇱",
				name: "Mali Flag",
				added_in: "6.0",
				shortName: "flag-ml",
				shortNames: ["flag-ml"],
				category: 8
			},
			{
				emoji: "🇲🇲",
				name: "Myanmar (Burma) Flag",
				added_in: "6.0",
				shortName: "flag-mm",
				shortNames: ["flag-mm"],
				category: 8
			},
			{
				emoji: "🇲🇳",
				name: "Mongolia Flag",
				added_in: "6.0",
				shortName: "flag-mn",
				shortNames: ["flag-mn"],
				category: 8
			},
			{
				emoji: "🇲🇴",
				name: "Macau SAR China Flag",
				added_in: "6.0",
				shortName: "flag-mo",
				shortNames: ["flag-mo"],
				category: 8
			},
			{
				emoji: "🇲🇵",
				name: "Northern Mariana Islands Flag",
				added_in: "6.0",
				shortName: "flag-mp",
				shortNames: ["flag-mp"],
				category: 8
			},
			{
				emoji: "🇲🇷",
				name: "Mauritania Flag",
				added_in: "6.0",
				shortName: "flag-mr",
				shortNames: ["flag-mr"],
				category: 8
			},
			{
				emoji: "🇲🇸",
				name: "Montserrat Flag",
				added_in: "6.0",
				shortName: "flag-ms",
				shortNames: ["flag-ms"],
				category: 8
			},
			{
				emoji: "🇲🇹",
				name: "Malta Flag",
				added_in: "6.0",
				shortName: "flag-mt",
				shortNames: ["flag-mt"],
				category: 8
			},
			{
				emoji: "🇲🇺",
				name: "Mauritius Flag",
				added_in: "6.0",
				shortName: "flag-mu",
				shortNames: ["flag-mu"],
				category: 8
			},
			{
				emoji: "🇲🇻",
				name: "Maldives Flag",
				added_in: "6.0",
				shortName: "flag-mv",
				shortNames: ["flag-mv"],
				category: 8
			},
			{
				emoji: "🇲🇼",
				name: "Malawi Flag",
				added_in: "6.0",
				shortName: "flag-mw",
				shortNames: ["flag-mw"],
				category: 8
			},
			{
				emoji: "🇲🇽",
				name: "Mexico Flag",
				added_in: "6.0",
				shortName: "flag-mx",
				shortNames: ["flag-mx"],
				category: 8
			},
			{
				emoji: "🇲🇾",
				name: "Malaysia Flag",
				added_in: "6.0",
				shortName: "flag-my",
				shortNames: ["flag-my"],
				category: 8
			},
			{
				emoji: "🇲🇿",
				name: "Mozambique Flag",
				added_in: "6.0",
				shortName: "flag-mz",
				shortNames: ["flag-mz"],
				category: 8
			},
			{
				emoji: "🇳🇦",
				name: "Namibia Flag",
				added_in: "6.0",
				shortName: "flag-na",
				shortNames: ["flag-na"],
				category: 8
			},
			{
				emoji: "🇳🇪",
				name: "Niger Flag",
				added_in: "6.0",
				shortName: "flag-ne",
				shortNames: ["flag-ne"],
				category: 8
			},
			{
				emoji: "🇳🇫",
				name: "Norfolk Island Flag",
				added_in: "6.0",
				shortName: "flag-nf",
				shortNames: ["flag-nf"],
				category: 8
			},
			{
				emoji: "🇳🇬",
				name: "Nigeria Flag",
				added_in: "6.0",
				shortName: "flag-ng",
				shortNames: ["flag-ng"],
				category: 8
			},
			{
				emoji: "🇳🇮",
				name: "Nicaragua Flag",
				added_in: "6.0",
				shortName: "flag-ni",
				shortNames: ["flag-ni"],
				category: 8
			},
			{
				emoji: "🇳🇱",
				name: "Netherlands Flag",
				added_in: "6.0",
				shortName: "flag-nl",
				shortNames: ["flag-nl"],
				category: 8
			},
			{
				emoji: "🇳🇴",
				name: "Norway Flag",
				added_in: "6.0",
				shortName: "flag-no",
				shortNames: ["flag-no"],
				category: 8
			},
			{
				emoji: "🇳🇵",
				name: "Nepal Flag",
				added_in: "6.0",
				shortName: "flag-np",
				shortNames: ["flag-np"],
				category: 8
			},
			{
				emoji: "🇳🇷",
				name: "Nauru Flag",
				added_in: "6.0",
				shortName: "flag-nr",
				shortNames: ["flag-nr"],
				category: 8
			},
			{
				emoji: "🇳🇺",
				name: "Niue Flag",
				added_in: "6.0",
				shortName: "flag-nu",
				shortNames: ["flag-nu"],
				category: 8
			},
			{
				emoji: "🇳🇿",
				name: "New Zealand Flag",
				added_in: "6.0",
				shortName: "flag-nz",
				shortNames: ["flag-nz"],
				category: 8
			},
			{
				emoji: "🇵🇦",
				name: "Panama Flag",
				added_in: "6.0",
				shortName: "flag-pa",
				shortNames: ["flag-pa"],
				category: 8
			},
			{
				emoji: "🇵🇪",
				name: "Peru Flag",
				added_in: "6.0",
				shortName: "flag-pe",
				shortNames: ["flag-pe"],
				category: 8
			},
			{
				emoji: "🇵🇫",
				name: "French Polynesia Flag",
				added_in: "6.0",
				shortName: "flag-pf",
				shortNames: ["flag-pf"],
				category: 8
			},
			{
				emoji: "🇵🇬",
				name: "Papua New Guinea Flag",
				added_in: "6.0",
				shortName: "flag-pg",
				shortNames: ["flag-pg"],
				category: 8
			},
			{
				emoji: "🇵🇭",
				name: "Philippines Flag",
				added_in: "6.0",
				shortName: "flag-ph",
				shortNames: ["flag-ph"],
				category: 8
			},
			{
				emoji: "🇵🇰",
				name: "Pakistan Flag",
				added_in: "6.0",
				shortName: "flag-pk",
				shortNames: ["flag-pk"],
				category: 8
			},
			{
				emoji: "🇵🇱",
				name: "Poland Flag",
				added_in: "6.0",
				shortName: "flag-pl",
				shortNames: ["flag-pl"],
				category: 8
			},
			{
				emoji: "🇵🇳",
				name: "Pitcairn Islands Flag",
				added_in: "6.0",
				shortName: "flag-pn",
				shortNames: ["flag-pn"],
				category: 8
			},
			{
				emoji: "🇵🇷",
				name: "Puerto Rico Flag",
				added_in: "6.0",
				shortName: "flag-pr",
				shortNames: ["flag-pr"],
				category: 8
			},
			{
				emoji: "🇵🇸",
				name: "Palestinian Territories Flag",
				added_in: "6.0",
				shortName: "flag-ps",
				shortNames: ["flag-ps"],
				category: 8
			},
			{
				emoji: "🇵🇹",
				name: "Portugal Flag",
				added_in: "6.0",
				shortName: "flag-pt",
				shortNames: ["flag-pt"],
				category: 8
			},
			{
				emoji: "🇵🇼",
				name: "Palau Flag",
				added_in: "6.0",
				shortName: "flag-pw",
				shortNames: ["flag-pw"],
				category: 8
			},
			{
				emoji: "🇵🇾",
				name: "Paraguay Flag",
				added_in: "6.0",
				shortName: "flag-py",
				shortNames: ["flag-py"],
				category: 8
			},
			{
				emoji: "🇶🇦",
				name: "Qatar Flag",
				added_in: "6.0",
				shortName: "flag-qa",
				shortNames: ["flag-qa"],
				category: 8
			},
			{
				emoji: "🇷🇸",
				name: "Serbia Flag",
				added_in: "6.0",
				shortName: "flag-rs",
				shortNames: ["flag-rs"],
				category: 8
			},
			{
				emoji: "🇷🇺",
				name: "Russia Flag",
				added_in: "6.0",
				shortName: "ru",
				shortNames: ["ru", "flag-ru"],
				category: 8
			},
			{
				emoji: "🇷🇼",
				name: "Rwanda Flag",
				added_in: "6.0",
				shortName: "flag-rw",
				shortNames: ["flag-rw"],
				category: 8
			},
			{
				emoji: "🇸🇦",
				name: "Saudi Arabia Flag",
				added_in: "6.0",
				shortName: "flag-sa",
				shortNames: ["flag-sa"],
				category: 8
			},
			{
				emoji: "🇸🇧",
				name: "Solomon Islands Flag",
				added_in: "6.0",
				shortName: "flag-sb",
				shortNames: ["flag-sb"],
				category: 8
			},
			{
				emoji: "🇸🇨",
				name: "Seychelles Flag",
				added_in: "6.0",
				shortName: "flag-sc",
				shortNames: ["flag-sc"],
				category: 8
			},
			{
				emoji: "🇸🇩",
				name: "Sudan Flag",
				added_in: "6.0",
				shortName: "flag-sd",
				shortNames: ["flag-sd"],
				category: 8
			},
			{
				emoji: "🇸🇪",
				name: "Sweden Flag",
				added_in: "6.0",
				shortName: "flag-se",
				shortNames: ["flag-se"],
				category: 8
			},
			{
				emoji: "🇸🇬",
				name: "Singapore Flag",
				added_in: "6.0",
				shortName: "flag-sg",
				shortNames: ["flag-sg"],
				category: 8
			},
			{
				emoji: "🇸🇭",
				name: "St. Helena Flag",
				added_in: "6.0",
				shortName: "flag-sh",
				shortNames: ["flag-sh"],
				category: 8
			},
			{
				emoji: "🇸🇮",
				name: "Slovenia Flag",
				added_in: "6.0",
				shortName: "flag-si",
				shortNames: ["flag-si"],
				category: 8
			},
			{
				emoji: "🇸🇯",
				name: "Svalbard & Jan Mayen Flag",
				added_in: "6.0",
				shortName: "flag-sj",
				shortNames: ["flag-sj"],
				category: 8
			},
			{
				emoji: "🇸🇰",
				name: "Slovakia Flag",
				added_in: "6.0",
				shortName: "flag-sk",
				shortNames: ["flag-sk"],
				category: 8
			},
			{
				emoji: "🇸🇱",
				name: "Sierra Leone Flag",
				added_in: "6.0",
				shortName: "flag-sl",
				shortNames: ["flag-sl"],
				category: 8
			},
			{
				emoji: "🇸🇲",
				name: "San Marino Flag",
				added_in: "6.0",
				shortName: "flag-sm",
				shortNames: ["flag-sm"],
				category: 8
			},
			{
				emoji: "🇸🇳",
				name: "Senegal Flag",
				added_in: "6.0",
				shortName: "flag-sn",
				shortNames: ["flag-sn"],
				category: 8
			},
			{
				emoji: "🇸🇴",
				name: "Somalia Flag",
				added_in: "6.0",
				shortName: "flag-so",
				shortNames: ["flag-so"],
				category: 8
			},
			{
				emoji: "🇸🇷",
				name: "Suriname Flag",
				added_in: "6.0",
				shortName: "flag-sr",
				shortNames: ["flag-sr"],
				category: 8
			},
			{
				emoji: "🇸🇸",
				name: "South Sudan Flag",
				added_in: "6.0",
				shortName: "flag-ss",
				shortNames: ["flag-ss"],
				category: 8
			},
			{
				emoji: "🇸🇹",
				name: "São Tomé & Príncipe Flag",
				added_in: "6.0",
				shortName: "flag-st",
				shortNames: ["flag-st"],
				category: 8
			},
			{
				emoji: "🇸🇻",
				name: "El Salvador Flag",
				added_in: "6.0",
				shortName: "flag-sv",
				shortNames: ["flag-sv"],
				category: 8
			},
			{
				emoji: "🇸🇽",
				name: "Sint Maarten Flag",
				added_in: "6.0",
				shortName: "flag-sx",
				shortNames: ["flag-sx"],
				category: 8
			},
			{
				emoji: "🇸🇾",
				name: "Syria Flag",
				added_in: "6.0",
				shortName: "flag-sy",
				shortNames: ["flag-sy"],
				category: 8
			},
			{
				emoji: "🇸🇿",
				name: "Swaziland Flag",
				added_in: "6.0",
				shortName: "flag-sz",
				shortNames: ["flag-sz"],
				category: 8
			},
			{
				emoji: "🇹🇦",
				name: "Tristan da Cunha Flag",
				added_in: "6.0",
				shortName: "flag-ta",
				shortNames: ["flag-ta"],
				category: 8
			},
			{
				emoji: "🇹🇨",
				name: "Turks & Caicos Islands Flag",
				added_in: "6.0",
				shortName: "flag-tc",
				shortNames: ["flag-tc"],
				category: 8
			},
			{
				emoji: "🇹🇩",
				name: "Chad Flag",
				added_in: "6.0",
				shortName: "flag-td",
				shortNames: ["flag-td"],
				category: 8
			},
			{
				emoji: "🇹🇬",
				name: "Togo Flag",
				added_in: "6.0",
				shortName: "flag-tg",
				shortNames: ["flag-tg"],
				category: 8
			},
			{
				emoji: "🇹🇭",
				name: "Thailand Flag",
				added_in: "6.0",
				shortName: "flag-th",
				shortNames: ["flag-th"],
				category: 8
			},
			{
				emoji: "🇹🇯",
				name: "Tajikistan Flag",
				added_in: "6.0",
				shortName: "flag-tj",
				shortNames: ["flag-tj"],
				category: 8
			},
			{
				emoji: "🇹🇰",
				name: "Tokelau Flag",
				added_in: "6.0",
				shortName: "flag-tk",
				shortNames: ["flag-tk"],
				category: 8
			},
			{
				emoji: "🇹🇱",
				name: "Timor-Leste Flag",
				added_in: "6.0",
				shortName: "flag-tl",
				shortNames: ["flag-tl"],
				category: 8
			},
			{
				emoji: "🇹🇲",
				name: "Turkmenistan Flag",
				added_in: "6.0",
				shortName: "flag-tm",
				shortNames: ["flag-tm"],
				category: 8
			},
			{
				emoji: "🇹🇳",
				name: "Tunisia Flag",
				added_in: "6.0",
				shortName: "flag-tn",
				shortNames: ["flag-tn"],
				category: 8
			},
			{
				emoji: "🇹🇴",
				name: "Tonga Flag",
				added_in: "6.0",
				shortName: "flag-to",
				shortNames: ["flag-to"],
				category: 8
			},
			{
				emoji: "🇹🇷",
				name: "Turkey Flag",
				added_in: "6.0",
				shortName: "flag-tr",
				shortNames: ["flag-tr"],
				category: 8
			},
			{
				emoji: "🇹🇹",
				name: "Trinidad & Tobago Flag",
				added_in: "6.0",
				shortName: "flag-tt",
				shortNames: ["flag-tt"],
				category: 8
			},
			{
				emoji: "🇹🇻",
				name: "Tuvalu Flag",
				added_in: "6.0",
				shortName: "flag-tv",
				shortNames: ["flag-tv"],
				category: 8
			},
			{
				emoji: "🇹🇼",
				name: "Taiwan Flag",
				added_in: "6.0",
				shortName: "flag-tw",
				shortNames: ["flag-tw"],
				category: 8
			},
			{
				emoji: "🇹🇿",
				name: "Tanzania Flag",
				added_in: "6.0",
				shortName: "flag-tz",
				shortNames: ["flag-tz"],
				category: 8
			},
			{
				emoji: "🇺🇦",
				name: "Ukraine Flag",
				added_in: "6.0",
				shortName: "flag-ua",
				shortNames: ["flag-ua"],
				category: 8
			},
			{
				emoji: "🇺🇬",
				name: "Uganda Flag",
				added_in: "6.0",
				shortName: "flag-ug",
				shortNames: ["flag-ug"],
				category: 8
			},
			{
				emoji: "🇺🇲",
				name: "U.S. Outlying Islands Flag",
				added_in: "6.0",
				shortName: "flag-um",
				shortNames: ["flag-um"],
				category: 8
			},
			{
				emoji: "🇺🇸",
				name: "United States Flag",
				added_in: "6.0",
				shortName: "us",
				shortNames: ["us", "flag-us"],
				category: 8
			},
			{
				emoji: "🇺🇾",
				name: "Uruguay Flag",
				added_in: "6.0",
				shortName: "flag-uy",
				shortNames: ["flag-uy"],
				category: 8
			},
			{
				emoji: "🇺🇿",
				name: "Uzbekistan Flag",
				added_in: "6.0",
				shortName: "flag-uz",
				shortNames: ["flag-uz"],
				category: 8
			},
			{
				emoji: "🇻🇦",
				name: "Vatican City Flag",
				added_in: "6.0",
				shortName: "flag-va",
				shortNames: ["flag-va"],
				category: 8
			},
			{
				emoji: "🇻🇨",
				name: "St. Vincent & Grenadines Flag",
				added_in: "6.0",
				shortName: "flag-vc",
				shortNames: ["flag-vc"],
				category: 8
			},
			{
				emoji: "🇻🇪",
				name: "Venezuela Flag",
				added_in: "6.0",
				shortName: "flag-ve",
				shortNames: ["flag-ve"],
				category: 8
			},
			{
				emoji: "🇻🇬",
				name: "British Virgin Islands Flag",
				added_in: "6.0",
				shortName: "flag-vg",
				shortNames: ["flag-vg"],
				category: 8
			},
			{
				emoji: "🇻🇮",
				name: "U.S. Virgin Islands Flag",
				added_in: "6.0",
				shortName: "flag-vi",
				shortNames: ["flag-vi"],
				category: 8
			},
			{
				emoji: "🇻🇳",
				name: "Vietnam Flag",
				added_in: "6.0",
				shortName: "flag-vn",
				shortNames: ["flag-vn"],
				category: 8
			},
			{
				emoji: "🇻🇺",
				name: "Vanuatu Flag",
				added_in: "6.0",
				shortName: "flag-vu",
				shortNames: ["flag-vu"],
				category: 8
			},
			{
				emoji: "🇼🇸",
				name: "Samoa Flag",
				added_in: "6.0",
				shortName: "flag-ws",
				shortNames: ["flag-ws"],
				category: 8
			},
			{
				emoji: "🇾🇪",
				name: "Yemen Flag",
				added_in: "6.0",
				shortName: "flag-ye",
				shortNames: ["flag-ye"],
				category: 8
			},
			{
				emoji: "🇿🇦",
				name: "South Africa Flag",
				added_in: "6.0",
				shortName: "flag-za",
				shortNames: ["flag-za"],
				category: 8
			},
			{
				emoji: "🇿🇲",
				name: "Zambia Flag",
				added_in: "6.0",
				shortName: "flag-zm",
				shortNames: ["flag-zm"],
				category: 8
			},
			{
				emoji: "🇿🇼",
				name: "Zimbabwe Flag",
				added_in: "6.0",
				shortName: "flag-zw",
				shortNames: ["flag-zw"],
				category: 8
			},
			{
				emoji: "🎌",
				name: "CROSSED FLAGS",
				added_in: "6.0",
				shortName: "crossed_flags",
				shortNames: ["crossed_flags"],
				category: 8
			},
			{
				emoji: "🏁",
				name: "CHEQUERED FLAG",
				added_in: "6.0",
				shortName: "checkered_flag",
				shortNames: ["checkered_flag"],
				category: 8
			},
			{
				emoji: "🏳️‍🌈",
				name: null,
				added_in: "7.0",
				shortName: "rainbow-flag",
				shortNames: ["rainbow-flag"],
				category: 8
			},
			{
				emoji: "🚩",
				name: "TRIANGULAR FLAG ON POST",
				added_in: "6.0",
				shortName: "triangular_flag_on_post",
				shortNames: ["triangular_flag_on_post"],
				category: 8
			}
		]
	]
}, Q = Z.categories, ze = Z.emojis, Be = [].concat(...ze), Ve = "emoji.frequently";
function He(e) {
	let t = e.trim().toLowerCase();
	if (!t) return [];
	let n = [], r = [];
	return Be.forEach((e) => {
		let i = [
			e.name,
			e.shortName,
			...e.shortNames
		].map((e) => (e || "").toLowerCase());
		i.some((e) => e.startsWith(t)) ? n.push(e) : i.some((e) => e.includes(t)) && r.push(e);
	}), [...n, ...r];
}
var $ = ({ className: e, onSelect: t, ...r }) => {
	let [o, s] = g(0), [l, u] = g(""), [p, _] = g(() => {
		try {
			return JSON.parse(localStorage.getItem(Ve) || "");
		} catch {
			return {};
		}
	}), v = h(null), y = h(null), b = h(null), x = h(Q.map(() => c())), S = h([]), C = d(() => {
		let e = v.current;
		if (!e) return;
		let t = e.getBoundingClientRect();
		S.current = [], x.current.forEach((n) => {
			let r = n.current;
			if (r) {
				let n = r.getBoundingClientRect();
				S.current.push(n.top - t.top - 1 + e.scrollTop);
			}
		});
	}, []);
	f(() => {
		y.current?.focus();
	}, []), f(() => {
		C();
	});
	let w = d(() => {
		let e = v.current;
		if (!e) return;
		let { scrollTop: t } = e, n = 0;
		for (let e = 0; e < S.current.length; e += 1) {
			let r = S.current[e], i = S.current[e + 1];
			if (t >= n && (i && t < i || !i)) {
				o !== e && (C(), s(e));
				break;
			}
			n = r;
		}
	}, [o, C]), T = d((e) => {
		v.current && (v.current.scrollTop = S.current[e]);
	}, []), E = d((e) => {
		let n = { ...p };
		e && (n[e] = (n[e] || 0) + 1), localStorage.setItem(Ve, JSON.stringify(n)), _(n), t(e);
	}, [p, t]), D = d((e) => {
		u(e.target.value);
	}, []), ee = m(() => Ne(Object.keys(p).map((e) => ({
		emoji: e,
		count: p[e] || 1
	})), ["count"]).reverse().splice(0, 22).map((e) => Me(Be, ["emoji", e.emoji])).filter((e) => !!e), [p]), O = l.trim().length > 0, k = m(() => O ? He(l) : [], [O, l]);
	return /* @__PURE__ */ a("div", {
		...r,
		className: n(X.root, e),
		children: [
			/* @__PURE__ */ i("div", {
				className: X.search,
				children: /* @__PURE__ */ i(je, {
					ref: y,
					type: "search",
					icon: "search",
					placeholder: "Search emoji…",
					"aria-label": "Search emoji",
					value: l,
					onChange: D
				})
			}),
			!O && /* @__PURE__ */ i("div", {
				className: X.categories,
				children: Q.map((e) => /* @__PURE__ */ i(Fe, {
					category: e,
					active: e.key === o,
					gotoCategory: T
				}, e.key))
			}),
			/* @__PURE__ */ i("div", {
				className: X.container,
				children: /* @__PURE__ */ i("div", {
					className: X.grid,
					ref: v,
					onScroll: w,
					children: O ? k.length > 0 ? /* @__PURE__ */ i(Y, {
						sectionRef: b,
						category: {
							key: "search",
							name: "Search results"
						},
						emojis: k,
						onSelect: E
					}, "search") : /* @__PURE__ */ i(z.Paragraph, {
						as: "div",
						variant: "4",
						subdued: !0,
						className: X.empty,
						children: "No emojis found"
					}) : Q.map((e) => /* @__PURE__ */ i(Y, {
						sectionRef: x.current[e.key],
						category: e,
						emojis: e.key === 0 ? ee : ze[e.key],
						onSelect: E
					}, e.key))
				})
			})
		]
	});
};
$.displayName = "EmojiPicker";
//#endregion
//#region src/components/emojiPicker/index.ts
var Ue = /* @__PURE__ */ e({
	EMOJIS: () => Z,
	EmojiPicker: () => $
});
//#endregion
export { y as _, Te as a, H as c, z as d, P as f, j as g, k as h, je as i, be as l, N as m, $ as n, G as o, ae as p, Z as r, U as s, Ue as t, V as u };

//# sourceMappingURL=emoji-BmIbKfkC.js.map